(function() {
    'use strict';

    angular
        .module('as.search')
        .directive('searchMaster', searchMaster)
        .controller('searchMasterController', searchMasterController)
        .controller('search-filter-modal-ctrl',search_filter_modal_ctrl)
        .filter('customSearchFilter',customSearchFilter);

    function customSearchFilter() {
        return function (input,term,all_fields) {
        var regex = new RegExp(term || '', 'i');
        var obj = {};
        angular.forEach(input, function(v, i){
          if(regex.test(all_fields[v].displayName + '')){
            obj[i]=v;
          }
        });
        return obj;
    }
    }

    searchMaster.$inject = ['$http', '$compile','$state'];

    function searchMaster($http, $compile, $state) {
        var directive = {
            restrict: 'AE',
            scope: {
                searchInitialData: '=',
                startSearchNow: '=',
                reportingFun: '=',
                options: '=?',
                closeModalFun: '=',
                messageNeeded:'@'
            },
            controller: 'searchMasterController',
            link: searchMasterLink
        };

        return directive;

        function searchMasterLink(scope, element, attrs) {
            // if(chk_restrictions_return(23) && chk_restrictions_return(24) && !(scope.options && scope.options.right)){
            //     $state.go('inapp.restricted_',{action:23});
            //     return;
            // }
            scope.templatetype=attrs.templatetype;
            return $http.get("./templates/directives/search/searchMaster" + attrs.templatetype + ".html")
                .success(function(templateContent) {
                    if(platform){
                        element.html(templateContent);
                        $compile(element.contents())(scope);
                    }
                    else
                        element.replaceWith($compile(templateContent)(scope));
                }).error(function(abcd) {
                    alert($filter('asPortalLang')('Err_Refresh_Page',"Sorry for the error, Please refresh this page"));
                });
        }
    }


    searchMasterController.$inject = ['$scope', '$http', '$filter', '$rootScope', 'sidetopHttp', '$q', '$state', 'asMessages', '$stateParams', 'adminRights','fileDownload','$timeout','invitation','$location','downloadDatabase','claimProfile','adminMailClone','contentApprovalAccessMsg','membershipService','ModalService','$controller','$ocLazyLoad','analytics','cache','lostUserService','profileFilling','miniProfileService','loginSignupService','userdata'];

    function searchMasterController($scope, $http, $filter, $rootScope, sidetopHttp, $q, $state, asMessages, $stateParams, adminRights, fileDownload, $timeout,invitation,$location,downloadDatabase,claimProfile,adminMailClone,contentApprovalAccessMsg,membershipService,ModalService,$controller,$ocLazyLoad,analytics,cache,lostUserService,profileFilling,miniProfileService,loginSignupService,userdata) {
        //Variables
        window.searchscope = $scope;
        var searchInitials = {},
            network = [];
        var vSearchParams = {};
        // vSearchParams.ordering = {};
        var searchTrackers = {
            sNumber: 0,
            sTime: 0
        };
     
        $timeout(function() {
            if(!isEmpty($scope.options.userRight) && !isEmpty($scope.options.userRight.fullView) && !isEmpty($scope.options.userRight.partialView)){
                chk_restrictions($scope.options.userRight.fullView,true,true);
            }
            else if(chk_restrictions_return(23) && chk_restrictions_return(24) && !($scope.options && $scope.options.right)){
                $state.go('inapp.restricted_',{action:23});
                return;
            }

            $scope.post_right=false;
            if(isObject($scope.options)){
                if($scope.options.hasOwnProperty('right'))
                    $scope.post_right=$scope.options.right;
            }
        },1000)
        var canceller1, canceller;
        $scope.sortPriority = 1;
        $scope.membershipFields = {};
        $scope.membershipFields.name = false;
        $scope.membershipFields.membership_name = false;
        $scope.membershipFields.membership_number = false;
        $scope.membershipFields.amount = false;
        $scope.membershipFields.transaction_status = false;
        $scope.membershipFields.end_date = false;
        $scope.membershipFields.id = false; // last_payment(this id is order id of table)
        if(!isObject($scope.options)) $scope.options = {"sendMailEnabled":true,view:{}};
        $scope.options.showviewConfig=false;
        $scope.tippyOption = {arrow: true,theme: $scope.tipShow?'excited':'dark',zIndex:999,dynamicTitle:true,duration:[300,1000]};
        $scope.vResettingWaiting = true;
        $scope.pageLoad = true;
        $scope.isEmpty = true;
        $scope.resultDataAttributes = {};
        $scope.info={isEnableFieldsFetched:false,expanded:{}};
        $scope.resultProfiles = [];
        $scope.enableFields=[];
        $scope.disabledFields=[];
        $scope.availabeFields=[];
        $scope.currentTime = Math.floor(Date.now()/1000);
        $scope.showFilterWhileEmpty = false;
        $scope.formFieldsConfig = [];
        $scope.current_view_mode = 'user';
        $scope.customDate = {};
        $scope.locationUpdated = false;
        $scope.limitFilters = true;
        $scope.limitSwalShown = false;
        $scope.NewUsers=$filter("asPortalLang")("New_Users","New Users");
        $scope.shortName={'shortName' :$rootScope.app_data.data.short_name}
        var today = new Date();
        $scope.maxDate = today.getDate()+","+(today.getMonth()+1)+","+today.getFullYear();
        if(!$ocLazyLoad.isLoaded('angular-datepicker')){
            $ocLazyLoad.load({
                    "name": "angular-datepicker",
                    "files": [staticContentCdnUrl+"./libs/angular-datepicker.js", "css!"+staticContentCdnUrl+"./css/angular-datepicker.css"]
            }).then(function() {
                $scope.datePickerLoaded = true;
            });
        }
        else $scope.datePickerLoaded = true;
        $scope.searchLangData = {commShortName: $rootScope.app_data.data.short_name};
        
        if($rootScope.app_data.cid==1497)
            var checkBoxRequired = [];
        else var checkBoxRequired = ['yoj','yop','institute','department','degree','specialization','city','hometown','chapters','groups','company','designation','professional_networks','industry','skill','subinst','past_institute','past_degree','past_department'];
        var view_fields = ["name","email","company","designation","membership_id","membership_number","yoj","yop","membership_payment_mode","enrollment_number","phone_number","life_membership_number","city","hometown","department","degree","specialization","institute","professional_networks","subinst","industry","skill","activeStatus","login_status","account_created","gender","role","dob","past_institute","past_degree","past_department","identity_number"];

        var signup_roles = $rootScope.meta(1);
        var search_data = {
            fields: {
                name: {
                    displayName: $filter("asLingo")(194,'','',"Keyword"),
                    actionString: "with",
                    futherSearchType: "inputBox",
                    futherSearchParams: {
                        query: 13,
                        placeholder: $filter("asPortalLang")("Enter_Keyword","Enter Keyword")+"..",
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: false,
                    singleSearch: true,
                    alwaysShow: true,
                    // preqFunctions: [{
                    //     fName: initSelfCheckboxes
                    // }, {
                    //     fName: initInputBox
                    // }]
                },
                membership_id : {
                    displayName: $filter('asLingo')('298'),
                    actionString: "from " + $filter('asLingo')('298'),
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('298'),
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    dataPreProcessors :[memebrship_datapreprocess],
                    countsRequired: false,
                    preqFunctions: [{
                        fName: getMembershipList,
                        expectedSchema: ["data"],
                        paramsToSend: {
                            id: $rootScope.app_data.cid,
                            get_active_or_has_user_memberships:true
                        },
                        removeIfNoData: true,
                        serviceLink: './new_membership/membership_ctrl/get_list'
                    }],
                    localautocomplete : {
                        type: "autocomplete",
                        name: "membership_id",
                        multiple: false,
                        data: {
                          dataSource: {},
                          triggerFunction : membershipIdSelected,
                          allowNew: false,
                     //     responsetype: "name",
                          inputActualPlaceholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('298'),
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    emptySearching: true,
                    restrictionFunctions: [function(){
                        return !adminRights.isAllowed(11);
                    },function(){
                        return !$rootScope.featureEnabled('membership',false);
                    }]
                    // restrictionFunctions:[negativeFunc(isAdmin), function(){
                    //     return !$rootScope.featureEnabled('membership',false);
                    // }]
                },
                membership_number: { 
                    displayName: $filter('asLingo')('299'),
                    actionString: "with",
                    futherSearchType: "inputBox",
                    parentClass: "margin-bottom-10",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Enter","Enter")+" "+$filter('asLingo')('299'),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    dataPreProcessors :[memebrship_datapreprocess],
                    singleSearch: true,
                    countsRequired: false,
                    emptySearching: true,
                    restrictionFunctions: [function(){
                        return !adminRights.isAllowed(11);
                    },function(){
                        return !$rootScope.featureEnabled('membership',false);
                    }]
                },
                email: { 
                    displayName: $filter("asPortalLang")("Email","Email"),
                    actionString: "with",
                    futherSearchType: "inputBox",
                    parentClass: "margin-bottom-10",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Enter","Enter")+" "+$filter("asPortalLang")("Email","Email"),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    singleSearch: true,
                    countsRequired: false,
                    emptySearching: true,
                    extraRadioOptions: true,
                    extraRadioData:[{
                        id: 'active',
                        name: $filter("asPortalLang")("Is_Active","Is Active")
                    }, {
                        id: 'unsubscribed',
                        name: $filter("asPortalLang")("Is_Unsubscribed","Is Unsubscribed")
                    }, {
                        id: 'bounced',
                        name: $filter("asPortalLang")("Is_Bounced","Is Bounced")
                    }],
                    restrictionFunctions: [negativeFunc(isAdmin)],
                },
                account_type: {
                    displayName: $filter("asPortalLang")("Account_Type","Account Type"),
                    actionString: "",
                    futherSearchType: "radio",
                    futherSearchParams: {
                        serviceNameField: "name",
                        serviceIdField: "id",
                        radioList: [{
                            id: 'bulk',
                            name: $filter("asPortalLang")("Import_Bulk","Imported in bulk")
                        }, {
                            id: 'user_created',
                            name: $filter("asPortalLang")("Create_Individual","Created individually")
                        }]
                    },
                    singleSearch: true,
                    countsRequired: false,
                    restrictionFunctions: [negativeFunc(isAdmin)],
                },
                // num_roles: {
                //     displayName: $filter("asPortalLang")("Num_Roles","Number of Roles"),
                //     actionString: "",
                //     futherSearchType: "radio",
                //     futherSearchParams: {
                //         serviceNameField: "name",
                //         serviceIdField: "id",
                //         radioList: [{
                //             id: 'single_role',
                //             name: $filter("asPortalLang")("Single_Role","Single Role")
                //         }, {
                //             id: 'multiple_role',
                //             name: $filter("asPortalLang")("Multiple_Role","Multiple Role")
                //         }]
                //     },
                //     singleSearch: true,
                //     countsRequired: false,
                //     restrictionFunctions: [negativeFunc(isAdmin),function(){
                //         return !$rootScope.featureEnabled('multiple_role',false);
                //     }]
                // },
                membership_payment_mode: {
                    displayName: $filter("asPortalLang")("Payment_Mode","Payment Mode"),
                    actionString: "of "+$filter('asLingo')('298')+" Payment Mode",
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select","Select")+" "+$filter('asLingo')('298')+" "+$filter("asPortalLang")("Payment_Mode","Payment Mode")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 1,
                            name: $filter("asPortalLang")("Online","Online")
                        }, {
                            id: 2,
                            name: $filter("asPortalLang")("Offline","Offline")
                        }]
                    },
                    dataPreProcessors :[memebrship_datapreprocess],
                    countsRequired: false,
                    restrictionFunctions: [function(){
                        return !adminRights.isAllowed(11);
                    },function(){
                        return !$rootScope.featureEnabled('membership',false);
                    }]
                },
                auth_status: {
                    displayName: $filter("asPortalLang")("Profile_Status","Profile Status"),
                    actionString: "of profile status",
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select","Select")+" "+$filter("asPortalLang")("Profile_Status","profile status"),
                        serviceNameField: "auth_status",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 'authenticated',
                            auth_status: $filter("asPortalLang")("Authenticated","Authenticated")
                        }, {
                            id: 'unauth',
                            auth_status: $filter("asPortalLang")("Unauthenticated","Unauthenticated")
                        }, {
                            id: 'rejected',
                            auth_status: $filter("asPortalLang")("Rejected","Rejected")
                        }, {
                            id: 'blocked',
                            auth_status: $filter("asPortalLang")("Blocked","Blocked")
                        }, {
                            id: 'demised',
                            auth_status: $filter("asLingo")("318")
                        }]
                    },
                    singleSearch: true,
                    countsRequired: false,
                    restrictionFunctions: [negativeFunc(isAdmin)],
                    showInfo: $filter("asPortalLang")("Default_Users_Msg","By default only authenticated and unauthenticated users are displayed in the list.")
                },
                membership_status: {
                    displayName: $filter('asLingo')('298')+" "+$filter("asPortalLang")("Status","Status"),
                    actionString: "of "+$filter('asLingo')('298')+" "+$filter("asPortalLang")("Status","Status"),
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select","Select")+" "+$filter('asLingo')('298')+" "+$filter("asPortalLang")("Status","Status")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 0,
                            name: $filter("asPortalLang")("Expired","Expired")
                        }, {
                            id: 1,
                            name: $filter("asPortalLang")("Active","Active")
                        },
                        // {
                        //     id: 2,
                        //     name: 'Pending'
                        // },
                        {
                            id: 3,
                            name: $filter("asPortalLang")("Suspended","Suspended")
                        }]
                    },
                    dataPreProcessors :[memebrship_datapreprocess],
                    countsRequired: false,
                    restrictionFunctions: [function(){
                        return !adminRights.isAllowed(11);
                    },function(){
                        return !$rootScope.featureEnabled('membership',false);
                    }]
                },
                last_payment: {//used for membership view not used in search
                    displayName: $filter("asPortalLang")("Payment_Date","Payment Date"),
                    actionString: "of "+$filter('asLingo')('298'),
                    hidden:true
                },
                membership_amount: {//used for membership view not used in search
                    displayName: $filter("asPortalLang")("Last_Payment","Last Payment"),
                    actionString: "of "+$filter('asLingo')('298'),
                    hidden:true
                },
                expiry_date: {//used for membership view not used in search
                    displayName: $filter('asLingo')('301'),
                    actionString: "of "+$filter('asLingo')('298'),
                    hidden:true
                },
                join_date: {//used for membership view not used in search
                    displayName: $filter('asLingo')('300'),
                    actionString: "of "+$filter('asLingo')('298'),
                    hidden:true
                },
                created_by_uui:{
                    displayName: $filter("asPortalLang")("Assigned_by", "Assigned by"),
                    actionString: "of "+$filter('asLingo')('298'),
                    hidden: true
                },
                last_edited_uui:{
                    displayName: $filter("asPortalLang")("Last_updated_by", "Last updated by"),
                    actionString: "of "+$filter('asLingo')('298'),
                    hidden: true
                },
                ms_unsubscribedFrom: {//used for mail_subscription view, not used in search
                    displayName: $filter("asPortalLang")("Unsubscribed_From","Unsubscribed From"),
                    actionString: "",
                    hidden:true
                },
                ms_feedback: {//used for mail_subscription view, not used in search
                    displayName:$filter("asLingo")('47','')+" "+$filter("asPortalLang")("Feedback","Feedback"),
                    actionString: "",
                    hidden:true
                },
                enrollment_number: { 
                    displayName: $filter('asLingo')('28'),
                    actionString: "with",
                    futherSearchType: "inputBox",
                    parentClass: "margin-bottom-10",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Enter","Enter")+" "+$filter('asLingo')('28'),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    countsRequired: false,
                    singleSearch: true,
                    emptySearching: true,
                    restrictionFunctions: [negativeFunc(isAdmin),
                        function(){
                            return !$scope.isEnrollment;
                        }
                    ],
                    hidden: true
                },
                identity_number: { 
                    displayName: $filter('asLingo')('312'),
                    actionString: "with",
                    futherSearchType: "inputBox",
                    parentClass: "margin-bottom-10",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Enter","Enter")+" "+$filter('asLingo')('312'),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    countsRequired: false,
                    singleSearch: true,
                    emptySearching: true,
                    restrictionFunctions: [negativeFunc(isAdmin),
                        function(){
                            return !$scope.isIdentity;
                        }
                    ],
                    hidden: true
                },
                phone_number: { 
                    displayName: $filter('asLingo')('218'),
                    actionString: "with",
                    futherSearchType: "inputBox",
                    parentClass: "margin-bottom-10",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Enter","Enter")+" "+$filter('asLingo')('218'),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    countsRequired: false,
                    singleSearch: true,
                    emptySearching: true,
                    restrictionFunctions: [negativeFunc(isAdmin)],
                },
                life_membership_number: { 
                    displayName: $filter('asLingo')('23')+" "+$filter("asPortalLang")("ID","ID"),
                    actionString: "with",
                    futherSearchType: "inputBox",
                    parentClass: "margin-bottom-10",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Enter","Enter")+" "+$filter('asLingo')('23')+" "+$filter("asPortalLang")("ID","ID"),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    countsRequired: false,
                    singleSearch: true,
                    restrictionFunctions: [negativeFunc(isAdmin),function(){
                        return !$rootScope.featureEnabled('life_membership_provision',false);
                    }],
                    emptySearching: true
                },
                life_membership_status: { 
                    displayName: $filter('asLingo')('23')+" "+$filter("asPortalLang")("Status","Status"),
                    actionString: "who are",
                    futherSearchType: "dropdown",
                    parentClass: "margin-bottom-10",
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select","Select")+" "+$filter('asLingo')('23')+" "+$filter("asPortalLang")("Status","Status")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 1,
                            name: $filter('asLingo')('22')
                        }, {
                            id: 2,
                            name: 'Not '+$filter('asLingo')('22')
                        }]
                    },
                    countsRequired: false,
                    singleSearch: true,
                    restrictionFunctions: [negativeFunc(isAdmin),function(){
                        return !$rootScope.featureEnabled('life_membership_provision',false);
                    }]
                },
                tags: { 
                    displayName: $filter('asLingo')('286')+" "+$filter("asPortalLang")("Name","name"),
                    actionString: "Members of ",
                    hidden:true,
                    futherSearchType: "dropdown",
                    parentClass: "margin-bottom-10",
                    futherSearchParams: {
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: false,
                    singleSearch: true,
                    preqFunctions: [{
                        fName: fetchTagData
                    }]
                },
                bounceEmail: {
                    displayName:$filter("asPortalLang")("Bounced_Email","Bounced email"),
                    actionString: "List of",
                    hidden: true,
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 0,
                            name: $filter("asPortalLang")("All","All")
                        }, {
                            id: 3,
                            name: $filter("asPortalLang")("Bounced_Email_Users","Bounced Email users")
                        }]
                    },
                    countsRequired: false,
                    singleSearch: true
                },
                unSubscribedEmail: {
                    displayName: $filter("asPortalLang")("Unsubscribed_Email","Unsubscribed Email"),
                    actionString: "Unsubscribed Email",
                    hidden: true,
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 0,
                            name:$filter("asPortalLang")("All","All")
                        }, {
                            id: 2,
                            name: $filter("asPortalLang")("Unsubscribed_Email","Unsubscribed Email")
                        }]
                    },
                    countsRequired: false,
                    singleSearch: true
                },
                activeStatus: {
                    displayName: $filter("asPortalLang")("Active_Accounts","Active Accounts"),
                    actionString: "activeStatus  ",
                    hidden: true,
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select_Timeline","Select timeline"),
                        serviceNameField: "name",
                        dropdownOrderbyField: "id",
                        serviceIdField: "id",
                        dateSelected: {
                            from: '',
                            to: '',
                            on: ''
                        },
                        dropdownList: [
                        {
                            id: 0,
                            name: $filter("asPortalLang")("Days_7","Last 7 days"),
                            value: [getDates('week')]
                        },
                        {
                            id: 1,
                            name: $filter("asPortalLang")("Days_30","Last 30 days"),
                            value: [getDates('month')]
                        },
                        {
                            id: 2,
                            name: $filter("asPortalLang")("Month_6","6 Months"),
                            value: [getDates('half_year')]
                        },
                        {
                            id: 3,
                            name: $filter("asPortalLang")("Year_1","1 Year"),
                            value: [getDates('year')]
                        }
                        ]
                    },
                    countsRequired: false,
                    restrictionFunctions: [negativeFunc(isAdmin)],
                    singleSearch: true
                },
                login_status: {
                    displayName: $filter("asPortalLang")("Login_Status","Login Status"),
                    actionString: "of login status",
                    futherSearchType: "radio",
                    futherSearchParams: {
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dateSelected: {
                            from: '',
                            to: '',
                            on: '',
                            rev: false
                        },
                        radioList: [
                        // {
                        //     id: 0,
                        //     name: "Never logged in between",
                        //     dateSelector: {
                        //         enabled: true,
                        //         type: "from-to"
                        //     },
                        //     rev: true
                        // }, 
                        {
                            id: 0,
                            name: $filter("asPortalLang")("Never_Logged_In","Never logged in"),
                            dateSelector: {
                                enabled: true,
                                type: "to"
                            }
                        }, {
                            id: 1,
                            name: $filter("asPortalLang")("Logged_In","Logged in"),
                            dropdownSelector: {
                                enabled: true,
                                placeholder: $filter("asPortalLang")("Select_Timeline","Select timeline"),
                                dropdownList: [{
                                    id: 0,
                                    name: $filter("asPortalLang")("Days_7","Last 7 days"),
                                    value: [getDates('week')]
                                },
                                {
                                    id: 1,
                                    name: $filter("asPortalLang")("Days_30","Last 30 days"),
                                    value: [getDates('month')]
                                },
                                {
                                    id: 2,
                                    name: $filter("asPortalLang")("Month_6","6 Months"),
                                    value: [getDates('half_year')]
                                },
                                {
                                    id: 3,
                                    name: $filter("asPortalLang")("Year_1","1 Year"),
                                    value: [getDates('year')]
                                },
                                {
                                    id: 4,
                                    name: $filter("asPortalLang")("Between_Date","Between (Select Date)"),
                                    dateSelector: {
                                        enabled: true,
                                        type: "from-to"
                                    }
                                }]
                            }
                        }
                        ]
                    },
                    countsRequired: false,
                    singleSearch: true,
                    emptySearching: true,
                    restrictionFunctions: [negativeFunc(isAdmin)]
                },
                account_created: {
                    displayName: $filter("asPortalLang")("Acc_Created_Date","Account Creation Date"),
                    actionString: "Account created ",
                    futherSearchType: "radio",
                    futherSearchParams: {
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dateSelected: {
                            from: '',
                            to: '',
                            on: ''
                        },
                        radioList: [
                        {
                            id: 0,
                            name: $filter("asPortalLang")("Created_On","Created On"),
                            dateSelector: {
                                enabled: true,
                                type: "on"
                            }
                        },
                        {
                            id: 1,
                            name: $filter("asPortalLang")("Select_Timeline","Select timeline"),
                            dropdownSelector: {
                                enabled: true,
                                placeholder: $filter("asPortalLang")("Select_Timeline","Select timeline"),
                                dropdownList: [{
                                    id: 0,
                                    name: $filter("asPortalLang")("Days_7","Last 7 days"),
                                    value: [getDates('week')]
                                },
                                {
                                    id: 1,
                                    name: $filter("asPortalLang")("Days_30","Last 30 days"),
                                    value: [getDates('month')]
                                },
                                {
                                    id: 2,
                                    name: $filter("asPortalLang")("Month_6","6 Months"),
                                    value: [getDates('half_year')]
                                },
                                {
                                    id: 3,
                                    name: $filter("asPortalLang")("Year_1","1 Year"),
                                    value: [getDates('year')]
                                },
                                {
                                    id: 4,
                                    name: $filter("asPortalLang")("Between_Date","Is between (Select Date)"),
                                    dateSelector: {
                                        enabled: true,
                                        type: "from-to"
                                    }
                                }]
                            }
                        }
                        ]
                    },
                    countsRequired: false,
                    singleSearch: true,
                    restrictionFunctions: [negativeFunc(isAdmin)]
                    // showDateRange: {
                    //     0: {
                    //     showRange: false 
                    // }}
                },
                adminRights: {
                    displayName: $filter("asPortalLang")("Admin_Rights","Admin Rights"),
                    actionString: "Admin Rights ",
                    hidden: true,
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 0,
                            name: $filter("asPortalLang")("Super_Admin","Super Admin")
                        }]
                    },
                    countsRequired: false,
                    singleSearch: true
                },
                company: {
                    displayName: $filter('asLingo')('44'),
                    actionString: "Work At",
                    icon: "icon-Search_workeat",
                    futherSearchType: "autocomplete",
                    futherSearchParams: {
                        query: 13,
                        placeholder: $filter('asLingo')('44')+" "+$filter("asPortalLang")("Name","Name"),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('company')>-1
                },
                city: {
                    displayName: $filter('asLingo')('43'),
                    actionString: "Living in",
                    icon: "icon-location_city",
                    futherSearchType: "autocomplete",
                    futherSearchParams: {
                        query: 12,
                        placeholder: $filter("asPortalLang")("Location_Inp","Location"),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id",
                        autocomplete_Options: { postData: { params: {'country': true, 'region': true} } }
                    },
                    countsRequired: true,
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('city')>-1
                },
                hometown: {
                    displayName: $filter('asLingo')('227'),
                    actionString: "from "+$filter('asLingo')('227'),
                    icon: "icon-home_filled",
                    hidden: true,
                    futherSearchType: "autocomplete",
                    futherSearchParams: {
                        query: 12,
                        placeholder: $filter("asPortalLang")("Location_Inp","Location"),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id",
                        autocomplete_Options: { postData: { params: {'country': true, 'region': true} } }
                    },
                    countsRequired: true,
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('hometown')>-1,
                    restrictionFunctions: [
                        function(){
                            return !$scope.isHometown;
                        },
                        function(){
                            return (!isAdmin() && angular.isDefined($rootScope.app_data.config.meta[64].fields) && angular.isDefined($rootScope.app_data.config.meta[64].fields['hometown']) && [2,3].indexOf($rootScope.app_data.config.meta[64].fields['hometown'].visibility)!=-1)
                        }
                    ]
                },
                department: {
                    displayName: $filter('asLingo')('5'),
                    actionString: "from " + $filter('asLingo')('5'),
                    icon: "icon-AA_userdetails_eduupdate",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('5') ,
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    preqFunctions: [{
                        fName: getDropdownValues,
                        expectedSchema: ["data"],
                        changeToAutocomplete: true,
                        dropdownProcess: processDepartmentDropdown,
                        paramsToSend: {
                            id: $rootScope.app_data.cid,
                            excludeListEntry:1
                        },
                        removeIfNoData: true,
                        serviceLink: './signuser/departmentGet/1'
                    }],
                    localautocomplete : {
                        type: "autocomplete",
                        name: "department",
                        multiple: false,
                        data: {
                          dataSource: {},
                          triggerFunction : departmentSelected,
                          allowNew: false,
                     //     responsetype: "name",
                          inputActualPlaceholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('5'),
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    restrictionFunctions: [function(){
                        return $scope.isDepHide;
                    }],
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('department')>-1
                },
                degree: {
                    displayName: $filter('asLingo')('4'),
                    actionString: "from " + $filter('asLingo')('4'),
                    icon: "icon-university-degree",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('4'),
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    preqFunctions: [{
                        fName: getDropdownValues,
                        changeToAutocomplete: true,
                        dropdownProcess: processDegreeDropdown,
                        expectedSchema: ["data"],
                        paramsToSend: {
                            id: $rootScope.app_data.cid,
                            excludeListEntry:1
                        },
                        removeIfNoData: true,
                        serviceLink: './signuser/degreesGet/1'
                    }],
                    localautocomplete : {
                        type: "autocomplete",
                        name: "degree",
                        multiple: false,
                        data: {
                          dataSource: {},
                          triggerFunction : degreeSelected,
                          allowNew: false,
                     //     responsetype: "name",
                          inputActualPlaceholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('4'),
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    restrictionFunctions: [function(){
                        return $scope.isDegreeHide;
                    }],
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('degree')>-1
                },
                specialization: {
                    displayName: $filter('asLingo')('283'),
                    actionString: "from " + $filter('asLingo')('283'),
                    icon: "icon-university-degree",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('283'),
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    preqFunctions: [{
                        fName: getDropdownValues,
                        changeToAutocomplete: true,
                        dropdownProcess: processSpecializationDropdown,
                        expectedSchema: ["data"],
                        paramsToSend: {
                            id: $rootScope.app_data.cid,
                            excludeListEntry:1,
                            type:2
                        },
                        removeIfNoData: true,
                        serviceLink: './signuser/specializationGet/1'
                    }],
                    localautocomplete : {
                        type: "autocomplete",
                        name: "specialization",
                        multiple: false,
                        data: {
                          dataSource: {},
                          triggerFunction : specializationSelected,
                          allowNew: false,
                     //     responsetype: "name",
                          inputActualPlaceholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('283'),
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    restrictionFunctions: [function(){
                        return !$scope.isSpecialization;
                    }],
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('specialization')>-1
                },
                past_institute:{
                    displayName:$filter('asLingo')('311'),
                    actionString: "from " +  $filter('asLingo')('311'),
                    icon: "icon-university-degree",
                    futherSearchType: "autocomplete",
                    futherSearchParams: {
                        query: 24,
                        placeholder:$filter("asPortalLang")("Select","Select")+" " +  $filter('asLingo')('311'),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    restrictionFunctions: [function(){
                        return $rootScope.app_data.cid==1497;
                    }],
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('past_institute')>-1
                },
                past_degree:{
                    displayName: $filter('asLingo')('309'),
                    actionString: "from " + $filter('asLingo')('309'),
                    icon: "icon-university-degree",
                    futherSearchType: "autocomplete",
                    futherSearchParams: {
                        query: 25,
                        placeholder:$filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('309'),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    restrictionFunctions: [function(){
                        return $rootScope.app_data.cid==1497;
                    }],
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('past_degree')>-1
                },
                past_department:{
                    displayName: $filter('asLingo')('310'),
                    actionString: "from " + $filter('asLingo')('310'),
                    icon: "icon-AA_userdetails_eduupdate",
                    futherSearchType: "autocomplete",
                    futherSearchParams: {
                        query: 26,
                        placeholder:$filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('310'),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    restrictionFunctions: [function(){
                        return $rootScope.app_data.cid==1497;
                    }],
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('past_department')>-1
                },
                institute: {
                    displayName: $filter('asLingo')('284'),
                    actionString: "from " + $filter('asLingo')('284'),
                    icon: "icon-university-degree",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('284'),
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    preqFunctions: [{
                        fName: getDropdownValues,
                        changeToAutocomplete: true,
                        dropdownProcess: processSpecializationDropdown,
                        expectedSchema: ["data"],
                        paramsToSend: {
                            id: $rootScope.app_data.cid,
                            excludeListEntry:1,
                            type:1
                        },
                        removeIfNoData: true,
                        serviceLink: './signuser/specializationGet/1'
                    }],
                    localautocomplete : {
                        type: "autocomplete",
                        name: "institute",
                        multiple: false,
                        data: {
                          dataSource: {},
                          triggerFunction : instituteSelected,
                          allowNew: false,
                     //     responsetype: "name",
                          inputActualPlaceholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('284'),
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    restrictionFunctions: [function(){
                        return !$scope.isInstitute;
                    }],
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('institute')>-1
                },
                professional_networks: {
                    displayName: $filter("asPortalLang")("Profession","Profession"),  
                    actionString: "Who are",
                    icon: "icon-group58",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select","Select")+" "+$filter("asPortalLang")("Profession","Profession"),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    localautocomplete : {
                        type: "autocomplete",
                        name: "professional_networks",
                        multiple: false,
                        data: {
                          dataSource: {
                            fetchAllData: {
                                limit : 1000000
                            },
                            params:{
                                type: '1',
                                user_list : false,
                                stream : 1,
                            },
                            url: "./filters/dyn_filters_ctrl/get_list"
                          },
                          triggerFunction : professionalNetworkSelected,
                          allowNew: false,
                     //     responsetype: "name",
                          inputActualPlaceholder: $filter("asPortalLang")("Profession","Profession"),
                          inputClass: "placeholder-opacity--4"
                        }
                      },
                    countsRequired: true,
                    restrictionFunctions: [function(){
                        return !$rootScope.featureEnabled('alumni_value_networks.show_in_directory.*',false);
                    }],
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('professional_networks')>-1
                },
                yop: {
                    displayName: $filter('asLingo')('3'),
                    actionString: "from " + $filter('asLingo')('3'),
                    icon: "icon-UserProfile_useredu",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('3') ,
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownOrderbyRev: true
                    },
                    countsRequired: true,
                    // preqFunctions: [{
                    //     fName: makeYearDropdown
                    // }],
                    localautocomplete : {
                        type: "autocomplete",
                        name: "yop",
                        multiple: false,
                        data: {
                          dataSource: {
                            data: makeYearDropdown("yop",null,true)
                          },
                          triggerFunction : yopSelected,
                          allowNew: false,
                          inputActualPlaceholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('3'),
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    restrictionFunctions: [function(){
                        return $scope.isYopHide;
                    }],
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('yop')>-1
                },
                yoj: {
                    displayName: $filter('asLingo')('2'),
                    actionString: "from " + $filter('asLingo')('2'),
                    icon: "icon-school1",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('2') ,
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownOrderbyRev: true
                    },
                    countsRequired: true,
                    // preqFunctions: [{
                    //     fName: makeYearDropdown
                    // }],
                    localautocomplete : {
                        type: "autocomplete",
                        name: "yoj",
                        multiple: false,
                        data: {
                          dataSource: {
                            data: makeYearDropdown("yoj",null,true)
                          },
                          triggerFunction : yojSelected,
                          allowNew: false,
                          inputActualPlaceholder: $filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('2'),
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    restrictionFunctions: [function(){
                        return $scope.isYojHide;
                    }],
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('yoj')>-1
                },
                sector: {
                    displayName: $filter('asLingo')('7'),
                    actionString: "from " + $filter('asLingo')('7'),
                    icon: "icon-UserProfile_UserWork",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('7') + "--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    localautocomplete : {
                        type: "autocomplete",
                        name: "sector",
                        multiple: false,
                        data: {
                          dataSource: {},
                          triggerFunction : sectorSelected,
                          allowNew: false,
                     //     responsetype: "name",
                          inputActualPlaceholder: "--"+$filter("asPortalLang")("Select","Select")+" " + $filter('asLingo')('7') + "--",
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    preqFunctions: [{
                        fName: getDropdownValues,
                        changeToAutocomplete: true,
                        expectedSchema: [],
                        serviceLink: './jobs/fetch_all_sectors'
                    }],
                },
                subinst: {
                    displayName: $filter('asLingo')('45'),
                    actionString: "from",
                    icon: "icon-location_city",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select","Select")+" "+$filter('asLingo')('45')+" --",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        // dropdownList: $rootScope.app_data.data.child_institutes&&$rootScope.app_data.data.child_institutes.map(function(v) {
                                // return {name:v.sub_name,id:v.sub_cid};
                            // })
                    },
                    localautocomplete : {
                        type: "autocomplete",
                        name: "subinst",
                        multiple: false,
                        data: {
                          dataSource: {
                            data: $rootScope.app_data.data.child_institutes&&$rootScope.app_data.data.child_institutes.map(function(v) {
                                return {name:v.sub_name,id:v.sub_cid};
                            })
                          },
                          triggerFunction : subinstSelected,
                          allowNew: false,
                     //     responsetype: "name",
                          inputActualPlaceholder: "--"+$filter("asPortalLang")("Select","Select")+" "+$filter('asLingo')('45')+" --",
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    countsRequired: true,
                    restrictionFunctions: [function() {
                        return $rootScope.app_data.data.insti_type!=3;
                    }],
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('subinst')>-1
                },
                skill: {
                    displayName: $filter('asLingo')('42'),
                    actionString: "Having "+$filter('asLingo')('42')+" in",
                    icon: "icon-stars2",
                    hidden: true,
					futherSearchType: "autocomplete",
                    futherSearchParams: {
                        query: 15,
                        placeholder: $filter("asPortalLang")("Search","Search")+" "+$filter('asLingo')('42'),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('skill')>-1,
                    restrictionFunctions: [
                        function(){
                            return !$scope.isSkill;
                        },
                        function(){
                            return (!isAdmin() && angular.isDefined($rootScope.app_data.config.meta[64].fields) && angular.isDefined($rootScope.app_data.config.meta[64].fields['skills']) && [2,3].indexOf($rootScope.app_data.config.meta[64].fields['skills'].visibility)!=-1)
                        }
                    ],
                },
                role: {
                    displayName: $filter("asLingo")(196,'','',"Search by Role"),
                    viewTitle: $filter("asLingo")('1'),
                    actionString: "who are",
                    icon: "icon-UserProfile_UserInfo",
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select","Select")+" " + $filter("asLingo")('1'),
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 0,
                            name: $filter("asPortalLang")("All","All")
                        }]
                    },
                    countsRequired: false,
                    singleSearch: true,
                    preqFunctions: [{fName: function() {
                        var roles_list = [];
                        angular.forEach(signup_roles,function(role) {
                            roles_list.push({
                                id: role.code,
                                name: $filter('asRoleLingo')(role.code)
                            });
                        });
                        roles_list.push({'id': 4, 'name': $filter('asRoleLingo')(4)});
                        $scope.search_data.fields['role'].futherSearchParams.dropdownList = roles_list;
                    }}]
                },
                gender: {
                    displayName: $filter('asLingo')('215'),
                    actionString: "of "+$filter('asLingo')('215'),
                    futherSearchType: "dropdown",
                    hidden: false,
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select","Select")+" "+$filter('asLingo')('215')+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: getGenderArr($filter)
                    },
                    countsRequired: false,
                    preqFunctions: [],
                    restrictionFunctions: [negativeFunc(isAdmin),
                        function(){
                            return !$scope.isGender;
                        }
                    ],
                    emptySearching: true,
                    singleSearch: true
                },
                marital_status: {
                    displayName: $filter("asPortalLang")("Marital_Status","Marital Status"),
                    actionString: "of marital status",
                    futherSearchType: "dropdown",
                    hidden: true,
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select","Select")+" "+$filter("asPortalLang")("Marital_Status","marital status")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 1,
                            name: $filter("asPortalLang")("Married","Married")
                        }, {
                            id: 2,
                            name: $filter("asPortalLang")("Unmarried","Un-married")
                        },{
                            id: 3,
                            name: $filter("asPortalLang")("Other","Other")
                        }]
                    },
                    countsRequired: false,
                    preqFunctions: [],
                    restrictionFunctions: [negativeFunc(isAdmin),
                        function(){
                            return !$scope.isMaritalStatus;
                        }
                    ],
                    emptySearching: true,
                    singleSearch: true
                },
                designation: {
                    displayName: $filter('asLingo')('228'),
                    actionString: "Working as ",
                    icon: "icon-Search_workeat",
                    futherSearchType: "autocomplete",
                    futherSearchParams: {
                        query: 17,
                        placeholder: $filter("asPortalLang")("Search","Search")+" "+$filter('asLingo')('228'),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('designation')>-1
                },
                industry: {
                    displayName: $filter('asLingo')('41'),
                    actionString: "In "+$filter('asLingo')('41'),
                    icon: "icon-UserProfile_UserWork",
                    futherSearchType: "autocomplete",
                    futherSearchParams: {
                        query: 20,
                        placeholder: $filter("asPortalLang")("Search","Search")+" "+$filter('asLingo')('41'),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: true,
                    emptySearching: true,
                    checkBoxRequired:checkBoxRequired.indexOf('industry')>-1
                },
                job_switch: {
                    displayName: $filter("asPortalLang")("Job_Seeker","Job Seeker"),
                    actionString: "Who are",
                    hidden: true,
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select_Option_Ph","Select Option")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 0,
                            name: $filter("asPortalLang")("Actively_App_Job","Actively Applying for Job")
                        }, {
                            id: 1,
                            name: $filter("asPortalLang")("Casually_Look_Job","Casually Looking for Job")
                        }]
                    },
                    countsRequired: false
                },
                job_provider_switch: {
                    displayName: $filter("asPortalLang")("Job_Provider","Job Provider"),
                    actionString: "Who are",
                    hidden: true,
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select_Option_Ph","Select Option")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 0,
                            name: $filter("asPortalLang")("Job_Provider","Job Provider")
                        }, {
                            id: 1,
                            name: $filter("asPortalLang")("Job_Referrer","Job Referrer")
                        }]
                    },
                    countsRequired: false
                },
                internship_switch: {
                    displayName: $filter("asPortalLang")("Intern_Seeker","Internship Seeker"),
                    actionString: "Who are",
                    hidden: true,
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder:  "--"+$filter("asPortalLang")("Select_Option_Ph","Select Option")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 0,
                            name: $filter("asPortalLang")("Actively_App_Intern","Actively Applying for Internship")
                        }, {
                            id: 1,
                            name: $filter("asPortalLang")("Casually_Look_Intern","Casually Looking for Internship")
                        }]
                    },
                    countsRequired: false
                },
                internship_provider_switch: {
                    displayName: $filter("asPortalLang")("Internship_Provider","Internship Provider"),
                    actionString: "Who are",
                    hidden: true,
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder:  "--"+$filter("asPortalLang")("Select_Option_Ph","Select Option")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 0,
                            name: $filter("asPortalLang")("Internship_Provider","Internship Provider")
                        }, {
                            id: 1,
                            name: $filter("asPortalLang")("Internship_Referrer","Internship Referrer")
                        }]
                    },
                    countsRequired: false
                },
                socialIntegration: {
                    displayName: $filter("asPortalLang")("Social_Integ_Status","Social Integration Status"),
                    actionString: "selectedIntegration",
                    hidden: true,
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [
                        {
                            id: 0,
                            name: $filter("asPortalLang")("Google","Google")
                        },{
                            id: 1,
                            name: $filter("asPortalLang")("Linkedin","Linkedin")
                        },{
                            id: 2,
                            name:  $filter("asPortalLang")("Facebook","Facebook")
                        }]
                    },
                    countsRequired: false,
                    singleSearch: true
                },
                user_metadata_filter: { 
                    displayName: "user_metadata_filter",
                    actionString: "with",
                     hidden: true,
                      futherSearchType: "dropdown",
                    countsRequired: false,
                    singleSearch: true
                },
                chapters: {
                    displayName: $filter('asLingo')('287'),
                    actionString: "from "+$filter('asLingo')('286','','lowercase')+" ",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select_Chapter","Select a [TERM:Chapter]")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    countsRequired: false,
                    preqFunctions: [{
                        fName: makeChapterAndGroupDropdown,
                        expectedSchema: ["data"],
                        paramsToSend: {
                            tag_name: "#chapters"
                        },
                        removeIfNoData: true,
                        serviceLink: './tags/fetch'
                    }],
                    localautocomplete : {
                        type: "autocomplete",
                        name: "chapters",
                        multiple: false,
                        data: {
                          dataSource: {},
                          triggerFunction : chapterSelected,
                          allowNew: false,
                     //     responsetype: "name",
                          inputActualPlaceholder: "--"+$filter("asPortalLang")("Select_Chapter","Select a [TERM:Chapter]")+"--",
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    checkBoxRequired:checkBoxRequired.indexOf('chapters')>-1,
                    restrictionFunctions: [function(){
                        return !$rootScope.featureEnabled('chapters',false);
                    }]
                },
                groups: {
                    displayName: $filter("asPortalLang")("Groups","Groups"),
                    actionString: "from group ",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select_Group","Select a Group")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    countsRequired: false,
                    preqFunctions: [{
                        fName: makeChapterAndGroupDropdown,
                        expectedSchema: ["data"],
                        paramsToSend: {
                            tag_name: "#groups"
                        },
                        removeIfNoData: true,
                        serviceLink: './tags/fetch'
                    }],
                    localautocomplete : {
                        type: "autocomplete",
                        name: "groups",
                        multiple: false,
                        data: {
                          dataSource: {},
                          triggerFunction : groupSelected,
                          allowNew: false,
                     //     responsetype: "name",
                          inputActualPlaceholder: "--"+$filter("asPortalLang")("Select_Group","Select a Group")+"--",
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    checkBoxRequired:checkBoxRequired.indexOf('groups')>-1,
                    restrictionFunctions: [negativeFunc(isAdmin),function(){
                        return !$rootScope.featureEnabled('groups',false);
                    }]
                },
                nonLoggedUsers: {
                    displayName: $filter("asPortalLang")("Log_In_Filter","Log In Filter"),
                    actionString: "never logged in",
                    hidden: true,
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select_Log_Filter","Select Log In Filter")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 1,
                            name: $filter("asPortalLang")("Never_Login_User","Never Logged-in Users")
                        }]
                    },
                    countsRequired: false,
                },
                import_id: {
                    displayName: $filter("asPortalLang")("Import_Name","Import Name"),
                    actionString: "imported by",
                    futherSearchType: "customfield",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Select","Select")+" "+$filter("asPortalLang")("Import_Name","import name"),
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    countsRequired: false,
                    restrictionFunctions: [function(){
                        return !adminRights.isAllowed(13);
                    },negativeFunc(isAdmin)],
                    localautocomplete : {
                        type: "autocomplete",
                        name: "import_id",
                        multiple: false,
                        data: {
                          dataSource: {},
                          triggerFunction : importIdSelected,
                          allowNew: false,
                     //     responsetype: "name",
                          inputActualPlaceholder:$filter("asPortalLang")("Select_Import_Name","Select an import name"),
                          // inputClass: "placeholder-opacity--4"
                        }
                      },
                    preqFunctions: [{
                        fName: getImportData,
                        expectedSchema: [],
                        paramsToSend: {
                            cid: $rootScope.app_data.cid,
                            import_status: 2,
                            fetch_all: 1
                        },
                        removeIfNoData: true,
                        serviceLink: './profile/import?action=fetch_import_data'
                    }]
                },
                mail_subscription: {
                    displayName: $filter("asPortalLang")("Unsubscribed_Email","Unsubscribed Email"),
                    actionString: "List of Unsubscribed Email users from",
                    hidden: true,
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 1,
                            name: $filter("asPortalLang")("Platform_Mails","Platform mails")
                        }, {
                            id: 2,
                            name: $filter("asPortalLang")("Institute_Mails","[TERM:Institute] mails")
                        }, {
                            id: 3,
                            name: $filter("asPortalLang")("All_Mails","All mails")
                        }, {
                            id: 4,
                            name: $filter("asPortalLang")("Any_Mails","Any mails")
                        },
                        ]
                    },
                    countsRequired: true,
                    singleSearch: true
                },
                mail_feedbacks: {
                    displayName: $filter("asPortalLang")("All_Feedbacks","All Feedbacks"),
                    actionString: " with feedback",
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Filter_By","Filter by")+" "+$filter("asLingo")('47','','lowercase')+" "+$filter("asPortalLang")("Feedback","Feedback").toLowerCase(),
                        serviceNameField: "name",
                        serviceIdField: "id",
                    },
                    singleSearch: true,
                    preqFunctions: [{
                        fName: getMailFeedbackCounts,
                        mail_subscriptionCat: (($scope.searchInitialData && $scope.searchInitialData.dataParams && $scope.searchInitialData.dataParams.mail_subscription && $scope.searchInitialData.dataParams.mail_subscription[0])?$scope.searchInitialData.dataParams.mail_subscription[0]:7),
                        removeIfNoData: true,
                    }],
                },
                votes_display: {
                    displayName: $filter("asPortalLang")("Voting_Options","Voting Options"),
                    actionString: "with option",
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Filter_By","Filter by")+" "+$filter("asPortalLang")("Voting_Options","Voting Options"),
                        serviceNameField:"name",
                        serviceIdField:"id",
                    },
                    singleSearch: true,
                    preqFunctions: [{
                        fName: getVoteOptions,
                        votes_displayOpt: ($scope.options && $scope.options.polltable && $scope.options.poll_id)?{'intParentTable':$scope.options.polltable,'parent_id':$scope.options.poll_id}:{},
                        removeIfNoData:true,
                    }],
                },
                mail_type: { 
                    hidden: true,
                    displayName: $filter("asPortalLang")("Mail_Type","Mail Type"),
                    actionString: "List of",
                    futherSearchType: "inputBox",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Enter_Mail_Type","Enter Mail Type"),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    countsRequired: false,
                    singleSearch: true,
                    restrictionFunctions: [negativeFunc(isAdmin)],
                },
                mail_id: { 
                    hidden: true,
                    displayName: $filter("asPortalLang")("Mail_Id","Mail Id"),
                    actionString: "List of",
                    futherSearchType: "inputBox",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Enter_Mail_Id","Enter Mail Id"),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    countsRequired: false,
                    singleSearch: true,
                    restrictionFunctions: [negativeFunc(isAdmin)],
                },
                mail_time_cat: { 
                    hidden: true,
                    displayName: $filter("asPortalLang")("Mail_Time_Category","Mail time category"),
                    futherSearchType: "inputBox",
                    futherSearchParams: {
                        placeholder: $filter("asPortalLang")("Enter_Time_Category","Enter time category"),
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    countsRequired: false,
                    singleSearch: true,
                    restrictionFunctions: [negativeFunc(isAdmin)],
                },
                mail_time_cat_value: { 
                    hidden: true,
                    displayName: $filter("asPortalLang")("Mail_Time_Values","Mail time category with values"),
                    futherSearchType: "inputBox",
                    futherSearchParams: {
                        placeholder: "",
                        idSelected: -1,
                        textSelected: '',
                        serviceNameField: "name",
                        serviceIdField: "id"
                    },
                    countsRequired: false,
                    restrictionFunctions: [negativeFunc(isAdmin)],
                },
                mobile_app:{
                    displayName: $filter("asPortalLang")("Mobile_App","Mobile App"),
                    actionString:":",
                    futherSearchType: "dropdown",
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select_Platform","Select Platform")+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownList: [{
                            id: 1,
                            name: $filter("asPortalLang")("Android","Android")
                        }, {
                            id: 0,
                            name: $filter("asPortalLang")("Ios","Ios")
                        }]
                    },
                    countsRequired: false,
                    preqFunctions: [],
                    restrictionFunctions: [negativeFunc(isAdmin),function(){
                        return (!$rootScope.featureEnabled('mobile_app',false) && $rootScope.app_data.config.meta[42].features.mobile_app.type!='dedicated');
                    }],
                    emptySearching: true,
                    emptySearchText:{"isEmpty":$filter("asPortalLang")("Not_Downloaded_Txt","Not Downloaded"),"isNotEmpty":$filter("asPortalLang")("Downloaded_Txt","Downloaded")},
                    singleSearch: true
                },
                work:{
                    hidden: true
                },
                dob: {
                    displayName: $filter("asLingo")('216'),
                    actionString: "with "+$filter("asLingo")('216'),
                    futherSearchType: "dropdown",
                    hidden: false,
                    futherSearchParams: {
                        placeholder: "--"+$filter("asPortalLang")("Select","Select")+" "+$filter("asLingo")('216')+"--",
                        serviceNameField: "name",
                        serviceIdField: "id",
                        dropdownOrderbyField: "id",
                        type: "date-month",
                        dateSelected: {
                            from: '',
                            to: '',
                            on: '',
                            rev: false
                        },
                        dropdownList: [
                            {
                                id: 0,
                                name: $filter("asPortalLang")("Today","Today"),
                                value: [getDateMonth('today')]
                            },
                            {
                                id: 1,
                                name: $filter("asPortalLang")("Tomorrow","Tomorrow"),
                                value: [getDateMonth('tomorrow')]
                            },
                            {
                                id: 2,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("January","January"),
                                value: [getDateMonth('January')]
                            },
                            {
                                id: 3,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("February","February"),
                                value: [getDateMonth('February')]
                            },
                            {
                                id: 4,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("March","March"),
                                value: [getDateMonth('March')]
                            },
                            {
                                id: 5,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("April","April"),
                                value: [getDateMonth('April')]
                            },
                            {
                                id: 6,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("May","May"),
                                value: [getDateMonth('May')]
                            },
                            {
                                id: 7,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("June","June"),
                                value: [getDateMonth('June')]
                            },
                            {
                                id: 8,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("July","July"),
                                value: [getDateMonth('July')]
                            },
                            {
                                id: 9,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("August","August"),
                                value: [getDateMonth('August')]
                            },
                            {
                                id: 10,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("September","September"),
                                value: [getDateMonth('September')]
                            },
                            {
                                id: 11,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("October","October"),
                                value: [getDateMonth('October')]
                            },
                            {
                                id: 12,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("November","November"),
                                value: [getDateMonth('November')]
                            },
                            {
                                id: 13,
                                name: $filter("asPortalLang")("In_Txt","in")+" "+$filter("asPortalLang")("December","December"),
                                value: [getDateMonth('December')]
                            },
                            {
                                id: 14,
                                name: $filter("asPortalLang")("Custom_Date","Custom Date"),
                                multipleDropdown: [
                                    {
                                        enabled: true,
                                        placeholder: $filter("asPortalLang")("Select_Date","Select Date"),
                                        id: "date",
                                        dropdownList: []
                                    },
                                    {
                                        enabled: true,
                                        placeholder: $filter("asPortalLang")("Select_Month","Select Month"),
                                        id: "month",
                                        dropdownList: [
                                            {
                                                id: 1,
                                                name: $filter("asPortalLang")("January","January"),
                                                value: 1
                                            },
                                            {
                                                id: 2,
                                                name: $filter("asPortalLang")("February","February"),
                                                value: 2
                                            },
                                            {
                                                id: 3,
                                                name: $filter("asPortalLang")("March","March"),
                                                value: 3
                                            },
                                            {
                                                id: 4,
                                                name: $filter("asPortalLang")("April","April"),
                                                value: 4
                                            },
                                            {
                                                id: 5,
                                                name: $filter("asPortalLang")("May","May"),
                                                value: 5
                                            },
                                            {
                                                id: 6,
                                                name: $filter("asPortalLang")("June","June"),
                                                value: 6
                                            },
                                            {
                                                id: 7,
                                                name: $filter("asPortalLang")("July","July"),
                                                value: 7
                                            },
                                            {
                                                id: 8,
                                                name: $filter("asPortalLang")("August","August"),
                                                value: 8
                                            },
                                            {
                                                id: 9,
                                                name: $filter("asPortalLang")("September","September"),
                                                value: 9
                                            },
                                            {
                                                id: 10,
                                                name: $filter("asPortalLang")("October","October"),
                                                value: 10
                                            },
                                            {
                                                id: 11,
                                                name: $filter("asPortalLang")("November","November"),
                                                value: 11
                                            },
                                            {
                                                id: 12,
                                                name: $filter("asPortalLang")("December","December"),
                                                value: 12
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                id: 15,
                                name: $filter("asPortalLang")("Between_Date","Between (Select Date)"),
                                dateSelector: {
                                    enabled: true,
                                    type: "from-to"
                                },
                                parent_filter:true
                            }
                        ]
                    },
                    countsRequired: false,
                    restrictionFunctions: [negativeFunc(isAdmin),
                        function(){
                            return !$scope.isDOB;
                        }
                    ],
                    emptySearching: true,
                    singleSearch: true,
                    multiSearchWithChip: false, //disabled due to complexities in UX
                    preqFunctions: [{fName: function() {
                        var date_list = [];
                        for (var i = 1; i <= 31; i++) {
                            date_list.push({'id': i, 'name': i});
                        }
                        angular.forEach($scope.search_data.fields['dob'].futherSearchParams.dropdownList, function(value, key){
                            if(value.name == "Custom Date" || value.name == $filter("asPortalLang")("Custom_Date","Custom Date")){
                                $scope.search_data.fields['dob'].futherSearchParams.dropdownList[key].multipleDropdown[0].dropdownList = date_list;
                            }
                        });
                        
                    }}]
                }
            },
            categories: [{
                fields: ["name"],
                displayName: $filter("asLingo")(194,'','',"Keyword")
            },
            // { //send this category from out side if needed
            //     fields: ["company", "designation", "yop", "degree", "department", "city", "hometown", "sector", "skill", "gender"],
            //     displayName: "Filters"
            // }
            ],
            initConfigurations: {
                initCheckboxes: false,
                initNetwork: false,
                totalCount: false
            },
            dataParams: {},
            fetchLost: false, // 0|false->never fetch;1|true->always fetch;2->fetch only when search params not empty 
            mobile_default_category: 0, //if the template supports mobile design and multiple categories, then category of this index will be shown by default
        }

        // { //send this category from out side if needed
        //     fields: ["company", "designation", "yop", "degree", "department", "city", "hometown", "sector", "skill", "gender"],
        //     displayName: "Filters"
        // }
       
        if(angular.isDefined($scope.searchInitialData) && angular.isDefined($scope.searchInitialData.fp) && Object.keys($scope.searchInitialData.fp).length > 0){
            check_fp_params();
        }

        if($scope.options && $scope.options.ordering) {
            vSearchParams.ordering= $scope.options.ordering;
        }
        
        if(angular.isUndefined($scope.startSearchNow))
        {
            $timeout(function() {
                var startSearch = $scope.startSearchNow || {};
                startSearch.start = initDataBind;
            },500)
        }
        var startSearch = $scope.startSearchNow || {};

        startSearch.start = initDataBind; 

        if(angular.isDefined($scope.options.extend_controllers)){
            angular.forEach($scope.options.extend_controllers,function(val,k) {
                angular.extend($controller(val, {$scope: $scope}));
            });
        }

        //Function Bindings
        $scope.autocompleteSelected = autocompleteSelected;
        $scope.filterDropdownOnChange = filterDropdownOnChange;
        $scope.multipleFilterDropdownOnChange = multipleFilterDropdownOnChange;
        $scope.vBoxChanged = vBoxChanged;
        $scope.vFetchProfiles = vFetchProfiles;
        $scope.messageBtnClick = messageBtnClick;
        $scope.updateNetList = updateNetList;
        $scope.vCrossButton = vCrossButton;
        $scope.vResetAll = vResetAll;
        $scope.inputBoxSelected = inputBoxSelected;
        $scope.inputBoxKeyPressed=inputBoxKeyPressed;
        $scope.isAllowed = adminRights.isAllowed;
        $scope.download = download;
        $scope.showMoreToggle = showMoreToggle;
        $scope.allow_email = allow_email;
        $scope.inviteVia = inviteVia;
        $scope.claim_profile = claim_profile;
        $scope.claim_profile2 = claim_profile2;
        $scope.mail = mail;
        $scope.close = close;
        $scope.searchFilterModal = searchFilterModal;
        $scope.fieldSort = fieldSort;
        $scope.isfieldEnabled = isfieldEnabled;
        $scope.changeDefaultFields = changeDefaultFields;
        $scope.userRowClick = function() {console.log('nooooo!')};
        $scope.resendMail = function() {console.log('nooooo!')};
        $scope.requestForAccess = requestForAccess;
        $scope.forceAsUpgradeOnClick=forceAsUpgradeOnClick;
        $scope.changeviewmode = changeviewmode;
        $scope.setDateInSearchParams = setDateInSearchParams;
        $scope.registerAnalytics=registerAnalytics;
        $scope.loadCheckBoxData=loadCheckBoxData;
        $scope.updateLocation = updateLocation;
        $scope.openLostUserModal = openLostUserModal;
        $scope.miniProfile = miniProfile;
        $scope.goToDirectory = goToDirectory;
        $scope.openMap = openMap;
        $scope.changeAllFiltersLim = changeAllFiltersLim;
        $scope.resetAllVisible=resetAllVisible;
        $scope.entityEmptyChanges = entityEmptyChanges;
        $scope.vCrossButton_entity = vCrossButton_entity;

        $scope.searchData=$filter('asPortalLang')('Select_Date',"Select Date")

        var change_stream = true;

        $scope.allSelected = false;

        var subinst_array = userdata.fetchAllowedSubinst();
           
        $scope.sub_insti_array=subinst_array;
        //Activate Function

        function activate(searchInitialData) {
            if(searchInitialData.success == 0 && searchInitialData.errorcode == "LIMIT_EXCEEDED"){
                swal({text: searchInitialData.error, "title":$filter('asPortalLang')('Action_Limit_Restriction',"Access Temporary Restricted")});
                $scope.limitSwalShown = true;
                return;
            }
            if(platform && (isAppCacheEnable || isAppCacheEnable === "true" || isAppCacheEnable === true) && $scope.options && $scope.options.view && $scope.options.view.name == "directory"){
                $rootScope.$watch('DirectoryCache', function() {
                    console.log("$rootScope.DirectoryCache : ",$rootScope.DirectoryCache);
                    if($rootScope.DirectoryCache === true)
                        $scope.showNewDataLabel = true;
                    else
                        $scope.showNewDataLabel = false;
                });
            }

            if($scope.templatetype=='View' || $scope.templatetype=='Compact'){
                // $ocLazyLoad.load("css!https://unpkg.com/placeholder-loading/dist/css/placeholder-loading.min.css").then(function() {
                // });
            }

            if (window.innerWidth <= 1024) {
                $scope.isMobOrTab = true;
            } else {
                $scope.isMobOrTab = false;
            }

            if($scope.options && $scope.options.includeNonSubInstiUsers)
                $scope.includeNonSubInstiUsers = true;

            setMouseScroll();
            intialiseSearch();
            searchInitials.stream++;
            // searchDataInit();
            if(chk_restrictions_return(23) && !angular.equals(vSearchParams, {}) && !$scope.post_right)
            {
                if(chk_restrictions_return(24)){
                    chk_restrictions(23, true, true);         
                    return;
                }
            }

            if($scope.options && $scope.options.userRowClick && $scope.options.userRowClick.constructor == Function) {
                $scope.userRowClick = $scope.options.userRowClick;
            }
            if($scope.options && $scope.options.resendMail && $scope.options.resendMail.constructor == Function) {
                $scope.resendMail = $scope.options.resendMail;
            }

            as_upgrade(1000);


            if($scope.options && $scope.options.view && $scope.options.view.name && $scope.options.view.availabeFields && isArray($scope.options.view.availabeFields) && ($rootScope.app_data.isAdmin || $scope.options.view.name=='membership')){
                angular.forEach($scope.options.view.availabeFields,function(val,key){
                    var field =angular.copy(val);
                    var fieldKey =angular.copy(key);
                    $scope.availabeFields[fieldKey]={};
                    $scope.availabeFields[fieldKey].field=field;
                    $scope.availabeFields[fieldKey].enabled=false;
                    if(angular.isUndefined($scope.search_data.fields[field])) $scope.availabeFields[fieldKey].hidden = true;
                    if(angular.isDefined(search_data.fields[field]) && angular.isDefined(search_data.fields[field].displayName)){
                        $scope.availabeFields[fieldKey].displayName=search_data.fields[field].viewTitle?search_data.fields[field].viewTitle:search_data.fields[field].displayName;
                    }
                });

                $scope.disabledFields = [];

                if($scope.options.view.disabledFields)
                    $scope.disabledFields = $scope.options.view.disabledFields;

                if($scope.disabledFields && isArray($scope.disabledFields)){
                    angular.forEach($scope.availabeFields,function(val,key){
                        if($scope.disabledFields.indexOf(val.field)==-1){
                           $scope.availabeFields[key].enabled=true;
                           $scope.enableFields.push(val.field);
                        }
                    });
                }
            }

            if($scope.options && $scope.options.view && $scope.options.view.name && $scope.options.view.availabeFields && isArray($scope.options.view.availabeFields) && $scope.options.view.name=='membership'){
                var data={"meta_option" : "SEARCH_VIEWS"};
                $http.post('./admin/get_meta', data).then(function(res) {
                    if(res && res.data && res.data.success && res.data.success==1){
                       $scope.options.showviewConfig=true;

                        if(!res.data.data || !angular.isDefined(res.data.data[$scope.options.view.name])){
                            if(!res.data.data)
                                res.data.data={};

                            res.data.data[$scope.options.view.name]={
                                "enabled": true,
                                "desktop":{
                                  "disabled_fields": []    
                                },
                                "mobile":{
                                  "disabled_fields": []    
                                }
                            };
                        }

                        if(angular.isDefined(res.data.data[$scope.options.view.name]['enabled']) && res.data.data[$scope.options.view.name]['enabled']==true){
                             $scope.searchView=res.data.data[$scope.options.view.name];
                             
                            if($rootScope.isMobile) {
                                $scope.disabledFields=$scope.searchView['mobile']['disabled_fields'];
                            }else{
                                $scope.disabledFields=$scope.searchView['desktop']['disabled_fields'];
                            }

                            if($scope.disabledFields && isArray($scope.disabledFields)){
                                angular.forEach($scope.availabeFields,function(val,key){
                                    if($scope.disabledFields.indexOf(val.field)==-1){
                                       $scope.availabeFields[key].enabled=true;
                                       $scope.enableFields.push(val.field);
                                    }
                                });
                            }
                        }else{
                            $scope.options.showviewConfig=false;
                        }
                    }
                    $scope.info.isEnableFieldsFetched=true;
                });
            }

            as_upgrade(100);

            vIsEmptySearch(vSearchParams);
            vFilterCount(vSearchParams); 
            $scope.vResettingWaiting = false;
            $scope.isFetchingSelected = false;
            $scope.options.isLoaded = true;
            $scope.pageLoad = false;
            var initialData = searchInitialData.data;
            var initCheckboxes = {};
            if (angular.isDefined(initialData)) {
                $scope.totalCount = initialData.totalCount;
                initCheckboxes = (initialData.checkboxes.success == 1) ? initialData.checkboxes : {};
                network = (initialData.network) ? initialData.network : [];
                // downloadPermit = (initialData.downloadPermit) ? initialData.downloadPermit : false;
                if (initialData.people.success == 1) {
                    $scope.resultProfiles = initialData.people.data; 
                    mapNetworkAndSelf($scope.resultProfiles);
                }
            }
            if($scope.resultProfiles.length == 0 && angular.isDefined($scope.search_data.dataParams.dob) && angular.isDefined($scope.search_data.dataParams.dob.birthday) && $scope.search_data.dataParams.dob.birthday !=='Today'){
                $scope.options.isLoaded = false;
            }
            setCheckboxesFromDropdownList();
            angular.forEach(initCheckboxes.data, function(fCheckbox, cField) {
                if (angular.isDefined($scope.search_data["fields"][cField])) {
                    $scope.search_data["fields"][cField].vCheckboxes = fCheckbox;
                }
            });
            vStringBuilder(vSearchParams);

            if(chk_restrictions_return(23) && !chk_restrictions_return(24) && !$scope.post_right) {
                $scope.resultDataAttributes.scrollMoreFlag = true; //means that more data should not be fetched due to restrictions
                $scope.showRestrictedCard = true;
            }
            $scope.search_data_unchanged = angular.copy($scope.search_data);
            as_upgrade(1000);
        }
        
        function check_fp_params() {
            if(!$scope.searchInitialData || !$scope.searchInitialData.fp || !$scope.searchInitialData.fp.filters)
                return;
            for (var field in search_data.fields) {
                if ($scope.searchInitialData.fp.filters.hasOwnProperty(field)) {
                    // if(search_data.fields[field].singleSearch){ 
                        search_data.fields[field].hidden_due_to_fp=true;
                    // }
                }
            }
        }

        function registerAnalytics(first, second, third) {
            if(!$scope.options || !$scope.options.view || $scope.options.view.name!="directory") return;

            if(second=="query_string")second=$scope.displayName;
            if(third=="active_fields"){
                third='';
                angular.forEach($scope.enableFields, function(value, key) {
                    third=third+':'+value;
                });
            }
            analytics.event(''+first+','+second+','+third+'');
        }

        function setMouseScroll() {
            var slider = document.querySelector('#adminResultsDiv');
            if(!slider){
                return;
            }
            // slider.style.cursor = "grab";
            var startX;
            var scrollLeft;
            var mouseClick = false;
            slider.addEventListener('mousedown', function (e) {
              slider.style.cursor = "grabbing";
              mouseClick = true;
              startX = e.pageX - slider.offsetLeft;
              scrollLeft = slider.scrollLeft;
            });

            slider.addEventListener('mouseup', function (e) {
              slider.style.cursor = 'unset';
              mouseClick = false;
            });

            slider.addEventListener('mousemove', function (e) {
              if(!mouseClick)
                return;
              e.preventDefault();
              var x = e.pageX - slider.offsetLeft;
              var walk = (x - startX) * 3; //scroll-fast
              slider.scrollLeft = scrollLeft - walk;
            });
        }

        function changeAllFiltersLim(value) {
            $scope.limitFilters = value;
        }


        //Functions

        function changeviewmode() {

            if(!$scope.options || !$scope.options.enableViewMode) {
                console.log('view mode not enabled. $scope.options.enableViewMode',$scope.options.enableViewMode);
                return;
            }

            as_upgrade(100);
            var _search_data = angular.copy($scope.search_data_unchanged);

            if($scope.current_view_mode=='admin'){
                $scope.current_view_mode = 'user';
                $scope.search_data.fields = Object.keys(_search_data.fields).reduce(function(p,c) {
                    var v = _search_data.fields[c];
                    if(angular.isDefined(v.emptySearching)){
                        v.emptySearching = false;
                    }
                    if(v.restrictionFunctions && v.restrictionFunctions.constructor==Array && v.restrictionFunctions.length>0) {
                        for (var i = 0; i < v.restrictionFunctions.length; i++) {
                            if(v.restrictionFunctions[i](c,v)) {
                                return p;
                            }
                        }
                    }

                    if(!angular.isDefined(v.isprivateField) || v.isprivateField==false){
                        p[c]=v;
                    }
                    return p;
                },{});

            }
            else{
                $scope.current_view_mode = 'admin';
                $scope.search_data.fields = Object.keys(_search_data.fields).reduce(function(p,c) {
                    var v = _search_data.fields[c];
                    if(angular.isDefined(v.emptySearching)){
                        v.emptySearching = true;
                    }
                    if(v.restrictionFunctions && v.restrictionFunctions.constructor==Array && v.restrictionFunctions.length>0) {
                        for (var i = 0; i < v.restrictionFunctions.length; i++) {
                            if(v.restrictionFunctions[i](c,v)) {
                                return p;
                            }
                        }
                    }
                    p[c] = v;
                    return p;
                },{});
                
            }
            check_fp_params();
            resetUpdateCount();
            vResetAll();
            
        }

        $scope.isFormField = function(field) {
            if($scope.formFieldsConfig){
                if(angular.isDefined($scope.formFieldsConfig[field])){
                    return true;
                }else{
                    return false;
                }
            }else{
                return false;
            }
        }
        $scope.expand_category=function(category){
            if($scope.info.expanded[category]){
                delete $scope.info.expanded[category]
            }
            else{
                $scope.info.expanded[category]=true;   
            }
            angular.forEach($scope.search_data.fields,function(field){
                if(field['entity_info']==category){
                    field.category_hidden=!field.category_hidden;
                }
            });
            as_upgrade(100);
        }

        function isfieldEnabled(field){
            if($scope.enableFields){
                if($scope.enableFields.indexOf(field)>=0){
                    return true;
                }else{
                    return false;
                }
            }else{
                return false;
            }
        }


        function changeDefaultFields(field){
            // if($scope.options.view.name=='directory' && $scope.options.view.availabeFields.indexOf(field)>=0){
            //     var elem1 = document.querySelector("#"+field+"_view");
            //     elem1.checked = true;
            //     var elem2 = document.querySelector("#"+field+"_view_label");
            //     elem2.classList.add("is-checked");
            //     as_upgrade(10);
            //     return;
            // }
            $scope.options.savingViewConfig=true;

            var status='enabled';

            if($scope.enableFields.indexOf(field)>=0){
                $scope.enableFields.splice($scope.enableFields.indexOf(field),1);
                status='disabled';
            }
            else{
                $scope.enableFields.push(field);
            }

            if($scope.options && $scope.options.view && $scope.options.view.name=="directory"){
                registerAnalytics('search_view_btn_update', $scope.displayName, field+':'+status);
            }

            $scope.disabledFields=[];
            angular.forEach($scope.availabeFields,function(val,key){
                if($scope.enableFields.indexOf(val.field)<0){
                    $scope.disabledFields.push(val.field);
                }
            });

            try{$scope.reportingFun.viewFieldChange({enableFields:$scope.enableFields,disableFields:$scope.disabledFields});}
            catch(e){}

            if($scope.options && $scope.options.view && $scope.options.view.name && angular.isDefined($scope.options.view.doNotSaveFieldConfig) && $scope.options.view.doNotSaveFieldConfig==true)
                return;

            var data={"meta_option" : "SEARCH_VIEWS"};
            $http.post('./admin/get_meta', data).then(function(res) {
                if(res && res.data && res.data.success && res.data.success==1){
                    if(!res.data.data || !angular.isDefined(res.data.data[$scope.options.view.name])){
                        if(!res.data.data)
                            res.data.data={};

                        res.data.data[$scope.options.view.name]={
                            "enabled": true,
                            "desktop":{
                              "disabled_fields": []    
                            },
                            "mobile":{
                              "disabled_fields": []    
                            }
                        };
                    }

                    if($rootScope.isMobile){
                        res.data.data[$scope.options.view.name]['mobile']['disabled_fields']=$scope.disabledFields;
                    }else{
                        res.data.data[$scope.options.view.name]['desktop']['disabled_fields']=$scope.disabledFields;
                    }
                    var setData = {
                        meta_code: 69,
                        meta_value:  res.data.data
                    }; 
                    $http.post('./admin/set_meta', setData).then(function(res) {
                         if(res && res.data && res.data.success && res.data.success==1){
                            $scope.options.savingViewConfig=false;
                         }else{
                            $scope.options.savingViewConfig=false;
                         }
                    });  

                }else{
                    $scope.options.savingViewConfig=false;
                }
            });

        }

        function close() {
            try{ $scope.closeModalFun.close(); }
            catch(e){}
        }

        function intialiseSearch() {
            searchInitials.stream = 1;
            $scope.resultDataAttributes.scrollMoreFlag = false;
            $scope.resultProfiles = [];
        }

        function searchFilterModal() {
            ModalService.showModal({
                templateUrl: './templates/directives/search/searchFilterModal.html',
                controller: "search-filter-modal-ctrl",
                inputs: {
                    searchInitialData: $scope.searchInitialData,
                    options: angular.merge(angular.copy($scope.options||{}),{noCheckBoxNeeded:true,countOnly:true})
                },
                target: document.body
            }).then(function(modal) {
                modal.close.then(function(data) {
                    console.log('modal.close.then',data);
                    if (data) {
                        $scope.searchInitialDataModal = {dataParams:data};
                        $scope.options.setFormFields = false;
                        vSearchParams = {}
                        initDataBind();
                        $scope.showFilterWhileEmpty = true;
                    } else {
                        console.log("no list selected");
                    }
                });
            });
        }

        function initial_expand_category(vSearchParams){
            var entities_to_expand=[];
            angular.forEach($scope.search_data.categories, function(category){
                if(vSearchParams.emptyResponse && vSearchParams.emptyResponse.indexOf(category.form_id) !== -1) {
                    if(entities_to_expand.indexOf(category.displayName)==-1)
                        entities_to_expand.push(category.displayName);
                }
                if(vSearchParams.nonEmptyResponse && vSearchParams.nonEmptyResponse.indexOf(category.form_id) !== -1) {
                    if(entities_to_expand.indexOf(category.displayName)==-1)
                        entities_to_expand.push(category.displayName);
                }
            });
            for(var field in $scope.search_data.fields){
                if(vSearchParams[field]){
                    if($scope.search_data.fields[field]['entity_info']){
                        if(entities_to_expand.indexOf($scope.search_data.fields[field]['entity_info'])==-1){
                            entities_to_expand.push($scope.search_data.fields[field]['entity_info']);
                        }
                    }
                }
            }                
            angular.forEach(entities_to_expand,function(ex){
                $scope.expand_category(ex);
            });            
        }

        function setCheckboxesFromDropdownList() {
            $scope.search_data.fields = Object.keys($scope.search_data.fields).reduce(function(p,c) {
                var v = $scope.search_data.fields[c];
                p[c] = v;
                if(v.vCheckboxes || !v.futherSearchParams || !v.futherSearchParams.dropdownList || v.singleSearch) {
                    return p;
                }
                v.vCheckboxes = v.futherSearchParams.dropdownList.reduce(function(p2,v2,i) {
                    if(i>4) return p2;
                    p2[v2[v.futherSearchParams.serviceIdField]] = {count:0,id:v2[v.futherSearchParams.serviceIdField],name:v2[v.futherSearchParams.serviceNameField]};
                    return p2;
                },{});
                return p;
            },{});
            initial_expand_category(vSearchParams);
            for (var field in $scope.search_data.fields) {
                var v = $scope.search_data.fields[field];
                if(v.futherSearchType==='inputBox'|| v.futherSearchType==='inputBox1'|| v.futherSearchType==='dropdown' || v.singleSearch) {
                    if (angular.isDefined(vSearchParams[field]) && typeof vSearchParams[field] === 'object' && vSearchParams[field].constructor === Array) {
                        for (var i = 0; i < vSearchParams[field].length; i++) {
                            if(!v.displayName) v.displayName = field;
                            var selectedData = {
                                name: v.displayName + ": " + vSearchParams[field][i],
                                id: vSearchParams[field][i]
                            }
                            if (v.futherSearchType==='dropdown') {
                                var found_name = false;
                                if(v.futherSearchParams && angular.isArray(v.futherSearchParams['dropdownList'])){
                                    angular.forEach(v.futherSearchParams['dropdownList'], function(obj, index){
                                        if(!found_name && obj[v.futherSearchParams['serviceIdField']]==vSearchParams[field][i])
                                            found_name = obj[v.futherSearchParams['serviceNameField']];
                                    });
                                }
                                selectedData.name = found_name || vSearchParams[field][i];
                            }
                            vAddcheckbox(selectedData, field, {
                                justAdd: true
                            });
                        }
                        if (v.futherSearchType==='inputBox' || v.futherSearchType==='inputBox1') {
                            $scope.search_data.fields[field].futherSearchParams.textSelected = vSearchParams[field][0];
                        }
                        else if(v.singleSearch && v.futherSearchParams && v.futherSearchParams.dropdownList) {
                            for (var j in v.futherSearchParams.dropdownList) {
                                if(v.futherSearchParams.dropdownList[j].id == vSearchParams[field][0]) {
                                    $scope.search_data.fields[field].futherSearchParams.fullSelected = v.futherSearchParams.dropdownList[j];
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }

        function searchDataInit(dontRunPreqFn) {
            var toRemoveFields = [];
            angular.forEach($scope.search_data.categories, function(field_categories) {
                angular.forEach(field_categories.fields, function(this_field,key) {
                    if(!$scope.search_data.fields[this_field]) {
                        toRemoveFields.push(this_field);
                    }
                });
            });

            for (var i in $scope.search_data.categories) {
                for (var j in toRemoveFields) {
                    if($scope.search_data.categories[i].fields.indexOf(toRemoveFields[j])!==-1) {
                        $scope.search_data.categories[i].fields.splice($scope.search_data.categories[i].fields.indexOf(toRemoveFields[j]),1);
                    }
                }
            }

            console.log('$scope.search_data.categories',angular.copy($scope.search_data.categories),toRemoveFields);
            angular.forEach($scope.search_data.categories, function(field_categories) {
                if(field_categories.form_id &&
                    (($scope.search_data.dataParams.emptyResponse && $scope.search_data.dataParams.emptyResponse.indexOf(field_categories.form_id) > -1) ||
                    ($scope.search_data.dataParams.nonEmptyResponse && $scope.search_data.dataParams.nonEmptyResponse.indexOf(field_categories.form_id) > -1))
                ){
                    if($scope.search_data.dataParams.emptyResponse && $scope.search_data.dataParams.emptyResponse.indexOf(field_categories.form_id) > -1) {
                        if(!vSearchParams.emptyResponse) vSearchParams.emptyResponse = [];
                        vSearchParams.emptyResponse.push(field_categories.form_id);
                    } 
                    if($scope.search_data.dataParams.nonEmptyResponse && $scope.search_data.dataParams.nonEmptyResponse.indexOf(field_categories.form_id) > -1) {
                        if(!vSearchParams.nonEmptyResponse) vSearchParams.nonEmptyResponse = [];
                        vSearchParams.nonEmptyResponse.push(field_categories.form_id);
                    } 
                }

                angular.forEach(field_categories.fields, function(this_field,key) {
                    if (angular.isDefined($scope.search_data.dataParams) && typeof $scope.search_data.dataParams[this_field] !== 'undefined') {
                        vSearchParams[this_field] = [];
                        if ([String,Number].indexOf($scope.search_data.dataParams[this_field].constructor) !== -1) {
                            vSearchParams[this_field].push($scope.search_data.dataParams[this_field]);
                        } else {
                            vSearchParams[this_field] = $scope.search_data.dataParams[this_field];
                        }
                    }
                    //don't change position of this loop as certain preq functions are dependent on vSearchParams
                    if (angular.isDefined($scope.search_data.fields[this_field].preqFunctions) && !dontRunPreqFn) {
                        angular.forEach($scope.search_data.fields[this_field].preqFunctions, function(curFunction) {
                            curFunction.fName(this_field, curFunction);
                        });
                    }

                });
            });
        }

        function getDropdownValues(field, fParams) {
            return sidetopHttp.postDataCall(fParams.serviceLink, fParams.paramsToSend, getDropdownSuccess);

            function getDropdownSuccess(response) {
                var fData = response;
                if(fParams.dropdownProcess){
                    fData = fParams.dropdownProcess(fData);
                }
                var data_present = true;
                if (angular.isUndefined(fParams.expectedSchema)) {
                    fParams.expectedSchema = [];
                }
                for (var i in fParams.expectedSchema) {
                    if (angular.isDefined(fData[fParams.expectedSchema[i]])) {
                        fData = fData[fParams.expectedSchema[i]];
                    } else {
                        data_present = false;
                    }
                }
                if(fParams.removeIfNoData && !data_present) {
                    delete $scope.search_data.fields[field];
                    searchDataInit(true);
                    return;
                }

                if(fParams.changeToAutocomplete)
                    $scope.search_data.fields[field].localautocomplete.data.dataSource.data = fData;
                else
                    $scope.search_data.fields[field].futherSearchParams.dropdownList = fData;
                return fData;

            }
        }

        function processDegreeDropdown(data) {
            var data_final = {};
            data_final.data = [];
            if(!data || !data.data || !data.data.length)
                return data;
            angular.forEach(data.data,function(value,key) {
                if(value.id && value.degree)
                    data_final.data.push({id: value.id , name: value.degree});
            });
            return data_final;
        }

        function processDepartmentDropdown(data) {
            var data_final = {};
            data_final.data = [];
            if(!data || !data.data || !data.data.length)
                return data;
            angular.forEach(data.data,function(value,key) {
                if(value.id && value.department)
                    data_final.data.push({id: value.id , name: value.department});
            });
            return data_final;
        }

        function processSpecializationDropdown(data) {
            var data_final = {};
            data_final.data = [];
            if(!data || !data.data || !data.data.length)
                return data;
            angular.forEach(data.data,function(value,key) {
                if(value.id && value.specialization)
                    data_final.data.push({id: value.id , name: value.specialization});
            });
            return data_final;
        }

        function getImportData(field, fParams) {
            return sidetopHttp.postDataCall(fParams.serviceLink, fParams.paramsToSend, getImportDataSuccess);

            function getImportDataSuccess(response) {

                var fData = [];
                var data_present = true;
                if(response && response.success!=0){
                    angular.forEach(response.data, function(val,key) {
                        fData.push({
                            id: val.id,
                            name: val.import_name
                        });
                    });
                }
                if(fData.length==0){
                    data_present = false;
                }
                else
                    $scope.search_data.fields[field].localautocomplete.data.dataSource.data = fData;
                    // $scope.search_data.fields[field].futherSearchParams.dropdownList = fData;
                
                if(fParams.removeIfNoData && !data_present) {
                    delete $scope.search_data.fields[field];
                    searchDataInit(true);
                }
                return fData;
            }
        }
        // function to fetch the options for dropdown
        function getVoteOptions(field,arg) {
            if(arg && arg.votes_displayOpt && Object.keys(arg.votes_displayOpt).length==0){
                $scope.search_data.fields[field].futherSearchParams.dropdownList=[];
                return;
            }
            var data = arg.votes_displayOpt;
            $http.post('./noticeboard_actions_c/getVoteList',data).then(function(res)
            {
                if(res && res.data && res.data.data && res.data.success && res.data.success==1){
                    var fData=[];
                    // fData.push({
                    //     id: 'ignore',
                    //     name: '',
                    //     dName: 'Filter by poll options'
                    // });
                    angular.forEach(res.data.data,function(val,key) {
                        fData.push({
                            id: parseInt(val.id),
                            name: val.content,
                            dName: val.content
                        });
                    });
                    $scope.search_data.fields[field].futherSearchParams.dropdownList=fData;     
                }
            });
        }

        function getMailFeedbackCounts(field,arg) {
            var data= {category:arg.mail_subscriptionCat};
             $http.post('./admin/getMailFeedbackCounts', data).then(function(res) {
                 if(res && res.data && res.data.data && res.data.success && res.data.success==1){
                    var fData=[];

                    fData.push({
                        id: 'ignore',
                        name: '',
                        dName: 'Filter by user feedback',
                    });

                    angular.forEach(res.data.data,function(val,key) {
                        fData.push({
                            id: parseInt(key),
                            name: val.name,
                            dName: val.name + "("+(val.count?val.count:0)+")",
                        });
                    });
                    $scope.search_data.fields[field].futherSearchParams.dropdownList=fData;
                 }
            }); 
        }

        function autocompleteSelected(selectedData, field) {
            vAddcheckbox(selectedData, field);
            $scope.search_data.fields[field].futherSearchParams.idSelected = -1; //again intialising to -1
            $scope.search_data.fields[field].futherSearchParams.textSelected = ''; //emptying the text field

        }

        function multipleFilterDropdownOnChange(selectedData, field,source){
            if(source == "date"){
                $scope.customDate.date = selectedData.name;
            }
            if(source == "month"){
                $scope.customDate.month = selectedData.value;
                $scope.customDate.monthName = selectedData.name;
            }
            if(angular.isDefined($scope.customDate.date) && angular.isDefined($scope.customDate.month)){
                $scope.search_data.fields[field].futherSearchParams.fullSelected.value = [];
                $scope.search_data.fields[field].futherSearchParams.fullSelected.value.push($scope.customDate);
                $scope.customDate = {};
                filterDropdownOnChange(selectedData, field);
            }
        }

        function filterDropdownOnChange(selectedData, field) {
            if(chk_restrictions_return(23) && !$scope.post_right)
            {
                if(!chk_restrictions_return(24)){
                    showRestrictionModal();
                }

            }
            else{
                if(selectedData.value && selectedData.value.length && selectedData.value[0].to_date && selectedData.value[0].from_date)
                    setDateInSearchParams(field,selectedData.value,null,'from-to');
                else if($scope.search_data.fields[field].futherSearchType == 'dropdown' && selectedData.dateSelector && selectedData.dateSelector.enabled && selectedData.dateSelector.type!='to'){
                    $scope.search_data.fields[field].futherSearchParams.dropdownList[selectedData.id].dateSelector.show = true;
                }
                else
                    vAddcheckbox(selectedData, field);
            }
        }

        function inputBoxSelected(selectedData, field) {
            if(field=='name' && $scope.options && $scope.options.view && $scope.options.view.name=="directory"){
                var currUser='user';
                if($rootScope.app_data.isAdmin){
                    currUser='admin';
                }
                registerAnalytics('search', 'keyword_text_'+currUser, selectedData);
            }

            if(chk_restrictions_return(23) && !$scope.post_right)
            {
                if(!chk_restrictions_return(24)){
                    showRestrictionModal();
                }

            }
            else{
            var v = $scope.search_data.fields[field];
            if(!v.displayName) v.displayName = field;
            var selectedData = {
                name: v.displayName + ": " + selectedData,
                id: selectedData
            }
            if(v.extraRadioData){
                angular.forEach(v.extraRadioData,function(val,key) {
                    if(val.id==selectedData.id)
                        selectedData.name = v.displayName + " " + val.name;
                });
            }
            vAddcheckbox(selectedData, field);
            $scope.showFilterWhileEmpty = true;
            }
        }
      
        function resetAllVisible() {
            if ($scope.queryString != null && !$scope.isEmpty) {
                var index=0;
                if($scope.searchInitialData && $scope.searchInitialData.fp && $scope.searchInitialData.fp.filters){
                    angular.forEach($scope.queryString, function(q, i) {
                        if (q.id && !isObject(q.id)) {
                            if(!$scope.searchInitialData.fp.filters[q.key]){
                                    index=i;
                            }
                        }
                        else{
                            index=1;
                        }

                    });
                }
                else{
                    index=1;
                }
                
               if(index>0){
                    return true;
               }
            }
            return false;
        }



        function vAddcheckbox(selectedData, field, options) {
            if($scope.options && $scope.options.transferInfo)
                $scope.options.transferInfo.fetchingCnt = true;
            if(angular.isDefined(selectedData.empty)){
                    $scope.vBoxChanged(selectedData, field);
            }
            else if(isArray(selectedData)){
                $scope.vBoxChanged(selectedData, field);
            }
            else{
            var cData = {
                id: isScalar(selectedData)?selectedData:selectedData[$scope.search_data.fields[field].futherSearchParams.serviceIdField],
                name: isScalar(selectedData)?selectedData:selectedData[$scope.search_data.fields[field].futherSearchParams.serviceNameField],
                checked: (options && options.checked)===false?false:true,
                count: 0
            };
            if(selectedData.count){
                cData.count=selectedData.count;
            }
            if (angular.isUndefined($scope.search_data.fields[field].vCheckboxes) || (!$scope.search_data.fields[field].multiSearchWithChip && $scope.search_data.fields[field].singleSearch)) {
                $scope.search_data.fields[field].vCheckboxes = {};
            }
            $scope.search_data.fields[field].vCheckboxes[cData.id] = cData; //defining checkbox variable
            callvBoxChanged();
            

            function callvBoxChanged() {
                if (angular.isUndefined(options) || !options.justAdd) {
                    $scope.vBoxChanged(cData.id, field); //calling function to get data based on this checkbox change
                } else {
                    return cData;
                }
            }
            }
        }

        function entityEmptyChanges(selectedData, entity) {
            if(chk_restrictions_return(23) && !$scope.post_right)
            {
                if(!chk_restrictions_return(24)){
                    showRestrictionModal();
                    return;
                }
            }
            else{
                as_upgrade(10);

                if(angular.isObject(selectedData)){
                    var category = $scope.search_data.categories.find(function (cat) {
                        return cat.form_id == entity.form_id;
                    });

                    if(angular.isDefined(selectedData.empty)){
                        if(selectedData.empty) {
                            if(!vSearchParams.emptyResponse) vSearchParams.emptyResponse = [];
                            if(vSearchParams.emptyResponse.indexOf(entity.form_id) === -1) vSearchParams.emptyResponse.push(entity.form_id);
                            if(vSearchParams.nonEmptyResponse && vSearchParams.nonEmptyResponse.indexOf(entity.form_id) !== -1)
                                vSearchParams.nonEmptyResponse.splice(vSearchParams.nonEmptyResponse.indexOf(entity.form_id), 1);
                        }
                        if(!selectedData.empty) {
                            if(!vSearchParams.nonEmptyResponse) vSearchParams.nonEmptyResponse = [];
                            if(vSearchParams.nonEmptyResponse.indexOf(entity.form_id) === -1) vSearchParams.nonEmptyResponse.push(entity.form_id);
                            if(vSearchParams.emptyResponse && vSearchParams.emptyResponse.indexOf(entity.form_id) !== -1)
                                vSearchParams.emptyResponse.splice(vSearchParams.emptyResponse.indexOf(entity.form_id), 1);
                        }

                        // Remove all field's filters of this entity
                        if(vSearchParams.form && !isEmpty(vSearchParams.form.fields)) {
                            angular.forEach(category.fields, function(field) {
                                if(vSearchParams[field]) delete vSearchParams[field];
                                angular.forEach($scope.search_data.fields[field].vCheckboxes,function(value,key) {
                                    if(value['checked']) delete value['checked'];
                                });
                            });
                            delete vSearchParams.form.fields;
                        }
                    }
                }
                else if(entity == 'emptyResponse' || entity == 'nonEmptyResponse') {               
                    if(entity == 'emptyResponse') {
                        if(vSearchParams.form) {
                            delete vSearchParams['form']['emptyResponse'][selectedData];
                            vSearchParams.form.form_id.splice(vSearchParams.form.form_id.indexOf(selectedData), 1);
                        }    
                        vSearchParams.emptyResponse.splice(vSearchParams.emptyResponse.indexOf(selectedData), 1);
                        var elem1 = document.querySelector("#isempty_"+selectedData+"_label");
                        elem1.classList.remove("is-checked");
                    }
                    else if(entity == 'nonEmptyResponse') {
                        if(vSearchParams.form) {                            
                            delete vSearchParams['form']['nonEmptyResponse'][selectedData];
                            vSearchParams.form.form_id.splice(vSearchParams.form.form_id.indexOf(selectedData), 1);
                        }
                        vSearchParams.nonEmptyResponse.splice(vSearchParams.nonEmptyResponse.indexOf(selectedData), 1);
                        var elem2 = document.querySelector("#isnotempty_"+selectedData+"_label");
                        elem2.classList.remove("is-checked");
                    }
                    as_upgrade(10);          
                }

                if(angular.isDefined($scope.num_deleted))
                    $scope.num_deleted = 0;
                if(angular.isDefined($scope.num_edited)){
                    $scope.num_edited = 0;
                    $scope.searchLangData.profileUpdCount = 0;
                }
                if(angular.isDefined($scope.num_selected)){
                    $scope.num_selected = 0;
                    $scope.searchLangData.profileSelCount = 0;
                }
                if(angular.isDefined($scope.allSelected))
                    $scope.allSelected = 0;
                if(angular.isDefined($scope.adminErrorMessage))
                    $scope.adminErrorMessage = "";
                postCheckboxAndParams(vSearchParams);
            }
        }

        function vBoxChanged(id, field, dont_open_drawer) {
            if(chk_restrictions_return(23) && !$scope.post_right)
            {
                if(!chk_restrictions_return(24)){
                    showRestrictionModal();
                    return;
                }
            }
            else{
            as_upgrade(10);
            // if (angular.isUndefined(dont_open_drawer) || !dont_open_drawer) {
            //     $scope.toggleDrawer();
            // }
            // var results_top = results_top_div.getBoundingClientRect().top + window.pageYOffset;
            // scrollTo(results_top - 150, 100);
            if(angular.isObject(id)){
                if(id.isEmpty)
                    delete vSearchParams[field]['isEmpty'];
                else if(id.isNotEmpty)
                    delete vSearchParams[field]['isNotEmpty'];
                if(angular.isDefined(id.empty)){
                    if(id.empty)
                        vSearchParams[field] = {isEmpty:true};
                    if(!id.empty)
                        vSearchParams[field] = {isNotEmpty:true};
                    angular.forEach($scope.search_data.fields[field].vCheckboxes,function(value,key) {
                        if(value['checked'])
                            delete value['checked'];
                    });
                }
                if(!$scope.search_data.fields[field].multiSearchWithChip && id!=[] && !angular.equals({},id) && angular.isUndefined(id.isEmpty) && angular.isUndefined(id.isNotEmpty) && angular.isUndefined(id.empty)){
                    vSearchParams[field] = id;
                    angular.forEach($scope.search_data.fields[field].vCheckboxes,function(value,key) {
                        if(!value['checked'] && id.indexOf(value.id)>=0)
                            value['checked'] = true;
                    });
                }
            }
            else{
            if ((!$scope.search_data.fields[field].multiSearchWithChip && $scope.search_data.fields[field].singleSearch) || (angular.isDefined(vSearchParams[field]) && angular.equals({},vSearchParams[field]))) {
                vSearchParams[field] = [];
            }
            if ($scope.search_data.fields[field].vCheckboxes[id]["checked"] === true /*checked*/ ) {
                if (angular.isUndefined(vSearchParams[field])) {
                    vSearchParams[field] = [];
                }
                if($scope.search_data.fields[field].emptySearching){
                    if(vSearchParams[field].isEmpty){
                        var elem1 = document.querySelector("#is_"+field+"_label");
                        elem1.classList.add("is-checked");
                        var elem2 = document.querySelector("#isempty_"+field+"_label");
                        elem2.classList.remove("is-checked");
                        delete vSearchParams[field]['isEmpty'];
                        vSearchParams[field] = [];
                    }
                    if(vSearchParams[field].isNotEmpty){
                        var elem1 = document.querySelector("#is_"+field+"_label");
                        elem1.classList.add("is-checked");
                        var elem2 = document.querySelector("#isnotempty_"+field+"_label");
                        elem2.classList.remove("is-checked");
                        delete vSearchParams[field]['isNotEmpty'];
                        vSearchParams[field] = [];
                    }
                }
                if (vSearchParams[field].indexOf(id) == -1 /*checking if this checkbox was already checked.. just being safe*/ ) {
                    var isEmpty = false;
                    if(typeof id == 'string' && id == '') isEmpty = true;
                    if(!isEmpty && field == "dob"){
                        var obj = {};
                        obj.index = vSearchParams[field].length;
                        obj.month = $scope.search_data.fields[field].futherSearchParams.fullSelected.value[0].month;
                        obj.monthName = $scope.search_data.fields[field].futherSearchParams.fullSelected.value[0].monthName;
                        obj.date = $scope.search_data.fields[field].futherSearchParams.fullSelected.value[0].date || 0;
                        if(!obj.date) delete obj.date;
                        vSearchParams[field].push(obj);
                    }
                    else if(!isEmpty) vSearchParams[field].push(id);
                    var category = $scope.search_data.categories.find(function (cat) {
                        return cat.displayName == $scope.search_data.fields[field]['entity_info'];
                    });
                    if(category && category.form_id) {
                        var elem1 = document.querySelector("#isempty_"+category.form_id+"_label");
                        elem1.classList.remove("is-checked");
                        var elem2 = document.querySelector("#isnotempty_"+category.form_id+"_label");
                        elem2.classList.remove("is-checked");
                        if(vSearchParams.emptyResponse && vSearchParams.emptyResponse.indexOf(category.form_id) !== -1)
                            vSearchParams.emptyResponse.splice(vSearchParams.emptyResponse.indexOf(category.form_id), 1);
                        if(vSearchParams.nonEmptyResponse && vSearchParams.nonEmptyResponse.indexOf(category.form_id) !== -1)
                            vSearchParams.nonEmptyResponse.splice(vSearchParams.nonEmptyResponse.indexOf(category.form_id), 1);
                        as_upgrade(10);
                    }
                }
            } else { //checkbox unchecked
                vSearchParams[field].splice(vSearchParams[field].indexOf(id), 1);
                if(angular.isDefined(vSearchParams[field].length) && vSearchParams[field].length==0){
                    // $scope.search_data.fields[field].isShown = false;
                    $scope.availabeFields = $scope.availabeFields.filter(function(value,index) {
                        if($scope.options.view.availabeFields.indexOf(field)<0)
                            return value.field!=field;
                        else
                            return value.field;
                    });
                    if($scope.enableFields.indexOf(field)!=-1 && ((angular.isDefined($scope.options.view.default_fields) && $scope.options.view.default_fields.indexOf(field) < 0) 
                        || !angular.isDefined($scope.options.view.default_fields)))
                        $scope.enableFields.splice($scope.enableFields.indexOf(field),1);
                }
                if ($scope.search_data.fields[field].futherSearchType=="inputBox") {
                    $scope.search_data.fields[field].futherSearchParams.textSelected = '';
                }
            }
            }
            if(angular.isDefined($scope.num_deleted))
                $scope.num_deleted = 0;
            if(angular.isDefined($scope.num_edited)){
                $scope.num_edited = 0;
                $scope.searchLangData.profileUpdCount = 0;
            }
            if(angular.isDefined($scope.num_selected)){
                $scope.num_selected = 0;
                $scope.searchLangData.profileSelCount = 0;
            }
            if(angular.isDefined($scope.allSelected))
                $scope.allSelected = 0;
            if(angular.isDefined($scope.adminErrorMessage))
                $scope.adminErrorMessage = "";
            postCheckboxAndParams(vSearchParams);
            }
        }

        function setDateInSearchParams(field,preset_values,removeFilter,source) {
            if($scope.options && $scope.options.transferInfo)
                $scope.options.transferInfo.fetchingCnt = true;
            if(chk_restrictions_return(23))
            {
                if(!chk_restrictions_return(24)){
                    showRestrictionModal();
                    return;
                }
            }
            else{
            as_upgrade(10);
            if(angular.isDefined(vSearchParams[field]) && source && !removeFilter){
                if($scope.search_data.fields[field].futherSearchParams.dateSelected.from && source!='from-to')
                    $scope.search_data.fields[field].futherSearchParams.dateSelected.from = '';
                if($scope.search_data.fields[field].futherSearchParams.dateSelected.to && source!='from-to' && source!='to')
                    $scope.search_data.fields[field].futherSearchParams.dateSelected.to = '';
                if($scope.search_data.fields[field].futherSearchParams.dateSelected.on && source!='on')
                    $scope.search_data.fields[field].futherSearchParams.dateSelected.on = '';
            }
            if (angular.isUndefined(vSearchParams[field]) || $scope.search_data.fields[field].singleSearch) {
                vSearchParams[field] = {};
            }
            if($scope.search_data.fields[field].futherSearchParams.dateSelected.from && $scope.search_data.fields[field].futherSearchParams.dateSelected.to){
                vSearchParams[field].from = $scope.search_data.fields[field].futherSearchParams.dateSelected.from;
                vSearchParams[field].to = $scope.search_data.fields[field].futherSearchParams.dateSelected.to;
                vSearchParams[field].from = $filter('date')($scope.search_data.fields[field].futherSearchParams.dateSelected.from, "dd-MM-yyyy");
                vSearchParams[field].to = $filter('date')($scope.search_data.fields[field].futherSearchParams.dateSelected.to, "dd-MM-yyyy");
                if($scope.search_data.fields[field].futherSearchParams.dateSelected.rev)
                    vSearchParams[field].rev = $scope.search_data.fields[field].futherSearchParams.dateSelected.rev;

            }
            else if($scope.search_data.fields[field].futherSearchParams.dateSelected.on){
                vSearchParams[field].on = $scope.search_data.fields[field].futherSearchParams.dateSelected.on;
                vSearchParams[field].on = $filter('date')($scope.search_data.fields[field].futherSearchParams.dateSelected.on, "dd-MM-yyyy");
            }
            else if(angular.isDefined(preset_values) && isArray(preset_values) && preset_values[0].from_date && preset_values[0].to_date){
                // $scope.search_data.fields[field].futherSearchParams.dateSelected.from = new Date(preset_values[0].from_date);

                // console.log($scope.search_data.fields[field].futherSearchParams.dateSelected.from);
                vSearchParams[field].from = preset_values[0].from_date;
                vSearchParams[field].to = preset_values[0].to_date;
            }
            else if(angular.isDefined(vSearchParams[field]) && !removeFilter){
                // $scope.search_data.fields[field].futherSearchParams.dateSelected.from = '';
                // vSearchParams[field].push($scope.search_data.fields[field].futherSearchParams.dateSelected.from);
                $scope.search_data.fields[field].futherSearchParams.dateSelected.to = $filter('date')(new Date().setDate(new Date().getDate() + 1),'dd-MM-yyyy');
                // vSearchParams[field].to = $filter('date')(new Date().setDate(new Date().getDate() + 1),'dd-MM-yyyy');
                vSearchParams[field].to = 0;
            }

            if(angular.isDefined($scope.num_deleted))
                $scope.num_deleted = 0;
            if(angular.isDefined($scope.num_edited)){
                $scope.num_edited = 0;
                $scope.searchLangData.profileUpdCount = 0;
            }
            if(angular.isDefined($scope.num_selected)){
                $scope.num_selected = 0;
                $scope.searchLangData.profileSelCount = 0;
            }
            if(angular.isDefined($scope.allSelected))
                $scope.allSelected = 0;
            if(angular.isDefined($scope.adminErrorMessage))
                $scope.adminErrorMessage = "";
                
            postCheckboxAndParams(vSearchParams);

            }
        }

        function boxToSearchParamsMultiple(inputConf) {
            //this is not used for now. Can be used in future if we plan to search using multiple params at one go without actually searching on change in params directly 
        }

        function forceAsUpgradeOnClick(){
            as_upgrade(100);
            as_upgrade(1000);
        }

        function searchParamsToBox(searchParams, options) {
            if (vIsEmptySearch(searchParams)) {
                angular.forEach($scope.search_data.fields, function(fieldV, fieldK) {
                    angular.forEach(fieldV.vCheckboxes, function(checkVal, checkId) {
                        checkVal["checked"] = false;
                    });
                });
            } else {
                //this is temp. as of now this will never be used. can be used in future is we have search params but no checkboxes against these params
            }
        }

        function vFilterCount(searchParams) {
            var dataTosend;
            if (canceller1 != undefined) {
                canceller1.resolve();
                // console.log('request cancelled');
            }
            canceller1 = $q.defer();
            if($scope.options && $scope.options.transferInfo)
                $scope.options.transferInfo.fetchingCnt = true;    
            dataTosend = angular.copy(searchParams);
            dataTosend = Object.keys(dataTosend).reduce(function(p,k) {
                if(k == 'emptyResponse' || k == 'nonEmptyResponse') {
                    angular.forEach(p[k] , function(formId) {
                        var category = $scope.search_data.categories.find(function (cat) {
                            return cat.form_id == formId;
                        });
                        if(category.dataPreProcessors && category.dataPreProcessors.constructor==Array && category.dataPreProcessors.length>0) {
                            for (var i = 0; i < category.dataPreProcessors.length; i++) {
                                dataTosend = category.dataPreProcessors[i](dataTosend,k,category);
                            }
                        }
                    });
                }
                if($scope.search_data.fields[k]) {
                    var v = $scope.search_data.fields[k];
                    if(v.dataPreProcessors && v.dataPreProcessors.constructor==Array && v.dataPreProcessors.length>0) {
                        for (var i = 0; i < v.dataPreProcessors.length; i++) {
                            dataTosend = v.dataPreProcessors[i](dataTosend,dataTosend[k],k,v);
                        }
                    }
                }
                return p;
            },dataTosend);
            if (!dataTosend.other_params) {
                dataTosend.other_params = {};
            }
            if($scope.options && $scope.options.view && $scope.options.view.name){
                dataTosend.other_params.viewName = $scope.options.view.name;
            }

            if($scope.options && $scope.options.poll_id){
                dataTosend.other_params.poll_id = $scope.options.poll_id;
            }
            if($scope.options && $scope.options.polltable){
                dataTosend.other_params.polltable = $scope.options.polltable;
            }
            if($scope.options && $scope.options.include_demised)
                dataTosend.other_params.include_demised = $scope.options.include_demised;
            if($scope.options && $scope.options.distinctMobApps && $scope.options.distinctMobApps==true){
                dataTosend.other_params.distinctMobApps = $scope.options.distinctMobApps;
            }

            if($scope.options && $scope.options.valid_phones_only && $scope.options.valid_phones_only==true){
                dataTosend.other_params.valid_phones_only = $scope.options.valid_phones_only;
            }
            if($scope.options && $scope.options.sms_data && $scope.options.sms_data==true){
                dataTosend.other_params.sms_data = $scope.options.sms_data;
            }
            if($scope.options && $scope.options.whatsapp_message && $scope.options.whatsapp_message==true){
                dataTosend.other_params.whatsapp_message = $scope.options.whatsapp_message;
            }

            if($scope.options && $scope.options.disableAuthFilter){
                dataTosend.other_params.disableAuthFilter = $scope.options.disableAuthFilter;
            }

            if($scope.options && $scope.options.keyword_filter){
                dataTosend.other_params.keyword_filter = $scope.options.keyword_filter;
            }

            if($scope.options && $scope.options.merge_empty_yop){
                dataTosend.other_params.merge_empty_yop = $scope.options.merge_empty_yop;
            }

            // consider lost members also while getting counts, except in case it is specified not to fetch them 
            dataTosend.other_params.fetch_lost = true;
            if ($scope.search_data.fetchLost===false && $scope.current_view_mode!='admin') dataTosend.other_params.fetch_lost = false;
            if ($scope.search_data.authenticated_only && $scope.current_view_mode == 'user') dataTosend['authenticated_only'] = true;
            if ($scope.search_data.lg && $scope.current_view_mode == 'user') dataTosend['lg'] = true;
            if ($scope.search_data.membership_only && $scope.current_view_mode == 'user') dataTosend['life_membership_status'] = true;
            $scope.isFetchingSelected = true;
            $scope.filterCountCalled = true;
            if($scope.search_data.roles){
                dataTosend.other_params.roles = $scope.search_data.roles;
            }
            if($scope.search_data && $scope.search_data.isPrimary){
                dataTosend.other_params.isPrimary=true;
            }

            var configObject = {
                timeout: canceller1.promise
            };

            if($rootScope.app_data.admin_r_subinsti && subinst_array.length!=0){
                var dataTosendForSubInstCount = angular.copy(dataTosend);
                if(isEmpty(dataTosendForSubInstCount['subinst'])){
                if(subinst_array.length!=$rootScope.app_data.admin_r_subinsti.length)
                    dataTosendForSubInstCount['subinst'] = subinst_array;
                else
                    dataTosendForSubInstCount['subinst'] = {isNotEmpty: true};
                }
                else if(subinst_array && subinst_array.length!=$rootScope.app_data.admin_r_subinsti.length){
                    // send subcids only jiske right ho admin ke paas
                    if(dataTosendForSubInstCount['subinst']['isNotEmpty'])
                        dataTosendForSubInstCount['subinst'] = subinst_array;
                    else if(dataTosendForSubInstCount['subinst'].length){
                        var tmp_arr = [];
                        angular.forEach(dataTosendForSubInstCount['subinst'],function(subinst_v,subinst_k) {
                            if(subinst_array.indexOf(subinst_v)>=0)
                                tmp_arr.push(subinst_v);
                        });
                        dataTosendForSubInstCount['subinst'] = tmp_arr;
                    }
                }

                if(!isEmpty(dataTosendForSubInstCount['subinst'])){
                    if($scope.options && $scope.options.transferInfo)
                        $scope.options.transferInfo.fetchingSubInstCnt = true;
                sidetopHttp.postDataConfigCall('./search/filterCount', dataTosendForSubInstCount, configObject, filterSubinstCountSuccess).error(function() {
                    $scope.filterCountCalled = false;
                    if($scope.options && $scope.options.transferInfo){
                        $scope.options.transferInfo.fetchingSubInstCnt = false;
                        $scope.options.transferInfo.resultCountForSubInst = 0;
                    }
                });
                }
                else{
                    $scope.resultCountForSubInst = 0;
                    if($scope.options && $scope.options.transferInfo)
                        $scope.options.transferInfo.resultCountForSubInst = 0;
                }

                function filterSubinstCountSuccess(response) {
                    $scope.isFetchingSelected = false;
                    $scope.filterCountCalled = false;
                    if($scope.options && $scope.options.transferInfo)
                        $scope.options.transferInfo.fetchingSubInstCnt = false;
                    if (response.success == 1) {
                        $scope.resultCountForSubInst = response.data[0].count;
                        if($scope.options && $scope.options.transferInfo)
                            $scope.options.transferInfo.resultCountForSubInst = $scope.resultCountForSubInst;
                    }
                }

                if($scope.includeNonSubInstiUsers && (!(dataTosend['subinst'] && angular.isUndefined(dataTosend["subinst"]["isEmpty"]) && angular.isUndefined(dataTosend["subinst"]["isNotEmpty"])) || isEmpty(dataTosend['subinst']))){
                    var dataTosendForNonSubInstCount = angular.copy(dataTosend);
                    dataTosendForNonSubInstCount.other_params['nonSubInstiUsers'] = true;
                    if($scope.options && $scope.options.transferInfo)
                        $scope.options.transferInfo.fetchingNonSubInstCnt = true;
                    sidetopHttp.postDataConfigCall('./search/filterCount', dataTosendForNonSubInstCount, configObject, filterSubinstCountSuccessCb);

                    function filterSubinstCountSuccessCb(response) {
                        $scope.isFetchingSelected = false;
                        $scope.filterCountCalled = false;
                        if($scope.options && $scope.options.transferInfo)
                            $scope.options.transferInfo.fetchingNonSubInstCnt = false;
                        if (response.success == 1) {
                            $scope.resultCountForNonSubInst = response.data[0].count;
                            if($scope.options && $scope.options.transferInfo)
                                $scope.options.transferInfo.resultCountForNonSubInst = $scope.resultCountForNonSubInst;
                        }
                    }
                }
                else{
                    delete $scope.resultCountForNonSubInst;
                    if($scope.options && $scope.options.transferInfo)
                        $scope.options.transferInfo.resultCountForNonSubInst = 0;
                }
            }
            $scope.fetchingCount = true;
            return sidetopHttp.postDataConfigCall('./search/filterCount', dataTosend, configObject, filterCountSuccess);

            function filterCountSuccess(response) {
                //console.log(response);
                $scope.isFetchingSelected = false;
                $scope.filterCountCalled = false;
                if (response.success == 1) {
                    $scope.resultCount = response.data;
                    vSendAnalytics($scope.resultCount, searchParams); //this function is called from here only, put in comments everywhere else
                    $scope.searchLangData.profileCount = $scope.resultCount[0].count;
                    if($scope.resultCount[0].count < 12) $scope.resultDataAttributes.scrollMoreFlag = true;
                }
                else response.data=0;
                try{$scope.reportingFun.filterCountSuccess({displayName:$scope.displayName,response:response,dataTosend:dataTosend,api:'./search/filterCount',queryString:$scope.queryString});}
                catch(e){}
                $scope.fetchingCount = false;
            }
        }

        function vSendAnalytics(resultCount, searchParams) {
            if (!$rootScope.app_data.same_com_log)
                return;
            
            searchParams = Object.keys(searchParams).reduce(function(p,k) {
                if($scope.search_data.fields[k]) {
                    var v = $scope.search_data.fields[k];
                    if(v.dataPreProcessors && v.dataPreProcessors.constructor==Array && v.dataPreProcessors.length>0) {
                        for (var i = 0; i < v.dataPreProcessors.length; i++) {
                            searchParams = v.dataPreProcessors[i](searchParams,searchParams[k],k,v,true);
                        }
                    }
                }
                return p;
            },searchParams);
            if (new Date().getTime() - searchTrackers.sTime > 8000) {
                var analyticsData = {
                    count: resultCount[0].count,
                    params: searchParams,
                    index: searchTrackers.sNumber
                };

                return sidetopHttp.postDataCall('./search/track_searches', analyticsData, sendAnalyticsSuccess);

                function sendAnalyticsSuccess(response) {
                    searchTrackers.sNumber++;
                }

                searchTrackers.sTime = new Date().getTime();
            }
        }

        function vFetchProfiles() {
            var dataTosend = angular.copy(vSearchParams);
            // $scope.params_for_modal = angular.copy(vSearchParams);
            if (canceller != undefined) {
                canceller.resolve();
            }

            if(platform && scrollBlocking()) {
                return;
            }

            canceller = $q.defer();
            dataTosend = Object.keys(dataTosend).reduce(function(p,k) {
                if(k == 'emptyResponse' || k == 'nonEmptyResponse') {
                    angular.forEach(p[k] , function(formId) {
                        var category = $scope.search_data.categories.find(function (cat) {
                            return cat.form_id == formId;
                        });
                        if(category.dataPreProcessors && category.dataPreProcessors.constructor==Array && category.dataPreProcessors.length>0) {
                            for (var i = 0; i < category.dataPreProcessors.length; i++) {
                                dataTosend = category.dataPreProcessors[i](dataTosend,k,category);
                            }
                        }
                    });
                }
                if($scope.search_data.fields[k]) {
                    var v = $scope.search_data.fields[k];
                    if(v.dataPreProcessors && v.dataPreProcessors.constructor==Array && v.dataPreProcessors.length>0) {
                        for (var i = 0; i < v.dataPreProcessors.length; i++) {
                            dataTosend = v.dataPreProcessors[i](dataTosend,dataTosend[k],k,v);
                        }
                    }
                }
                return p;
            },dataTosend);
            $scope.resultDataAttributes.scrollMoreFlag = true; //flag that makes sure that no more values are fetched
            dataTosend["stream"] = searchInitials.stream;
            if (!dataTosend.other_params) {
                dataTosend.other_params = {};
                dataTosend.other_params.fetch_lost = false; 
            }
            if($scope.options && $scope.options.view && $scope.options.view.name){
                dataTosend.other_params.viewName = $scope.options.view.name;
            }

            if($scope.options && $scope.options.poll_id){
                dataTosend.other_params.poll_id = $scope.options.poll_id;
            }

            if($scope.options && $scope.options.polltable){
                dataTosend.other_params.polltable = $scope.options.polltable;
            }

            if($scope.options && $scope.options.include_demised)
                dataTosend.other_params.include_demised = $scope.options.include_demised;

            if($scope.options && $scope.options.distinctMobApps && $scope.options.distinctMobApps==true){
                dataTosend.other_params.distinctMobApps = $scope.options.distinctMobApps;
            }
            if($scope.options && $scope.options.valid_phones_only && $scope.options.valid_phones_only==true){
                dataTosend.other_params.valid_phones_only = $scope.options.valid_phones_only;
            }
            if($scope.options && $scope.options.sms_data && $scope.options.sms_data==true){
                dataTosend.other_params.sms_data = $scope.options.sms_data;
            }
            if($scope.options && $scope.options.whatsapp_message && $scope.options.whatsapp_message==true){
                dataTosend.other_params.whatsapp_message = $scope.options.whatsapp_message;
            }

            if($scope.options && $scope.options.disableAuthFilter){
                dataTosend.other_params.disableAuthFilter = $scope.options.disableAuthFilter;
            }

            if($scope.options && $scope.options.keyword_filter){
                dataTosend.other_params.keyword_filter = $scope.options.keyword_filter;
            }

            if($scope.options && $scope.options.merge_empty_yop){
                dataTosend.other_params.merge_empty_yop = $scope.options.merge_empty_yop;
            }
            if(($scope.search_data.fetchLost==1 || $scope.search_data.fetchLost==true) || ($scope.search_data.fetchLost==2 && !vIsEmptySearch(vSearchParams)) || $scope.current_view_mode=='admin') {
                dataTosend.other_params.fetch_lost = true;
            }

            if($scope.search_data.roles){
                dataTosend.other_params.roles = $scope.search_data.roles;
            }

            if($scope.search_data.lost)
                dataTosend.lost = true;

            if($scope.search_data.authenticated_only && $scope.current_view_mode == 'user') dataTosend.authenticated_only = true;
            if($scope.search_data.lg && $scope.current_view_mode == 'user') dataTosend.lg = true;
            if($scope.search_data.membership_only && $scope.current_view_mode == 'user') dataTosend.life_membership_status = true;
            // isFetching=true;//this variable is mainly used to send proper analytics
            var configObject = {
                timeout: canceller.promise
            };
            $scope.isFetchingSelected = true;
            if (dataTosend["stream"] == 1) {
                $scope.vResettingWaiting = true;
            }
            if (!$rootScope.app_data.same_com_log) {
                dataTosend.rnd = 0;
            }

            $scope.dataTosend4Mail = angular.copy(dataTosend);
            delete $scope.dataTosend4Mail.stream;
            delete $scope.dataTosend4Mail.rnd;
            delete $scope.dataTosend4Mail.lost;

            $scope.params_for_modal = angular.copy(dataTosend);

            try{$scope.reportingFun.fetchingProfiles({dataTosend:dataTosend,api:'./search/UserSearch'});}
            catch(e){}
            if($scope.adminNotDeleted){
                if(change_stream){
                    dataTosend['stream'] = 1;
                    searchInitials.stream = 1;
                    change_stream = false;
                }
                dataTosend['role'] = [4];
            }
            dataTosend["lm"] = 12;
            return sidetopHttp.postDataConfigCall('./search/UserSearch', dataTosend, configObject, userSearchSuccess);

            function userSearchSuccess(response) {
                if($scope.options && $scope.options.view && $scope.options.view.name=="directory"){
                    registerAnalytics('search', 'stream', searchInitials.stream);
                }
                if(!response) return;
                $scope.isFetchingSelected = false;
                if ($scope.vResettingWaiting) {
                    $scope.vResettingWaiting = false;
                };
                if (response.success == 1) {
                $scope.options.isLoaded = true;
                    $scope.resultDataAttributes.scrollMoreFlag = false; //means that there are still more values to be fetched
                    mapNetworkAndSelf(response.data);
                    $scope.resultProfiles = $scope.resultProfiles.concat(response.data);
                    searchInitials.stream++;
                } else {
                    if(response.success == 0 && response.errorcode == "LIMIT_EXCEEDED"){
                        swal({text: response.error, "title":$filter('asPortalLang')('Action_Limit_Restriction',"Access Temporary Restricted")});
                        $scope.limitSwalShown = true;
                        return;
                    }
                    $scope.resultDataAttributes.scrollMoreFlag = true; // no more values, don't call filterCount() again
                }
                if(response.success == -1 && response.error == -2) {
                    $scope.showLoginCard = true;
                }
                if($scope.options && $scope.options.view && $scope.options.view.availabeFields && angular.isDefined($scope.options.view.doNotSaveFieldConfig) && $scope.options.view.doNotSaveFieldConfig==true){
                    var avail_fields = $scope.availabeFields.map(function(value,index) {
                        return value['field'];
                    });
                    angular.forEach(vSearchParams, function(value, key) {
                        if( $scope.enableFields.indexOf(key)==-1 && key=='mail_feedbacks'){
                            if(avail_fields.indexOf('ms_feedback')<0)
                                $scope.availabeFields.push({enabled:true,field:'ms_feedback'});
                            if(angular.isDefined($scope.enableFields) && $scope.enableFields.indexOf('ms_feedback')<0)
                                $scope.enableFields.push('ms_feedback');
                            as_upgrade(1000);
                        }

                        if(view_fields.indexOf(key)!=-1 && $scope.enableFields.indexOf(key)==-1 && value!=[] && value!="" && !angular.equals({}, value) && key!="name"){
                            var field =angular.copy(value);
                            var new_filter={};
                            new_filter.field=key;
                            new_filter.enabled=true;
                            if(angular.isDefined($scope.search_data.fields[key]) && angular.isDefined($scope.search_data.fields[key].displayName)){
                                new_filter.displayName=$scope.search_data.fields[key].displayName;
                            }
                            if(avail_fields.indexOf(key)<0)
                                $scope.availabeFields.push(new_filter);
                            if(angular.isDefined($scope.enableFields) && $scope.enableFields.indexOf(key)<0)
                                $scope.enableFields.push(key);
                            
                        }
                    });
                }
                // if (!$rootScope.app_data.same_com_log) {
                //     $scope.resultDataAttributes.scrollMoreFlag = true;
                //     $scope.showLoginCard = ($scope.totalCount.count - $scope.resultProfiles.length) >= 10;
                // }
                as_upgrade(100);
            }
        }

        function scrollBlocking() {
            console.log('$scope.options',$scope.options);
            if(!$scope.options || !$scope.options.stickyStateScrollBlock) {
                return false;
            }

            if($scope.options.stickyStateScrollBlock != $state.current.name) {
                return true;
            }

            return false;

        }

        function mapNetworkAndSelf(profiles) {
            profiles.map(function(el) {
                el.notMe = (el.basic_info.uid != $rootScope.app_data.uid);
                el.inNetwork = (network.indexOf(String(el.basic_info.uui)) != -1);
                return el;
            })
            return profiles;
        }

        function vIsEmptySearch(searchParams) {
            console.log("searchParams : ",searchParams);
            $scope.isEmpty = true;
            angular.forEach(searchParams, function(value, key) {
                if (typeof value == 'string' /*name field*/ ) {
                    if (value != '') {
                        $scope.isEmpty = false;
                    }
                }
                else if (isObject(value) && (angular.isDefined(value.isEmpty) || angular.isDefined(value.isNotEmpty) || value.from || angular.isDefined(value.to) || value.on)) {
                    $scope.isEmpty = false;
                }
                else {
                    if (value.length > 0) {
                        $scope.isEmpty = false;
                    }
                }
            });
            return $scope.isEmpty;
        }

        function vGetCount(field, id, callback) {
            var getCountData = {
                type: field,
                id: id
            };
            return sidetopHttp.postDataCall('./search/getCount', getCountData, getCountSuccess);

            function getCountSuccess(response) {
                var d;
                if (response.success == 1 && response.data != null) {
                    d = response;
                } else {
                    d = {
                        data: 0
                    };
                }
                callback(d);
            }
        }

        function messageBtnClick(name, uui, uid, event, is_authenticated) {
            $scope.close(event);
            var user = {
                name: name,
                uui: uui,
                uid: uid,
                is_authenticated: is_authenticated
            }

            if($scope.options && $scope.options.view && $scope.options.view.name=="directory"){
                registerAnalytics('search','message','clicked');
            }
            if($scope.options && $scope.options.view && $scope.options.view.name=="birthday"){
                asMessages.openSendBox(user, event.target, function(){}, {
                    hideChips: true,
                    defaultMessage: $filter('asPortalLang')('Birthday_Wish','Happy Birthday to you!'),
                    messageSourceAndContextNeeded : {source:"Birthday Greetings", context:null}
                });
            }
            asMessages.openSendBox(user, event.target, function(){
            }, {hideChips: true});
        }

        function updateNetList(uui) {
            snackbar_general("Added to "+$filter('asLingo')('35'), 2500);
            network.push(uui);
        }

        
        function vStringBuilder_Lang(searchParams){

            var dynamicString = ''
            var filterArray = [];
            angular.forEach(searchParams, function(value, field) {
                if (value.length != 0 && (value.length != undefined || !angular.equals({}, value)) && !(isObject(value) && (angular.isDefined(value.isEmpty) || angular.isDefined(value.isNotEmpty)) ) && !(field == 'form' || field == 'emptyResponse' || field == 'nonEmptyResponse')) {
                    if(!$scope.search_data.fields[field]) return;
                    if(value!=[] && value!="" && !angular.equals({}, value)){
                        $scope.search_data.fields[field].isFieldChecked = true;
                        $scope.search_data.fields[field].isShown = true;
                    }
                    if (dynamicString != '') {
                        dynamicString = dynamicString + ' ;'
                    };
                    if($scope.search_data['fields'][field].actionString && $scope.search_data['fields'][field].actionString != undefined)
                        dynamicString = dynamicString + " " + $scope.search_data['fields'][field].actionString;
                    for (var i = 0; i < value.length; i++) {
                        if (!isObject(value[i]) && $scope.search_data['fields'][field]["vCheckboxes"] && $scope.search_data['fields'][field]["vCheckboxes"][value[i]] != undefined) {
                            if(!$scope.search_data.fields[field].hidden){
                                var filterArray_val = '';
                                if($scope.search_data.fields[field].futherSearchType=='radio'){
                                    angular.forEach($scope.search_data.fields[field].futherSearchParams.radioList,function(val_,key_) {
                                        if(value.indexOf(val_.id)>=0)
                                            filterArray_val = val_.name;
                                    });
                                }
                                else
                                    filterArray_val = $scope.search_data['fields'][field]["vCheckboxes"][value[i]]["name"];
                                filterArray.push({
                                    key: field,
                                    value: filterArray_val,
                                    vCrossButton:($scope.searchInitalData && $scope.searchInitialData.fp && Object.keys($scope.searchInitialData.fp).length>0 && $scope.searchInitialData.fp.filters[field] && $scope.searchInitialData.fp.filters[field].indexOf($scope.search_data['fields'][field]["vCheckboxes"][value[i]]["id"])!=-1)?false:true,
                                    id: $scope.search_data['fields'][field]["vCheckboxes"][value[i]]["id"]
                                });
                            }
                            if (i == 0) {
                                dynamicString = dynamicString + " " + $scope.search_data['fields'][field]["vCheckboxes"][value[i]]["name"];
                            } else {
                                dynamicString = dynamicString + " , " + $scope.search_data['fields'][field]["vCheckboxes"][value[i]]["name"];
                            }
                        }
                        if(isObject(value[i])){
                            var month = ""; var date = "";
                            angular.forEach(value[i], function(v, k){
                                if(k=="monthName"){
                                    month = v;
                                }
                                if(k=="date"){
                                    date = v;
                                }
                            });
                            var val = date + " " + month;
                            filterArray.push({
                                key: field,
                                value: val,
                                vCrossButton:($scope.searchInitialData.fp && Object.keys($scope.searchInitialData.fp).length>0 && $scope.searchInitialData.fp.filters[field])?false:true,
                                id: value[i]
                            });
                            if(i == 0)
                                dynamicString = dynamicString + " " + val;
                            else
                                dynamicString = dynamicString + " , " + val;
                        }
                    }
                    if(angular.isDefined(value.to) || value.from || value.on){
                        if(value.from && value.to){
                            var dynamicString_val = 0;
                            var val = $scope.search_data['fields'][field]["displayName"] + " : " + $filter('date')(value.from, "yyyy-MM-dd") + " - " + $filter('date')(value.to, "yyyy-MM-dd");
                            if($scope.search_data.fields[field].futherSearchParams.radioList){
                                angular.forEach($scope.search_data.fields[field].futherSearchParams.radioList,function(v,k) {
                                    if(v.dropdownSelector){
                                        angular.forEach(v.dropdownSelector.dropdownList,function(v_,k_) {
                                            if(v_.value && v_.value[0] && v_.value[0].to_date==value.to && v_.value[0].from_date==value.from ){
                                                val = v_.name;
                                                dynamicString_val = 1;
                                                dynamicString = dynamicString + " : " + val;
                                            }
                                        });
                                    }
                                });
                            }
                            if($scope.search_data.fields[field].futherSearchParams.dropdownList && $scope.search_data.fields[field].futherSearchParams.dateSelected){
                                angular.forEach($scope.search_data.fields[field].futherSearchParams.dropdownList,function(v_,k_) {
                                    if(v_.value && v_.value[0] && v_.value[0].to_date==value.to && v_.value[0].from_date==value.from ){
                                        val = v_.name;
                                        dynamicString_val = 1;
                                        dynamicString = dynamicString + " : " + val;
                                    }
                                });
                            }
                            if(dynamicString_val==0)
                                dynamicString = dynamicString + " : " + $filter('date')(value.from, "yyyy-MM-dd") + " - " + $filter('date')(value.to, "yyyy-MM-dd");
                            filterArray.push({
                                key: field,
                                value: val,
                                vCrossButton:($scope.searchInitalData && $scope.searchInitialData.fp && Object.keys($scope.searchInitialData.fp).length>0 && $scope.searchInitialData.fp.filters[field])?false:true,
                                id: value
                            });
                        }
                        else if(angular.isDefined(value.to)){
                            var val = "";
                            if($scope.search_data.fields[field].futherSearchParams.radioList){
                                angular.forEach($scope.search_data.fields[field].futherSearchParams.radioList,function(v,k) {
                                    if(v.dateSelector && v.dateSelector.type=='to'){
                                        val = v.name;  
                                        dynamicString = dynamicString + " " + val;
                                    }
                                });
                            }
                            filterArray.push({
                                key: field,
                                value: val,
                                vCrossButton:($scope.searchInitalData && $scope.searchInitialData.fp && Object.keys($scope.searchInitialData.fp).length>0 && $scope.searchInitialData.fp.filters[field])?false:true,
                                id: value
                            });
                        }
                        else if(value.on){
                            var val = $scope.search_data['fields'][field]["displayName"] + ": " + $filter('date')(value.on, "yyyy-MM-dd");
                            filterArray.push({
                                key: field,
                                value: val,
                                vCrossButton:($scope.searchInitialData && $scope.searchInitialData.fp && Object.keys($scope.searchInitialData.fp).length>0 && $scope.searchInitialData.fp.filters[field])?false:true,
                                id: value
                            });
                        }
                    }
                }
                else if(isObject(value) && (angular.isDefined(value.isEmpty) || angular.isDefined(value.isNotEmpty)) ) {
                    var val;
                    if(value.isEmpty){
                        if((!$scope.search_data['fields'][field]['emptySearchText']) || ($scope.search_data['fields'][field]['emptySearchText'] && !$scope.search_data['fields'][field]['emptySearchText']['isEmpty'] ) )
                            val = $filter("asPortalLang")("Field_Empty","[DATA:field] is empty",{'field': $scope.search_data['fields'][field]["displayName"]});
                        else
                            val = $scope.search_data['fields'][field]["displayName"] + " : "+ $scope.search_data['fields'][field]['emptySearchText']['isEmpty'];
                    }
                    if(value.isNotEmpty){
                         if((!$scope.search_data['fields'][field]['emptySearchText']) || ($scope.search_data['fields'][field]['emptySearchText'] && !$scope.search_data['fields'][field]['emptySearchText']['isNotEmpty']))
                            val = $filter("asPortalLang")("Field_Not_Empty","[DATA:field] is not empty",{'field': $scope.search_data['fields'][field]["displayName"]});
                        else
                            val = $scope.search_data['fields'][field]["displayName"] + " : "+$scope.search_data['fields'][field]['emptySearchText']['isNotEmpty'];
                    }
                    if(dynamicString && dynamicString.trim() != '') {
                        dynamicString = dynamicString + " ; ";
                    }
                    else {
                        dynamicString = dynamicString + " : ";
                    }
                    dynamicString = dynamicString + val;
                    filterArray.push({
                        key: field,
                        value: val,
                        vCrossButton:($scope.searchInitialData && $scope.searchInitialData.fp && Object.keys($scope.searchInitialData.fp).length>0 && $scope.searchInitialData.fp.filters[field])?false:true,
                        id: value
                    });
                    $scope.search_data.fields[field].isFieldChecked = true;
                    $scope.search_data.fields[field].isShown = true;
                    var elem1 = document.querySelector("#is_"+field+"_label");
                    try{
                    if(value.isEmpty){
                        var elem2 = document.querySelector("#isempty_"+field+"_label");
                        elem2.classList.add("is-checked");
                    }
                    if(value.isNotEmpty){
                        var elem2 = document.querySelector("#isnotempty_"+field+"_label");
                        elem2.classList.add("is-checked");
                    }
                    elem1.classList.remove("is-checked");
                    }
                    catch(e){}
                }
                else if(field == 'emptyResponse' || field == 'nonEmptyResponse') {
                    var val;

                    if (field == 'emptyResponse') {
                        angular.forEach(value, function(formId) {
                            var category = $scope.search_data.categories.find(function (cat) {
                                return cat.form_id === formId;
                            });
                            if (category) {
                                var elem1 = document.querySelector("#isempty_"+formId+"_label");
                                elem1.classList.add("is-checked");
                                val = $filter("asPortalLang")("Field_Empty","[DATA:field] is empty",{'field': category.displayName});
                                dynamicString += ((dynamicString && dynamicString.trim() != '') ? " ; " : " : ") + val;
                                filterArray.push({
                                    key: field,
                                    value: val,
                                    vCrossButton_entity: true,
                                    id: formId,
                                });
                            }
                        });
                    }

                    if (field == 'nonEmptyResponse') {
                        angular.forEach(value, function(formId) {
                            var category = $scope.search_data.categories.find(function (cat) {
                                return cat.form_id === formId;
                            });
                            if (category) {
                                var elem2 = document.querySelector("#isnotempty_"+formId+"_label");
                                elem2.classList.add("is-checked");
                                val = $filter("asPortalLang")("Field_Not_Empty","[DATA:field] is not empty",{'field': category.displayName});
                                dynamicString += ((dynamicString && dynamicString.trim() != '') ? " ; " : " : ") + val;
                                filterArray.push({
                                    key: field,
                                    value: val,
                                    vCrossButton_entity: true,
                                    id: formId,
                                });
                            }
                        });
                    }
                    as_upgrade(10);
                }
                else {
                    // $scope.search_data.fields[field].isFieldChecked = false;
                }

            });
            $scope.queryString = filterArray;
            $scope.downloadFilterArray = filterArray; // this is used for pass filter string to download URL
            $scope.displayName = dynamicString;
            return {
                searchString: dynamicString,
                queryString: filterArray
            };

        }
        
        
        function vStringBuilder(searchParams) {
            console.log("searchParams : ",searchParams);
            if($rootScope.app_data.portal_language && $rootScope.app_data.portal_language!='en')
            {
                return vStringBuilder_Lang(searchParams);
            }
            else{
            var dynamicString = ''
            var filterArray = [];
            angular.forEach(searchParams, function(value, field) {
                if (value.length != 0 && (value.length != undefined || !angular.equals({}, value)) && !(isObject(value) && (angular.isDefined(value.isEmpty) || angular.isDefined(value.isNotEmpty)) ) && !(field == 'form' || field == 'emptyResponse' || field == 'nonEmptyResponse') ){
                    if(!$scope.search_data.fields[field]) return;
                    if(value!=[] && value!="" && !angular.equals({}, value)){
                        $scope.search_data.fields[field].isFieldChecked = true;
                        $scope.search_data.fields[field].isShown = true;
                    }
                    if (dynamicString != '') {
                        dynamicString = dynamicString + ' and'
                    };
                    if($scope.search_data['fields'][field].actionString && $scope.search_data['fields'][field].actionString != undefined)
                        dynamicString = dynamicString + " " + $scope.search_data['fields'][field].actionString;
                    for (var i = 0; i < value.length; i++) {
                        if (!isObject(value[i]) && $scope.search_data['fields'][field]["vCheckboxes"] && $scope.search_data['fields'][field]["vCheckboxes"][value[i]] != undefined) {
                            if(!$scope.search_data.fields[field].hidden){
                                var filterArray_val = '';
                                if($scope.search_data.fields[field].futherSearchType=='radio'){
                                    angular.forEach($scope.search_data.fields[field].futherSearchParams.radioList,function(val_,key_) {
                                        if(value.indexOf(val_.id)>=0)
                                            filterArray_val = val_.name;
                                    });
                                }
                                else
                                    filterArray_val = $scope.search_data['fields'][field]["vCheckboxes"][value[i]]["name"];
                                filterArray.push({
                                    key: field,
                                    vCrossButton:($scope.searchInitialData && $scope.searchInitialData.fp && $scope.searchInitialData.fp.filters[field] && $scope.searchInitialData.fp.filters[field].indexOf(parseInt($scope.search_data['fields'][field]["vCheckboxes"][value[i]]["id"]))!=-1)?false:true,
                                    value: filterArray_val,
                                    id: $scope.search_data['fields'][field]["vCheckboxes"][value[i]]["id"]
                                });
                            }
                            if (i == 0) {
                                dynamicString = dynamicString + " " + $scope.search_data['fields'][field]["vCheckboxes"][value[i]]["name"];
                            } else {
                                dynamicString = dynamicString + " or " + $scope.search_data['fields'][field]["vCheckboxes"][value[i]]["name"];
                            }
                        }
                        if(isObject(value[i])){
                            var month = ""; var date = "";
                            angular.forEach(value[i], function(v, k){
                                if(k=="monthName"){
                                    month = v;
                                }
                                if(k=="date"){
                                    date = v;
                                }
                            });
                            var val = date + " " + month;
                            filterArray.push({
                                key: field,
                                value: val,
                                vCrossButton:($scope.searchInitialData && $scope.searchInitialData.fp && Object.keys($scope.searchInitialData.fp).length>0 && $scope.searchInitialData.fp.filters[field])?false:true,
                                id: value[i]
                            });
                            if(i == 0)
                                dynamicString = dynamicString + " " + val;
                            else
                                dynamicString = dynamicString + " or " + val;
                        }
                    }
                    if(angular.isDefined(value.to) || value.from || value.on){
                        if(value.from && value.to){
                            var dynamicString_val = 0;
                            var val = $scope.search_data['fields'][field]["displayName"] + " between " + $filter('date')(value.from, "yyyy-MM-dd") + " and " + $filter('date')(value.to, "yyyy-MM-dd");
                            if(angular.isDefined($scope.search_data.fields[field].futherSearchParams)){
                                if($scope.search_data.fields[field].futherSearchParams.radioList){
                                    angular.forEach($scope.search_data.fields[field].futherSearchParams.radioList,function(v,k) {
                                        if(v.dropdownSelector){
                                            angular.forEach(v.dropdownSelector.dropdownList,function(v_,k_) {
                                                if(v_.value && v_.value[0] && v_.value[0].to_date==value.to && v_.value[0].from_date==value.from ){
                                                    val = v_.name;
                                                    dynamicString_val = 1;
                                                    dynamicString = dynamicString + " : " + val;
                                                }
                                            });
                                        }
                                    });
                                }
                                if($scope.search_data.fields[field].futherSearchParams.dropdownList && $scope.search_data.fields[field].futherSearchParams.dateSelected){
                                    angular.forEach($scope.search_data.fields[field].futherSearchParams.dropdownList,function(v_,k_) {
                                        if(v_.value && v_.value[0] && v_.value[0].to_date==value.to && v_.value[0].from_date==value.from ){
                                            val = v_.name;
                                            dynamicString_val = 1;
                                            dynamicString = dynamicString + " : " + val;
                                        }
                                    });
                                }
                            }
                            if(dynamicString_val==0)
                                dynamicString = dynamicString + " between " + $filter('date')(value.from, "yyyy-MM-dd") + " and " + $filter('date')(value.to, "yyyy-MM-dd");
                            filterArray.push({
                                key: field,
                                value: val,
                                vCrossButton:($scope.searchInitialData && $scope.searchInitialData.fp && Object.keys($scope.searchInitialData.fp).length>0 && $scope.searchInitialData.fp.filters[field])?false:true,
                                id: value
                            });
                        }
                        else if(angular.isDefined(value.to)){
                            var val = "";
                            if($scope.search_data.fields[field].futherSearchParams.radioList){
                                angular.forEach($scope.search_data.fields[field].futherSearchParams.radioList,function(v,k) {
                                    if(v.dateSelector && v.dateSelector.type=='to'){
                                        val = v.name;  
                                        dynamicString = dynamicString + " " + val;
                                    }
                                });
                            }
                            filterArray.push({
                                key: field,
                                value: val,
                                vCrossButton:($scope.searchInitialData && $scope.searchInitialData.fp && Object.keys($scope.searchInitialData.fp).length>0 && $scope.searchInitialData.fp.filters[field])?false:true,
                                id: value
                            });
                        }
                        else if(value.on){
                            var val = $scope.search_data['fields'][field]["displayName"] + ": " + $filter('date')(value.on, "yyyy-MM-dd");
                            filterArray.push({
                                key: field,
                                vCrossButton:($scope.searchInitialData && $scope.searchInitialData.fp && Object.keys($scope.searchInitialData.fp).length>0 && $scope.searchInitialData.fp.filters[field])?false:true,
                                value: val,
                                id: value
                            });
                        }
                    }
                }
                else if(isObject(value) && (angular.isDefined(value.isEmpty) || angular.isDefined(value.isNotEmpty)) ) {
                    var val;
                    if(value.isEmpty){
                        if((!$scope.search_data['fields'][field]['emptySearchText']) || ($scope.search_data['fields'][field]['emptySearchText'] && !$scope.search_data['fields'][field]['emptySearchText']['isEmpty'] ) )
                            val = $scope.search_data['fields'][field]["displayName"] + " is empty ";
                        else
                            val = $scope.search_data['fields'][field]["displayName"] + " : "+ $scope.search_data['fields'][field]['emptySearchText']['isEmpty'];
                    }                   
                    if(value.isNotEmpty){
                         if((!$scope.search_data['fields'][field]['emptySearchText']) || ($scope.search_data['fields'][field]['emptySearchText'] && !$scope.search_data['fields'][field]['emptySearchText']['isNotEmpty']))
                            val = $scope.search_data['fields'][field]["displayName"] + " is not empty ";
                        else
                            val = $scope.search_data['fields'][field]["displayName"] + " : "+$scope.search_data['fields'][field]['emptySearchText']['isNotEmpty'];
                    }
                    if(dynamicString && dynamicString.trim() != '') {
                        dynamicString = dynamicString + " and ";
                    }
                    else {
                        dynamicString = dynamicString + " of ";
                    }
                    dynamicString = dynamicString + val;
                    filterArray.push({
                        key: field,
                        value: val,
                        vCrossButton:($scope.searchInitialData && $scope.searchInitialData.fp && Object.keys($scope.searchInitialData.fp).length>0 && $scope.searchInitialData.fp.filters[field])?false:true,
                        id: value
                    });
                    $scope.search_data.fields[field].isFieldChecked = true;
                    $scope.search_data.fields[field].isShown = true;
                    var elem1 = document.querySelector("#is_"+field+"_label");
                    try{
                    if(value.isEmpty){
                        var elem2 = document.querySelector("#isempty_"+field+"_label");
                        elem2.classList.add("is-checked");
                    }
                    if(value.isNotEmpty){
                        var elem2 = document.querySelector("#isnotempty_"+field+"_label");
                        elem2.classList.add("is-checked");
                    }
                    elem1.classList.remove("is-checked");
                    }
                    catch(e){}
                }
                else if(field == 'emptyResponse' || field == 'nonEmptyResponse') {
                    var val;

                    if (field == 'emptyResponse') {
                        angular.forEach(value, function(formId) {
                            var category = $scope.search_data.categories.find(function (cat) {
                                return cat.form_id == formId;
                            });
                            if (category) {
                                var elem1 = document.querySelector("#isempty_"+formId+"_label");
                                elem1.classList.add("is-checked");
                                val = category.displayName + " is empty";
                                dynamicString += ((dynamicString && dynamicString.trim() != '') ? " and " : " of ") + val;
                                filterArray.push({
                                    key: field,
                                    value: val,
                                    vCrossButton_entity: true,
                                    id: formId,
                                });
                            }
                        });
                    }

                    if (field == 'nonEmptyResponse') {
                        angular.forEach(value, function(formId) {
                            var category = $scope.search_data.categories.find(function (cat) {
                                return cat.form_id == formId;
                            });
                            if (category) {
                                var elem2 = document.querySelector("#isnotempty_"+formId+"_label");
                                elem2.classList.add("is-checked");
                                val = category.displayName + " is not empty";
                                dynamicString += ((dynamicString && dynamicString.trim() != '') ? " and " : " of ") + val;
                                filterArray.push({
                                    key: field,
                                    value: val,
                                    vCrossButton_entity: true,
                                    id: formId,
                                });
                            }
                        });
                    }
                    as_upgrade(10);
                }
                else {
                    // $scope.search_data.fields[field].isFieldChecked = false;
                }

            });
            $scope.queryString = filterArray;
            $scope.downloadFilterArray = filterArray; // this is used for pass filter string to download URL
            $scope.displayName = dynamicString;
            return {
                searchString: dynamicString,
                queryString: filterArray
            };
          }
        }

        function vCrossButton(id, field) {
            if($scope.options && $scope.options.transferInfo)
                $scope.options.transferInfo.fetchingCnt = true;
            $scope.adminNotDeleted = false;
            change_stream = true;
            if(angular.isDefined($scope.num_deleted))
                $scope.num_deleted = 0;
            if(angular.isDefined($scope.num_edited)){
                $scope.num_edited = 0;
                $scope.searchLangData.profileUpdCount = 0;
            }
            if(angular.isDefined($scope.adminErrorMessage))
                $scope.adminErrorMessage = "";
            if(angular.isDefined($scope.num_selected)){
                $scope.num_selected = 0;
                $scope.searchLangData.profileSelCount = 0;
            }
            if(angular.isDefined($scope.allSelected))
                $scope.allSelected = 0;
            $scope.availabeFields = $scope.availabeFields.filter(function(value,index) {
                if($scope.options.view.availabeFields.indexOf(field)<0)
                    return value.field!=field;
                else
                    return value.field;
            });
            if($scope.enableFields.indexOf(field)!=-1 && ((angular.isDefined($scope.options.view.default_fields) && $scope.options.view.default_fields.indexOf(field) < 0) 
                || !angular.isDefined($scope.options.view.default_fields)))
                $scope.enableFields.splice($scope.enableFields.indexOf(field),1);
            if(!angular.isObject(id) && angular.isDefined($scope.search_data.fields[field].vCheckboxes[id]))            
                $scope.search_data.fields[field].vCheckboxes[id]["checked"] = false;
            // $scope.search_data.fields[field].isShown = false;
            // $scope.search_data.fields[field].isFieldChecked = false;
            if($scope.search_data.fields[field].futherSearchParams.dropdownList){
                $scope.search_data.fields[field].futherSearchParams.fullSelected="";
            }
            var date_check = 0;
            if($scope.search_data.fields[field].multiSearchWithChip){
                angular.forEach(vSearchParams[field], function(value, key){
                    if(value.index == id.index)
                        vSearchParams[field].splice(key,1);
                });
            }
            if($scope.search_data.fields[field].futherSearchParams.dateSelected){
                var elem;
                var elem_dropdown;
                if($scope.search_data.fields[field].futherSearchParams.dateSelected.from && $scope.search_data.fields[field].futherSearchParams.dateSelected.to){
                    date_check = 1;
                    $scope.search_data.fields[field].futherSearchParams.dateSelected.from = "";
                    $scope.search_data.fields[field].futherSearchParams.dateSelected.to = "";
                    elem = document.getElementById("date_"+field+"_from_to");
                    elem_dropdown = document.getElementById("date_"+field+"_from_to_dropdown");
                }
                else if($scope.search_data.fields[field].futherSearchParams.dateSelected.on){
                    date_check = 1;
                    $scope.search_data.fields[field].futherSearchParams.dateSelected.on = "";
                    elem = document.getElementById("date_"+field+"_on");
                    elem_dropdown = document.getElementById("date_"+field+"_on_dropdown");
                }
                else if($scope.search_data.fields[field].futherSearchParams.dateSelected.to){
                    date_check = 1;
                    $scope.search_data.fields[field].futherSearchParams.dateSelected.to = "";
                }
                if(elem){
                    var e = elem.querySelectorAll("input[type=text]");
                    angular.forEach(e,function(value,key) {
                        value.value = '';
                    });
                }
                if(elem_dropdown){
                    var e = elem_dropdown.querySelectorAll("input[type=text]");
                    angular.forEach(e,function(value,key) {
                        value.value = '';
                    });
                }
                delete vSearchParams[field];
                id = {};
            }
            as_upgrade(100);
            $scope.vBoxChanged(id, field, true);
        }

        function vCrossButton_entity(id, field) {
            if($scope.options && $scope.options.transferInfo)
                $scope.options.transferInfo.fetchingCnt = true;
            $scope.adminNotDeleted = false;
            change_stream = true;
            if(angular.isDefined($scope.num_deleted))
                $scope.num_deleted = 0;
            if(angular.isDefined($scope.num_edited)){
                $scope.num_edited = 0;
                $scope.searchLangData.profileUpdCount = 0;
            }
            if(angular.isDefined($scope.adminErrorMessage))
                $scope.adminErrorMessage = "";
            if(angular.isDefined($scope.num_selected)){
                $scope.num_selected = 0;
                $scope.searchLangData.profileSelCount = 0;
            }
            if(angular.isDefined($scope.allSelected))
                $scope.allSelected = 0;

            as_upgrade(100);
            entityEmptyChanges(id, field);
        }

        function removedRestrictedFieldsSearchData() {
            var _search_data = angular.copy(search_data);
            console.log('_search_data', _search_data);
            _search_data.fields = Object.keys(_search_data.fields).reduce(function(p,c) {
                var v = _search_data.fields[c];
                if(angular.isDefined(v.emptySearching)){
                    if($scope.current_view_mode=='admin' || $scope.options.allowEmptySearch)
                        v.emptySearching = true;
                    else
                        v.emptySearching = false;
                }
                if(v.restrictionFunctions && v.restrictionFunctions.constructor==Array && v.restrictionFunctions.length>0) {
                    for (var i = 0; i < v.restrictionFunctions.length; i++) {
                        if(v.restrictionFunctions[i](c,v)) {
                            return p;
                        }
                    }
                }
                if($scope.options && $scope.options.hideDataOptions && $scope.options.hideDataOptions[c]){
                    angular.forEach($scope.options.hideDataOptions[c],function(val,key) {
                        var processed_field_opts = false;
                        if(v[key]){
                            angular.forEach(v[key],function(val_,key_) {
                                if(val_['id']!=undefined){
                                    processed_field_opts = true;
                                    if(val.indexOf(val_['id'])>=0)
                                        val_.hideOption = true;
                                }
                            });
                            if(!processed_field_opts){
                                angular.forEach(val,function(val_1,key_1) {
                                    if(v[key][key_1]){
                                        angular.forEach(v[key][key_1],function(val_2,key_2) {
                                            if(val_2['id'] && val_1.indexOf(val_2['id'])>=0)
                                                val_2.hideOption = true;
                                        });
                                        v[key][key_1] = v[key][key_1].filter(function(val_3,key_3) {
                                            if(!val_3.hideOption)
                                                return val_3;
                                        });
                                    }
                                });
                            }
                            else{
                                v[key] = v[key].filter(function(val_3,key_3) {
                                    if(!val_3.hideOption)
                                        return val_3;
                                });
                            }
                        }
                    });
                    if($scope.options.hideDataOptions[c].remEmptyFilter){
                        v.hideEmpty = true;
                    }
                    if($scope.options.hideDataOptions[c].remNotEmptyFilter){
                        v.hideNotEmpty = true;
                    }
                }
                p[c] = v;
                return p;
            },{});
            return _search_data;
        }

        function sortCategoriesForMobile(_search_data) {
            if(!$rootScope.isMobile || isNaN(_search_data.mobile_default_category) || !_search_data.categories) {
                return _search_data;
            }
            _search_data.categories = _search_data.categories.reduce(function(p,c,i) {
                if(i==_search_data.mobile_default_category)
                    p.unshift(c);
                else
                    p.push(c);
                return p;
            },[]);
            return _search_data;
        }

        
        function initDataBind() {
            checkEnroll().then(function() {
                initEntityDataBind().then(function(){
                    initFormFieldsDataBind().then(function(){
                        initDataBind_1();
                    });
                });
            });
        }

        function initEntityDataBind(){
            var d = $q.defer();
            if($scope.options && $scope.options.setEntityFields==1) {
                var entities=isEntityPresent();
                if(entities.length>0){
                    if($scope.options && $scope.options.split_entity_categories){
                        addEntityCategories(entities);
                    }
                    setFormFields(entities).then(function() {
                        d.resolve();
                    });
                }
                else{
                    d.resolve();
                }
            }
            else
                d.resolve();
            return d.promise;
        }

        function initFormFieldsDataBind(){
            var d = $q.defer();
            if($scope.options.setFormFields==1) {
                setFormFields().then(function () {
                    d.resolve();
                });
            }
            else d.resolve();
            return d.promise;
        }

        function addEntityCategories(entities){
            var found = false;
            var categoryIndex=-1;
            var insertionIndex = -1;
            angular.forEach($scope.searchInitialData.categories, function(category, category_index) {
                angular.forEach(category.fields, function(field, field_index) {
                    if (field === 'entity_field' && !found) {
                        found = true;
                        insertionIndex = field_index;
                        categoryIndex=category_index;
                    }
                });
            });

            if(found){
                if(insertionIndex === 0 || insertionIndex === $scope.searchInitialData.categories[categoryIndex].fields.length - 1) {
                    // 'entity_field' is at the start or end of the fields array
                    var fieldsBeforeEntity = insertionIndex === 0 ? [] : $scope.searchInitialData.categories[categoryIndex].fields.slice(0, insertionIndex);
                    var fieldsAfterEntity = insertionIndex === $scope.searchInitialData.categories[categoryIndex].fields.length - 1 ? [] : $scope.searchInitialData.categories[categoryIndex].fields.slice(insertionIndex + 1);
                    $scope.searchInitialData.categories.splice(categoryIndex,1);

                    // Insert new categories for each entity
                    angular.forEach(entities, function(entity) {
                        if(entity.entity_name){
                            var newCategory = {
                                'fields': [entity.entity_name],
                                'displayName': entity.entity_name,
                                'expandable':true,
                                'form_id': entity.form_id,
                                'emptySearching': entity.emptySearching,
                                dataPreProcessors: [function(dataTosend,type) {
                                    if(!dataTosend.form) dataTosend.form = {};
                                    if(!dataTosend.form.form_id) dataTosend.form.form_id = [];
                                    if(!dataTosend.form.emptyResponse) dataTosend.form.emptyResponse = {};

                                    if(dataTosend.form.form_id.indexOf(parseInt(entity.form_id))==-1)
                                        dataTosend.form.form_id.push(parseInt(entity.form_id));

                                    if(type == 'emptyResponse')
                                        dataTosend.form.emptyResponse[parseInt(entity.form_id)] = true;
                                    else if(type == "nonEmptyResponse")
                                        dataTosend.form.emptyResponse[parseInt(entity.form_id)] = false;

                                    if(isEmpty(dataTosend.form.emptyResponse)) delete dataTosend.form.emptyResponse;
                                    if(isEmpty(dataTosend.emptyResponse)) delete dataTosend.emptyResponse;
                                    if(isEmpty(dataTosend.nonEmptyResponse)) delete dataTosend.nonEmptyResponse;
                                    if(isEmpty(dataTosend.form.fields) && isEmpty(dataTosend.form.emptyResponse))
                                        delete dataTosend.form;

                                    return dataTosend;
                                }]
                            };
                            $scope.searchInitialData.categories.splice(categoryIndex, 0, newCategory);
                            categoryIndex++;
                        }
                    });
                    // Insert remaining fields after 'entity_field' as a new category
                    if(fieldsBeforeEntity.length > 0){
                        var remainingCategory = {
                            'fields': fieldsBeforeEntity
                        };
                        $scope.searchInitialData.categories.splice(categoryIndex - entities.length, 0, remainingCategory);
                    }

                    if(fieldsAfterEntity.length > 0) {
                        var remainingCategory = {
                            'fields': fieldsAfterEntity
                        };
                        $scope.searchInitialData.categories.splice(categoryIndex, 0, remainingCategory);
                    }
                }
                else{
                    // 'entity_field' is in the middle of the fields array
                    var fieldsBeforeEntity = $scope.searchInitialData.categories[categoryIndex].fields.slice(0, insertionIndex);
                    var fieldsAfterEntity = $scope.searchInitialData.categories[categoryIndex].fields.slice(insertionIndex + 1);
                    $scope.searchInitialData.categories[categoryIndex].fields = fieldsBeforeEntity;
                    categoryIndex++;
                    angular.forEach(entities, function(entity) {
                        
                        if (entity.entity_name) {
                            var newCategory = {
                                'fields': [entity.entity_name],
                                'displayName': entity.entity_name,
                                'expandable':true,
                                'form_id': entity.form_id,
                                'emptySearching': entity.emptySearching,
                                dataPreProcessors: [function(dataTosend,type) {
                                    if(!dataTosend.form) dataTosend.form = {};
                                    if(!dataTosend.form.form_id) dataTosend.form.form_id = [];
                                    if(!dataTosend.form.emptyResponse) dataTosend.form.emptyResponse = {};

                                    if(dataTosend.form.form_id.indexOf(parseInt(entity.form_id))==-1)
                                        dataTosend.form.form_id.push(parseInt(entity.form_id));

                                    if(type == 'emptyResponse')
                                        dataTosend.form.emptyResponse[parseInt(entity.form_id)] = true;
                                    else if(type == "nonEmptyResponse")
                                        dataTosend.form.emptyResponse[parseInt(entity.form_id)] = false;

                                    if(isEmpty(dataTosend.form.emptyResponse)) delete dataTosend.form.emptyResponse;
                                    if(isEmpty(dataTosend.emptyResponse)) delete dataTosend.emptyResponse;
                                    if(isEmpty(dataTosend.nonEmptyResponse)) delete dataTosend.nonEmptyResponse;
                                    if(isEmpty(dataTosend.form.fields) && isEmpty(dataTosend.form.emptyResponse))
                                        delete dataTosend.form;

                                    return dataTosend;
                                }]
                            };
                                $scope.searchInitialData.categories.splice(categoryIndex, 0, newCategory);
                                categoryIndex++;
                            }
                    });
                    if (fieldsAfterEntity.length > 0) {
                        var remainingCategory = {
                            'fields': fieldsAfterEntity
                        };
                        $scope.searchInitialData.categories.splice(categoryIndex, 0, remainingCategory);
                    }
                }
            }
        }

        function isEntityPresent(){
            var entities_info=[];
            var signup_meta=$rootScope.app_data.config.meta[31];
            var maxOrder=0;
            if(signup_meta){
                if(signup_meta['entities'] && signup_meta['entities'].length>0){
                    var entities=signup_meta['entities'];
                    angular.forEach(entities,function(entity){
                        if(entity.who_can_view_in_directory){
                            var allowed=false;
                            angular.forEach($rootScope.app_data.roles,function(role){
                                if(entity.who_can_view_in_directory.indexOf('None')==-1 && entity.who_can_view_in_directory.indexOf(role)>-1)
                                    allowed=true;
                            });
                            if(allowed){
                                 if (entity.order && !isNaN(entity.order)) {
                                     if(entity.order==maxOrder){
                                        entities_info.push({'entity_name': entity.name, 'form_id': entity.formid, 'emptySearching': entity.allowEmptyFilter});
                                        maxOrder++;
                                    }
                                    else{
                                        entities_info[entity.order - 1] = {'entity_name': entity.name, 'form_id': entity.formid, 'emptySearching': entity.allowEmptyFilter};
                                        maxOrder = Math.max(maxOrder, entity.order);   
                                    }
                                } else {
                                    entities_info.push({'entity_name': entity.name, 'form_id': entity.formid, 'emptySearching': entity.allowEmptyFilter});
                                }
                            }

                        }
                        else{
                             if (entity.order && !isNaN(entity.order)) {
                                if(entity.order==maxOrder){
                                    entities_info.push({'entity_name': entity.name, 'form_id': entity.formid, 'emptySearching': entity.allowEmptyFilter});
                                    maxOrder++;
                                }
                                else{
                                    entities_info[entity.order - 1] = {'entity_name': entity.name, 'form_id': entity.formid, 'emptySearching': entity.allowEmptyFilter};
                                    maxOrder = Math.max(maxOrder, entity.order);   
                                }
                                
                            } else {
                                entities_info.push({'entity_name': entity.name, 'form_id': entity.formid, 'emptySearching': entity.allowEmptyFilter});
                            }
                        }
                    });
                }
            }
            if(maxOrder>0){
                entities_info = entities_info.filter(function(entity){
                    return entity !== null;
                });
            }
            return entities_info;
        }


        function checkEnroll() {
            $scope.vResettingWaiting = true;
            $scope.isFetchingSelected = true;
            return $http.post('./admin/get_meta', {"meta_option": ["SIGNUP_EXTRA_INFO","YOJ_HIDE_IN_SIGNUP","YOP_HIDE_IN_SIGNUP","DEGREE_HIDE_IN_SIGNUP","DEGREE_HIDE_IN_SEARCH","DEP_HIDE_IN_SIGNUP","DEP_HIDE_IN_SEARCH"]}).then(function(res) {
                if(res && res.data && res.data.success && res.data.success==1){
                    $scope.signupExtraInfoMetadata = res.data.data.SIGNUP_EXTRA_INFO;
                    
                    $scope.isEnrollment = false;
                    if(angular.isDefined($scope.signupExtraInfoMetadata["fields"]["enrollment_no"])){
                        $scope.isEnrollment = 1;
                    }
                    if($scope.isEnrollment) search_data.fields['enrollment_number'].hidden = false;

                    $scope.isIdentity = false;
                    if(angular.isDefined($scope.signupExtraInfoMetadata["fields"]["identity_no"])){
                        $scope.isIdentity = 1;
                    }
                    if($scope.isIdentity) search_data.fields['identity_number'].hidden = false;

                    $scope.isDOB = true;
                    if(angular.isDefined($scope.signupExtraInfoMetadata["fields"]["dob"])){
                        $scope.isDOB = $scope.signupExtraInfoMetadata["fields"]["dob"];
                    }
                    if($scope.isDOB) search_data.fields['dob'].hidden = false;
                    $scope.isHometown = true;
                    if(angular.isDefined($scope.signupExtraInfoMetadata["fields"]["hometown"])){
                        $scope.isHometown = $scope.signupExtraInfoMetadata["fields"]["hometown"];
                    }
                    if($scope.isHometown) search_data.fields['hometown'].hidden = false;
                    $scope.isSkill= true;
                    if(angular.isDefined($scope.signupExtraInfoMetadata["fields"]["skills"])){
                        $scope.isSkill = $scope.signupExtraInfoMetadata["fields"]["skills"];
                    }
                    if($scope.isSkill) search_data.fields['skill'].hidden = false;
                    
                    $scope.isGender = true;
                    if(angular.isDefined($scope.signupExtraInfoMetadata["fields"]["gender"])){
                        $scope.isGender = $scope.signupExtraInfoMetadata["fields"]["gender"];
                    }
                    if($scope.isGender) search_data.fields['gender'].hidden = false;

                    $scope.isMaritalStatus = true;
                    if(angular.isDefined($scope.signupExtraInfoMetadata["fields"]["marital_status"])){
                        $scope.isMaritalStatus = $scope.signupExtraInfoMetadata["fields"]["marital_status"];
                    }
                    if($scope.isMaritalStatus) search_data.fields['marital_status'].hidden = false;

                    $scope.isYojHide = parseInt(res.data.data.YOJ_HIDE_IN_SIGNUP);
                    $scope.isYopHide = parseInt(res.data.data.YOP_HIDE_IN_SIGNUP);
                    $scope.isDegreeHide = parseInt(res.data.data.DEGREE_HIDE_IN_SIGNUP) || parseInt(res.data.data.DEGREE_HIDE_IN_SEARCH);
                    $scope.isDepHide = parseInt(res.data.data.DEP_HIDE_IN_SIGNUP) || parseInt(res.data.data.DEP_HIDE_IN_SEARCH);

                    $scope.isSpecialization = false;
                    if(angular.isDefined($scope.signupExtraInfoMetadata["fields"]["specialization"])){
                        $scope.isSpecialization = $scope.signupExtraInfoMetadata["fields"]["specialization"];
                    }
                    if($scope.isSpecialization) search_data.fields['specialization'].hidden = false;

                    $scope.isInstitute = false;
                    if(angular.isDefined($scope.signupExtraInfoMetadata["fields"]["institute"])){
                        $scope.isInstitute = $scope.signupExtraInfoMetadata["fields"]["institute"];
                    }
                    if($scope.isInstitute) search_data.fields['institute'].hidden = false;
                    if($rootScope.featureEnabled('profile_config_for_user.hide_education_from_profile.*')){
                        search_data.fields['past_institute'].hidden = true;
                        search_data.fields['past_degree'].hidden = true;
                        search_data.fields['past_department'].hidden = true;
                    }
                    if($rootScope.featureEnabled('profile_config_for_user.hide_work_from_profile.*')){
                        search_data.fields['company'].hidden = true;
                        search_data.fields['designation'].hidden = true;
                        search_data.fields['industry'].hidden = true;                        
                    }
                }
                return true;
            },function() {
                return true;
            });
        }


        function setViewMode() {
            if($scope.options && $scope.options.enableViewMode) {
                if($rootScope.app_data.isAdmin && !$scope.options.UserMode){
                    $scope.current_view_mode = 'admin';
                }
                else
                    $scope.current_view_mode = 'user';
            }
            else {
                $scope.current_view_mode = 'user';
            }
        }

        function initDataBind_1() {
            setViewMode();
            var _search_data = removedRestrictedFieldsSearchData();
            _search_data = sortCategoriesForMobile(_search_data);
            // var _search_data = search_data;
            if ($scope.searchInitialData) {
                $scope.search_data = angular.copy(angular.merge(_search_data, $scope.searchInitialData));
            } else {
                $scope.search_data = angular.copy(_search_data);
            }

            if ($scope.searchInitialDataModal) {
                $scope.search_data = angular.copy(angular.merge(angular.copy($scope.search_data), $scope.searchInitialDataModal));
            }

            angular.forEach($scope.searchInitialData.dataParams,function(v,k) {                
                if($scope.search_data.fields[k] && $scope.search_data.fields[k].futherSearchParams && $scope.search_data.fields[k].futherSearchParams.dateSelected && ( ($scope.search_data.fields[k].futherSearchType=='radio' && $scope.search_data.fields[k].futherSearchParams.radioList) || ($scope.search_data.fields[k].futherSearchType=='dropdown' && $scope.search_data.fields[k].futherSearchParams.dropdownList) ) ){
                    if(v.to)
                        $scope.search_data.fields[k].futherSearchParams.dateSelected.to = v.to;
                    if(v.from)
                        $scope.search_data.fields[k].futherSearchParams.dateSelected.from = v.from;
                    if(v.on)
                        $scope.search_data.fields[k].futherSearchParams.dateSelected.on = v.on;
                    var loop_on = $scope.search_data.fields[k].futherSearchType=='radio' ? 'radioList' : 'dropdownList';
                    angular.forEach($scope.search_data.fields[k].futherSearchParams[loop_on],function(v_,k_) {
                        if(angular.isUndefined($scope.search_data.fields[k].vCheckboxes)){
                            $scope.search_data.fields[k].vCheckboxes = {};
                        }
                        if(v.from && v.to && v_.dateSelector && v_.dateSelector.type && v_.dateSelector.type=='from-to'){
                            $scope.search_data.fields[k].vCheckboxes[k_] = {checked: true};
                            $scope.search_data.fields[k].futherSearchParams.fullSelected = v_;//this was for dob range filter(between)
                            $scope.search_data.fields[k].futherSearchParams[loop_on][k_].dateSelector.show = true;
                        }
                        else if(!v.from && v.to && v_.dateSelector && v_.dateSelector.type && v_.dateSelector.type=='to'){
                            $scope.search_data.fields[k].vCheckboxes[k_] = {checked: true};
                        }
                        else if(v.on && v_.dateSelector && v_.dateSelector.type && v_.dateSelector.type=='on'){
                            $scope.search_data.fields[k].vCheckboxes[k_] = {checked: true};
                            $scope.search_data.fields[k].futherSearchParams[loop_on][k_].dateSelector.show = true;
                        }
                        else if(v.from && v.to && v_.dropdownSelector && v_.dropdownSelector.dropdownList){
                            $scope.search_data.fields[k].vCheckboxes[k_] = {checked: true};
                            $scope.search_data.fields[k].futherSearchParams[loop_on][k_].showDropdown = true;
                            angular.forEach(v_.dropdownSelector.dropdownList,function(_v_,_k_) {
                                if(_v_.value && _v_.value[0]){
                                    if(v.from==_v_.value[0].from_date && v.to==_v_.value[0].to_date){
                                        $scope.search_data.fields[k].futherSearchParams.fullSelected = _v_;
                                    }
                                }
                                else if(!$scope.search_data.fields[k].futherSearchParams.fullSelected && _v_.dateSelector){
                                    $scope.search_data.fields[k].futherSearchParams.fullSelected = _v_;
                                    $scope.search_data.fields[k].futherSearchParams[loop_on][k_].dropdownSelector.dropdownList[_k_].dateSelector.show = true;
                                }
                            });
                        }
                    });
                }
            });

            searchDataInit();
            var urlData = {
                queryString: angular.copy(vSearchParams),
            };
            var dataTosend = urlData.queryString;
            dataTosend = Object.keys(dataTosend).reduce(function(p,k) {
                if(k == 'emptyResponse' || k == 'nonEmptyResponse') {
                    angular.forEach(p[k] , function(formId) {
                        var category = $scope.search_data.categories.find(function (cat) {
                            return cat.form_id == formId;
                        });
                        if(category.dataPreProcessors && category.dataPreProcessors.constructor==Array && category.dataPreProcessors.length>0) {
                            for (var i = 0; i < category.dataPreProcessors.length; i++) {
                                dataTosend = category.dataPreProcessors[i](dataTosend,k,category);
                            }
                        }
                    });
                }
                if($scope.search_data.fields[k]) {
                    var v = $scope.search_data.fields[k];
                    if(v.dataPreProcessors && v.dataPreProcessors.constructor==Array && v.dataPreProcessors.length>0) {
                        for (var i = 0; i < v.dataPreProcessors.length; i++) {
                            dataTosend = v.dataPreProcessors[i](dataTosend,dataTosend[k],k,v);
                        }
                    }
                }
                return p;
            },dataTosend);
            urlData.queryString = dataTosend;
            //if there is some extra filter applied during first stream then we should also fetch lost alumni as we allow it during

            if(vSearchParams.ordering){
                urlData.queryString.ordering=vSearchParams.ordering;
            }

            urlData.queryString.other_params = {fetchLost: false};
            if ($scope.search_data.fetchLost || $scope.current_view_mode=='admin') {
                if(($scope.search_data.fetchLost==1 || $scope.search_data.fetchLost==true) || ($scope.search_data.fetchLost==2 && !vIsEmptySearch(vSearchParams)) || $scope.current_view_mode=='admin') {
                    urlData.queryString.other_params.fetch_lost = true;
                }
            }

            if($scope.search_data.roles){
                urlData.queryString.other_params.roles = $scope.search_data.roles;
            }

            if($scope.options && $scope.options.view && $scope.options.view.name){
                urlData.other_params = {
                    viewName : $scope.options.view.name
                };
            }
           
            if($scope.options && $scope.options.poll_id){
                dataTosend.other_params.poll_id = $scope.options.poll_id;
            }

            if($scope.options && $scope.options.polltable){
                dataTosend.other_params.polltable = $scope.options.polltable;
            }

            if($scope.options && $scope.options.include_demised)
                dataTosend.other_params.include_demised = $scope.options.include_demised;

            if($scope.options && $scope.options.distinctMobApps){
                if(!urlData.other_params) urlData.other_params = {};
                urlData.other_params['distinctMobApps'] = $scope.options.distinctMobApps;
            }

            if($scope.options && $scope.options.valid_phones_only){
                if(!urlData.other_params) urlData.other_params = {};
                urlData.other_params['valid_phones_only'] = $scope.options.valid_phones_only;
            }
            if($scope.options && $scope.options.sms_data){
                if(!urlData.other_params) urlData.other_params = {};
                urlData.other_params['sms_data'] = $scope.options.sms_data;
            }
            if($scope.options && $scope.options.whatsapp_message){
                if(!urlData.other_params) urlData.other_params = {};
                urlData.other_params['whatsapp_message'] = $scope.options.whatsapp_message;
            }

            if($scope.options && $scope.options.disableAuthFilter){
                if(!urlData.other_params)  urlData.other_params = {};
                urlData.other_params['disableAuthFilter']=$scope.options.disableAuthFilter;
            }

            if($scope.options && $scope.options.keyword_filter){
                if(!urlData.other_params)
                    urlData.other_params = {};
                urlData.other_params.keyword_filter = $scope.options.keyword_filter;
            }

            if($scope.options && $scope.options.merge_empty_yop){
                if(!urlData.other_params)
                    urlData.other_params = {};
                urlData.other_params.merge_empty_yop = $scope.options.merge_empty_yop;
            }

            if($scope.search_data.lost) {
                urlData.queryString.lost = true;
            }

            $scope.user_view_tip = '';
            if($scope.search_data.membership_only) {
                $scope.user_view_tip = $filter('asPortalLang')('Non_Life_Member','Non Life Member');
            }
            else if($scope.search_data.authenticated_only && !$scope.search_data.membership_only) {
                $scope.user_view_tip = $filter('asPortalLang')('Unauthenticated','Unauthenticated');  
            }
            else {
                $scope.user_view_tip = $filter('asPortalLang')('Blocked','Blocked');
            }
            
            if($scope.user_view_tip != 'Blocked') {
                // change this acc to old code
                // also if in a statement we get abc and blocked, that shoukd be a separate key
                $scope.user_view_tip +=' '+$filter('asPortalLang')('And_Blocked','and blocked');
            }
            $scope.DynamicTip = {'DynamicTip':$scope.user_view_tip};
            if ($scope.search_data.authenticated_only && $scope.current_view_mode == 'user') urlData.queryString['authenticated_only'] = true;
            if ($scope.search_data.lg && $scope.current_view_mode == 'user') urlData.queryString['lg'] = true;
            if ($scope.search_data.membership_only && $scope.current_view_mode == 'user') urlData.queryString['life_membership_status'] = true;
            $scope.vResettingWaiting = true;
            $scope.isFetchingSelected = true;
            as_upgrade(300);
            urlData.selectiveCheckbox=true;

            if($scope.options.noCheckBoxNeeded){
                //do nothing
            }else{
                urlData.requiredCheckboxes = $scope.search_data.categories.reduce(function(p, c) {
                        p=p.concat(c.fields);
                        return p;
                    }, []);
            }

            try{$scope.reportingFun.fetchingProfiles({dataTosend:urlData,api:'./search/index_api'});}
            catch(e){}
            urlData.queryString.lm = 12;

            if(platform && (isAppCacheEnable || isAppCacheEnable === "true" || isAppCacheEnable === true)){
                var url = "./search/index_api";
                var cacheId, key, cacheUids, directoryCache;
                var cacheEnable = false;
                $rootScope.DirectoryCache = false;

                if($scope.options && $scope.options.view && $scope.options.view.name == "directory")
                    cacheEnable = true;

                var isEmptySearch = vIsEmptySearch(vSearchParams);
                console.log("isEmptySearch : ",isEmptySearch);
                if(isEmptySearch === true && cacheEnable === true) {

                    cacheId = "DirectoryCache";
                    key = url+'?cid='+$rootScope.app_data.cid;

                    directoryCache = cache.getCache(cacheId,key);

                    if(directoryCache && directoryCache.data){
                        console.log("directoryCache : ",directoryCache);
                        console.log("in if.......");
                        activate(directoryCache.data);

                        var users = directoryCache.data.data.people.data;
                        cacheUids = users.map(function(value) {
                            return value.uid;
                        });
                        console.log("cacheUids : ",cacheUids);
                    }
                }

                $http.post(url, urlData).success(function(response) {
                    console.log("response : ",response);
                    if(response.errorcode=="LIMIT_EXCEEDED" && response.error){
                        swal({text: response.error, "title":$filter('asPortalLang')('Action_Limit_Restriction',"Access Temporary Restricted")});
                        $scope.limitSwalShown = true;
                        return;
                    }
                    // check if any new user added in stream 1
                    if(directoryCache && directoryCache.data && cacheUids){
                        var users = response.data.people.data;
                        var apiUids = users.map(function(value) {
                            return value.uid;
                        });

                        apiUids.sort();
                        cacheUids.sort();
                        
                        // console.log("cache apiUids : ",apiUids);
                        // console.log("cache cacheUids : ",cacheUids);
                        // console.log("cache uid match : ",angular.equals(cacheUids,apiUids));

                        for(var i = 0; i < apiUids.length; i += 1) {
                            // console.log("apiUid : ",apiUids[i]);
                            // console.log("index of : ",cacheUids.indexOf(apiUids[i]));
                            if(cacheUids.indexOf(apiUids[i]) < 0){
                                // clear cache & refresh page
                                $rootScope.DirectoryCache = true;
                            }
                        }
                    }

                    if(isEmptySearch === true && cacheEnable === true){
                        cache.putCache(cacheId,key, {
                            data: response
                        });
                        console.log("after set cache....");

                        var DCache = cache.getCache(cacheId,key);
                        console.log("DCache : ",DCache);
                    }
                    
                    if(!directoryCache){
                        console.log("in if.......");
                        activate(response);
                    }
                });
            }
            else
                sidetopHttp.postDataConfigCall('./search/index_api', urlData, {}, activate);
        }

        function resetUpdateCount() {
            var params = {};
            params.other_params = {fetchLost: false};
            if ($scope.search_data.fetchLost || $scope.current_view_mode=='admin') {
                if(($scope.search_data.fetchLost==1 || $scope.search_data.fetchLost==true) || ($scope.search_data.fetchLost==2 && !vIsEmptySearch(vSearchParams)) || $scope.current_view_mode=='admin') {
                    params.other_params.fetch_lost = true;
                }
            }
            if($scope.search_data.roles){
                dataTosend.other_params.roles = $scope.search_data.roles;
            }

            if ($scope.search_data.authenticated_only && $scope.current_view_mode == 'user') params['authenticated_only'] = true;
            if ($scope.search_data.lg && $scope.current_view_mode == 'user') params['lg'] = true;
            if ($scope.search_data.membership_only && $scope.current_view_mode == 'user') params['life_membership_status'] = true;
            return $http.post('./admin/getTotalCommunityMembers',{params:params})
            .then(function(res) {
                if(res.data && res.data.success && res.data.data) {
                    $scope.totalCount.count = res.data.data;
                }
            });
        }

        function setFormFields(entities_info) {
            var url="./communities/communities/custom/extra_userprofile_info";
            var infoType='*';   
            var entity=false;    
            if(entities_info){
                url="./communities/communities/custom/get_entity_info";
                infoType=entities_info;
                entity=true;
            }
    	return $http.post(url,{infoType:infoType})
            .then(function(res) {
                if(res.data && res.data.success == 1 && res.data.data && res.data.data.length>0) {
                    var searchableFields = res.data.data.filter(function(v) {
                        return (v.searchable == 1 || (v.searchable == 2 && $rootScope.app_data.isAdmin)) && [1,2,3,4,5,6,7,8,9,14,15,18,20].indexOf(parseInt(v.type))!==-1;
                    });
                    if(searchableFields.length>0) {
                        var search_init_fields = {};
                        if(angular.isDefined($scope.searchInitialData.fields)){
                            search_init_fields = angular.copy($scope.searchInitialData.fields);
                        }
                        $scope.searchInitialData.fields = searchableFields.reduce(function(p,c) {
                        	var searchFieldType = false;

                        	if([3,4,5,7,14].indexOf(parseInt(c.type))!==-1) 
                        		searchFieldType = 'dropdown';
                        	else if([1,2,6,8].indexOf(parseInt(c.type))!==-1)
                        		searchFieldType = 'inputBox1';
                            else if([9].indexOf(parseInt(c.type))!==-1)
                                searchFieldType = 'file';
                            else if([15].indexOf(parseInt(c.type))!==-1)
                                searchFieldType = 'time';
                            else if([18].indexOf(parseInt(c.type))!==-1)
                                searchFieldType = 'star_rating';
                            else if([20].indexOf(parseInt(c.type))!==-1)
                                searchFieldType = 'date_time';
                            var field = {
                                displayName: c.title,
                                actionString: "with "+c.title+":",
                                futherSearchParams: {
                                    placeholder: $filter("asPortalLang")("Select","Select")+" "+c.title,
                                    serviceNameField: "name",
                                    serviceIdField: "id"
                                },
                                custom_field_type:c.field_type,
                                countsRequired: false,
                                isprivateField:c.privateField?c.privateField:false,
                                singleSearch: (searchFieldType=='inputBox1')?true:false,
                                category_hidden:(c.field_type=='entity_field' && ($scope.options && $scope.options.split_entity_categories))?true:false,
                                dataPreProcessors: [function(dataTosend,value,index) {
                                    // console.log('dataPreProcessors', 'dataTosend:', dataTosend);
                                    // if(!value || value.length==0) return dataTosend;
                                    if(!dataTosend.form) dataTosend.form = {};
                                    if(!dataTosend.form.form_id) dataTosend.form.form_id = [];
                                    if(!dataTosend.form.fields) dataTosend.form.fields = {};
                                    if(dataTosend.form.form_id.indexOf(parseInt(c.form_id))==-1)
                                        dataTosend.form.form_id.push(parseInt(c.form_id));
                                    // dataTosend.form.fields['field_id_'+c.id] = angular.merge(dataTosend.form.fields['field_id_'+c.id]?dataTosend.form.fields['field_id_'+c.id]:[],value);
                                    dataTosend.form.fields['field_id_'+c.id] = value;
                                    if(isEmpty(dataTosend.form.fields['field_id_'+c.id]))
                                        delete dataTosend.form.fields['field_id_'+c.id];
                                    if(isEmpty(dataTosend.form.fields) && isEmpty(dataTosend.form.emptyResponse))
                                        delete dataTosend.form;
                                    
                                    if(searchFieldType==='inputBox1' && dataTosend.form) {
	                                    if(!dataTosend.form.fieldsparams) dataTosend.form.fieldsparams = {};
	                                    dataTosend.form.fieldsparams[c.id] = {};
                                    	dataTosend.form.fieldsparams[c.id].match_type = 'non-strict';
                                    }
                                    // delete dataTosend[index];
                                    return dataTosend;
                                }]
                            };
                            if(c.entity_info){
                                field['entity_info']=c.entity_info;
                                if($scope.options && $scope.options.split_entity_categories)
                                    field['extra_margin']=' margin-left-28 margin-tb-8 categories-animate'
                            }
                            if(parseInt(c.type)===7){
                                field.futherSearchType = 'dropdown';
                                field.hidden = false;
                                field.singleSearch = true;
                                field.futherSearchParams = {
                                        placeholder: "--"+$filter("asPortalLang")("Select","Select")+" "+$filter("asPortalLang")("Date","Dates")+"--",
                                        serviceNameField: "name",
                                        serviceIdField: "id",
                                        dropdownOrderbyField: "id",
                                        type: "from-to",
                                        dateSelected: {
                                            from: '',
                                            to: '', on: '',
                                            rev: false
                                        },
                                        dropdownList: [
                                            {
                                                id: 0,
                                                name: $filter("asPortalLang")("Between_Date","Between (Select Date)"),
                                                dateSelector: {
                                                    enabled: true,
                                                    type: "from-to"
                                                }
                                                // parent_filter:true
                                            }
                                        ]
                                    };
                            }
                            else if(searchFieldType==='dropdown') {
                            	field.futherSearchType = 'dropdown';
                                field.type = c.type;
                                field.futherSearchParams.dropdownList = c.data&&c.data.map(function(v,i) {
                                    return {id:v,name:v};
                                },{});
                            }
                            else if(searchFieldType==='inputBox1') {
                            	field.futherSearchType = 'inputBox1';
                                field.type = c.type;
                                field.futherSearchParams.placeholder= $filter('asPortalLang')('Search_By_Titles',"Search by [DATA:title]",{'title':c.title})+"...";
                                field.futherSearchParams.idSelected= -1;
                                field.futherSearchParams.textSelected= '';
                                field.futherSearchParams.smallInputBox = true;                                
                            }
                            else if(searchFieldType === 'file'){
                                field.futherSearchType = 'file';
                                field.type = c.type;
                            }
                            else if(searchFieldType === 'time'){
                                field.futherSearchType = 'time';
                                field.type = c.type;
                            }
                            else if(searchFieldType === 'star_rating'){
                                field.futherSearchType = 'star_rating';
                                field.type = c.type;
                            }
                            else if(searchFieldType === 'date_time'){
                                field.futherSearchType = 'date_time';
                                field.type = c.type;
                            }
                            if (searchFieldType && c.empty_searchable && [7].indexOf(parseInt(c.type))===-1) {
                            	field.vCheckboxes = {
                                	___empty___: {
                                		id: "___empty___",
                                		name: "is Empty",
                                		checked: false
                                	}
                                };
                            }
                            if(c.name) p[c.name] = field;
                            else p[c.title] = field;
                            if(c.field_type!='entity_field')
                                view_fields.push(c.name?c.name:c.title);
                            return p;
                        },{});
                        if(!angular.equals({},search_init_fields))
                            angular.merge($scope.searchInitialData.fields,search_init_fields);
                        if(entity || ($scope.options && ($scope.options.mergeFormFields || ($scope.options.view && $scope.options.view.name && $scope.options.view.name=='directory')))){
                            angular.forEach(searchableFields,function(value,key) {
                                var name = value.name?value.name:value.title;
                                $scope.formFieldsConfig[name] = 'field_id_'+value.id;
                            });
                        }
                        var role_related_fields = [];
                        var basic_related_fields = [];
                        var entity_fields=[];
                        if(entity){
                            if($scope.options && $scope.options.split_entity_categories){
                                angular.forEach(entities_info,function(ent){
                                    var fields_to_insert =[];
                                    fields_to_insert=get_custom_field_by_order(searchableFields,'entity_field',ent.entity_name);
                                    insert_custom_field(fields_to_insert,ent.entity_name); 
                                });
                            }
                            else{
                                entity_fields=get_custom_field_by_order(searchableFields,'entity_field');
                                insert_custom_field(entity_fields,'entity_field');
                            }                                      
                        }
                        else{
                            role_related_fields=get_custom_field_by_order(searchableFields,'role_info');
                            basic_related_fields=get_custom_field_by_order(searchableFields,'basic_info');
                            insert_custom_field(role_related_fields,'role_info_fields');
                            insert_custom_field(basic_related_fields,'basic_info_fields');
                        }
                    }
                }
            });
        }

        function insert_custom_field(customFieldOrder,custom_field_type){
           var found=false;
            angular.forEach($scope.searchInitialData.categories, function(category, category_index) {
                angular.forEach(category.fields, function(field, field_index) {
                    if (field === custom_field_type) {
                        found=true;
                        var insertionIndex = field_index + 1;
                        if (insertionIndex < category.fields.length) {
                            Array.prototype.splice.apply(category.fields, [insertionIndex, 0].concat(customFieldOrder));                                        
                        } else {
                            category.fields = category.fields.concat(customFieldOrder);
                        }
                        category.fields.splice(field_index, 1);
                        return false;
                    }
                   
                });
                if(found)
                    return false;
            });
            if(!found){
                if($scope.options && $scope.options.mergeFormFields && $scope.searchInitialData.categories && $scope.searchInitialData.categories[0] && $scope.searchInitialData.categories[0].fields){
                    $scope.searchInitialData.categories[0].fields = $scope.searchInitialData.categories[0].fields.concat(customFieldOrder);
                }
                else{
                    $scope.searchInitialData.categories.push({
                        fields: customFieldOrder,
                        displayName: 'More filters',
                        display: false
                    });
                }
            }
        }
        function get_custom_field_by_order(fields, field_type,entity_info) {
            var customOrder = {};
            angular.forEach(fields, function(field, index) {
                if (field.field_type == field_type) {
                    if(entity_info){
                        if(field.entity_info==entity_info){
                            var key=field.name?field.name:field.title;
                            customOrder[key] = {
                                order: field.order?field.order:0
                            };
                        }
                    }
                    else{
                        var key=field.name?field.name:field.title;
                        customOrder[key] = {
                            order: field.order?field.order:0
                        };
                    }
                }
            });
            var sortedKeys = Object.keys(customOrder).sort(function(a, b) {
                return customOrder[a].order - customOrder[b].order;
            });
            return sortedKeys;
        }

        function vResetAll() {
            if($scope.options && $scope.options.transferInfo)
                $scope.options.transferInfo.fetchingCnt = true;
            $scope.adminNotDeleted = false;
            change_stream = true;
            if(Object.keys($scope.info.expanded).length>0){
                var entity_category=Object.keys($scope.info.expanded);
                angular.forEach(entity_category,function(ent){
                    $scope.expand_category(ent);
                });
            }
            if(angular.isDefined($scope.num_deleted))
                $scope.num_deleted = 0;
            if(angular.isDefined($scope.num_edited)){
                $scope.num_edited = 0;
                $scope.searchLangData.profileUpdCount = 0;
            }
            if(angular.isDefined($scope.adminErrorMessage))
                $scope.adminErrorMessage = "";
            if(angular.isDefined($scope.num_selected)){
                $scope.num_selected = 0;
                $scope.searchLangData.profileSelCount = 0;
            }
            if(angular.isDefined($scope.allSelected))
                $scope.allSelected = 0;
            $scope.availabeFields = [];
            if($scope.options && $scope.options.view && $scope.options.view.availabeFields){
            angular.forEach($scope.options.view.availabeFields, function(val,key) {
                var field =angular.copy(val);
                var fieldKey =angular.copy(key);
                $scope.availabeFields[key]={};
                $scope.availabeFields[key].field=field;
                $scope.availabeFields[key].enabled=false;
                if(angular.isUndefined($scope.search_data.fields[field])) $scope.availabeFields[key].hidden = true;
                if(angular.isDefined(search_data.fields[field]) && angular.isDefined(search_data.fields[field].displayName)){
                        $scope.availabeFields[key].displayName=search_data.fields[field].viewTitle?search_data.fields[field].viewTitle:search_data.fields[field].displayName;
                }
            });
            }
            $scope.enableFields = [];
            if($scope.disabledFields && isArray($scope.disabledFields)){
                angular.forEach($scope.availabeFields,function(val,key){
                    if($scope.disabledFields.indexOf(val.field)==-1){
                       $scope.availabeFields[key].enabled=true;
                       $scope.enableFields.push(val.field);
                    }
                });
            }
            vSearchParams = {}; 
            $scope.searchInitialDataModal = null;
            if($scope.searchInitialData && $scope.searchInitialData.contextSearch) {
                if(angular.isArray($scope.searchInitialData['permanentDataParam']) && $scope.searchInitialData['dataParams']){
                    $scope.searchInitialData.dataParams = Object.keys($scope.searchInitialData.dataParams).reduce(function(result, key) {
                        if ($scope.searchInitialData['permanentDataParam'].indexOf(key) != -1) result[key] = $scope.searchInitialData.dataParams[key];
                        return result;
                    }, {});
                }
                initDataBind();
                return;
            }
            searchParamsToBox(vSearchParams);
            if($scope.searchInitialData.fp){
                vSearchParams=angular.copy($scope.searchInitialData.fp.filters);
            }
            postCheckboxAndParams(vSearchParams,true);
            angular.forEach($scope.search_data.categories, function(field_categories) {
                angular.forEach(field_categories.fields, function(this_field) {
                    if (angular.isDefined($scope.search_data.fields[this_field]) && angular.isDefined($scope.search_data.fields[this_field].futherSearchParams)) {
                        $scope.search_data.fields[this_field].futherSearchParams.textSelected = '';
                        $scope.search_data.fields[this_field].isShown = false;
                        $scope.search_data.fields[this_field].isFieldChecked = false;
                    }
                });
            });
        }

        function postCheckboxAndParams(searchParams,fetch_profile) {
            $scope.adminNotDeleted = false;
            change_stream = true;
            intialiseSearch();
            vFilterCount(searchParams);
            vIsEmptySearch(searchParams);
            if(!$scope.options.countOnly)
                vFetchProfiles(searchParams); //Usersearch api get calls while applying filters
            vStringBuilder(searchParams);
            // $state.go('inapp.vsearch',
            //     searchParams, {
            //         notify: false,
            //         location: 'replace'
            //     }); //updating new location based on new search params. URL would change based on this
        }

        function fetchTagData(field, fParams) {
            if(!($scope.searchInitialData && $scope.searchInitialData.dataParams && $scope.searchInitialData.dataParams.tags && $scope.searchInitialData.dataParams.tags[0])) {
                return;
            }
            var params = {
                tag_id: $scope.searchInitialData.dataParams.tags[0]
            };
            return $http.post('./tags/fetch',params).then(function (res) {
                if(res && res.data && res.data.success == 1 && res.data.data) {
                    $scope.search_data.fields[field].futherSearchParams.dropdownList = [{id: res.data.data.id,name:res.data.data.name}];
                }
            });
        }

        function makeYearDropdown(field, fParams, return_only) {
            var retYear = [];
            var now = new Date().getFullYear();
            var startYear = $rootScope.app_data.data.establish_year;
            try{
                if(field=="yoj" && $rootScope.app_data.config.meta[11])
                    startYear = $rootScope.app_data.config.meta[11];
                if(field=="yop" && $rootScope.app_data.config.meta[12])
                    startYear = $rootScope.app_data.config.meta[12];
            }
            catch(e){}
            for (var i = now + 5; i >= startYear; i--) {
                retYear.push({
                    id: i,
                    name: i
                });
            }
            if(!return_only)
                $scope.search_data.fields[field].futherSearchParams.dropdownList = retYear;
            return retYear;
        }

        function inputBoxKeyPressed($event, field, value) {
            var keyCode = $event.which || $event.keyCode;
            if (keyCode === 13) {
                inputBoxSelected(value,field);
            }
        }

        function makeDownloadFilterString(){
            var string = "";
            angular.forEach($scope.downloadFilterArray, function(value, key){
                if(key > 0 && value["key"] == $scope.downloadFilterArray[key-1]["key"])
                    string += " or " + value["value"];
                else{
                    if(key > 0)
                        string += ", ";
                    if(value.key == 'emptyResponse' || value.key == 'nonEmptyResponse') {
                        angular.forEach($scope.search_data.categories, function(category) {
                            if (category.form_id === value.id)
                                string += category["displayName"]+" : ";
                        });
                    }
                    else string += $scope.search_data['fields'][value["key"]]["displayName"]+" : ";
                    string += value["value"];
                }
            });
            return string;
        }

        function download(event) {
            if(angular.isDefined($scope.num_deleted))
                $scope.num_deleted = 0;
            if(angular.isDefined($scope.num_edited)){
                $scope.num_edited = 0;
                $scope.searchLangData.profileUpdCount = 0;
            }
            if(angular.isDefined($scope.adminErrorMessage))
                $scope.adminErrorMessage = "";
            var filterString = $scope.displayName;
            var _vSearchParams = Object.keys(vSearchParams).reduce(function(p,k) {
                if(['stream','other_params','rnd'].indexOf(k)!==-1)
                    return p;
                if(k == 'emptyResponse' || k == 'nonEmptyResponse') {
                    angular.forEach(p[k] , function(formId) {
                        var category = $scope.search_data.categories.find(function (cat) {
                            return cat.form_id == formId;
                        });
                        if(category.dataPreProcessors && category.dataPreProcessors.constructor==Array && category.dataPreProcessors.length>0) {
                            for (var i = 0; i < category.dataPreProcessors.length; i++) {
                                vSearchParams = category.dataPreProcessors[i](vSearchParams,k,category);
                            }
                        }
                    });
                }
                if($scope.search_data.fields[k]) {
                    var v = $scope.search_data.fields[k];
                    if(v.dataPreProcessors && v.dataPreProcessors.constructor==Array && v.dataPreProcessors.length>0) {
                        for (var i = 0; i < v.dataPreProcessors.length; i++) {
                            vSearchParams = v.dataPreProcessors[i](vSearchParams,vSearchParams[k],k,v);
                        }
                    }
                }
                return p;
            },vSearchParams);
            if($rootScope.app_data.admin_r_subinsti && subinst_array.length!=0){
                if(subinst_array.length!=$rootScope.app_data.admin_r_subinsti.length){
                    _vSearchParams['subinst'] = subinst_array;
                }
            }
            var search = xwwwfurlenc(_vSearchParams);
            var download_options = {"onReset":$scope.close};
            if(search=='') search = "?other_params[fetch_lost]=true";
            else search = '?'+search+"&other_params[fetch_lost]=true";
            if($scope.options && $scope.options.view && $scope.options.view.name){
                search = search+"&other_params[viewName]="+$scope.options.view.name;
            }
            if($scope.options && $scope.options.poll_id){
                search = search+"&other_params[poll_id]="+$scope.options.poll_id;
            }
            if($scope.options && $scope.options.polltable){
                search = search+"&other_params[polltable]="+$scope.options.polltable;
            }
            if($scope.options && $scope.options.include_demised)
                search = search+"&other_params[include_demised]="+$scope.options.include_demised;
            if($scope.options && $scope.options.view && $scope.options.view.name=='votes_display' && $scope.options.poll_id && $scope.options.polltable)
                download_options['skipPass']=true;
            if($scope.options && $scope.options.keyword_filter){
                search = search+"&other_params[keyword_filter]="+$scope.options.keyword_filter;
            }
            //Code to download specific users only if selected in frontend
            if(angular.isDefined($scope.num_selected) && $scope.num_selected>0 && angular.isDefined($scope.allSelected) && !$scope.allSelected ){
                var selectedUuis=[];
                angular.forEach($scope.resultProfiles, function(v,k) {
                  if(v.enable){
                    selectedUuis.push(v.uui);
                  }
                });
                if(selectedUuis.length>0){
                    var uuiToDownload=selectedUuis.toString();
                    search=search+"&uui_to_download="+uuiToDownload;
                }
            }
            //End-Code to download specific users only if selected in frontend

            if($rootScope.featureEnabled('experiments.isExcel.*')) {  
                download_options["isExcel"] = true;
                search += "&other_params[isExcel]=" + true;
            }

            var downloadFilterString = makeDownloadFilterString();
            if($rootScope.app_data.admin_r_subinsti && subinst_array.length!=$rootScope.app_data.admin_r_subinsti.length){
                var data = {editable_fields: $scope.editable_fields, total_profiles: $scope.resultCount[0].count};
                data.cbInsti = $scope.filterDropdownOnChange;
                if($scope.resultCountForSubInst)
                    data.num_profiles = $scope.resultCountForSubInst;
                ModalService.showModal({
                    templateUrl : './templates/directives/search/searchDownloadModal.html',
                    controller: ['data','$scope', 'close','$http',function(data,$scope, close,$http) {
                                as_upgrade(100);
                                var cbInsti = data.cbInsti;
                                if(data.num_profiles)
                                    $scope.num_profiles = data.num_profiles;
                                else
                                    $scope.num_profiles = data.total_profiles;
                                $scope.total_profiles = data.total_profiles;
                                $scope.totalProfiles = {'totalProfiles': $scope.total_profiles};
                                $scope.numProfiles = {'numProfiles': $scope.num_profiles};
                                $scope.close = function($event) {
                                    close($event);
                                    if(angular.isDefined(document.querySelector("#show_mem")) && document.querySelector("#show_mem").checked){
                                        cbInsti(subinst_array,'subinst');
                                    }
                                }
                                $scope.proceedDownload = function($event) {
                                    if($scope.options && $scope.options.view && $scope.options.view.name=="directory"){
                                        registerAnalytics('search','download_clicked',downloadFilterString);
                                    }
                                    $scope.close($event);
                                     search = search +'&search_string=' + encodeURIComponent(downloadFilterString.replace(/[^\w & : ,]/g,' ').replace(/ +/g,' '));
                                    var downloadURL = 'search/download_new/' + search;
                                    downloadDatabase.withConfirmation(downloadURL,download_options);
                                }
                    }],
                    inputs: {
                        data: data,
                    },
                    target: document.body
                }).then(function(modal) {
                    // modal.close.then(function() {
                    //     console.log($scope);
                    // });
                });
            }
            else{
                if($scope.options && $scope.options.view && $scope.options.view.name=="directory"){
                    registerAnalytics('search','download_clicked',downloadFilterString);
                }
                search = search +'&search_string=' + encodeURIComponent(downloadFilterString.replace(/[^\w & : ,]/g,' ').replace(/ +/g,' '));
                var downloadURL = 'search/download_new/' + search;
                downloadDatabase.withConfirmation(downloadURL,download_options);
            }
         }

        function getDates(timeline) {
            var date = new Date();
            var return_obj = {
                to_date: $filter('date')(new Date().setDate(new Date().getDate() + 1), "dd-MM-yyyy")
            };
            if(angular.isDefined(timeline)){
                if(timeline=='week')
                    return_obj.from_date = $filter('date')(new Date().setDate(new Date().getDate() - 7), "dd-MM-yyyy");
                else if(timeline=='month')
                    return_obj.from_date = $filter('date')(new Date().setDate(new Date().getDate() - 30), "dd-MM-yyyy");
                else if(timeline=='half_year')
                    return_obj.from_date = $filter('date')(new Date().setDate(new Date().getDate() - 182), "dd-MM-yyyy");
                else if(timeline=='year')
                    return_obj.from_date = $filter('date')(new Date().setDate(new Date().getDate() - 365), "dd-MM-yyyy");
                else
                    return {};
                return return_obj;
            }
            else
                return {};
        }

        function getDateMonth(timeline) {
            var date = new Date();
            var return_obj = {};
            if(angular.isDefined(timeline)){
                var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
                var month_selected = months.indexOf(timeline);
                if(month_selected>-1){
                    return_obj.month = $filter('date')(new Date(0).setMonth(month_selected), "MM");
                    return_obj.monthName = $filter('date')(new Date(0).setMonth(month_selected), "MMMM");
                }
                else if(timeline=='today'){
                    return_obj.date = $filter('date')(new Date().setDate(new Date().getDate()), "dd");
                    return_obj.month = $filter('date')(new Date().setDate(new Date().getDate()), "MM");
                    return_obj.monthName = $filter('date')(new Date().setDate(new Date().getDate()), "MMMM");
                }
                else if(timeline=='tomorrow'){
                    return_obj.date = $filter('date')(new Date().setDate(new Date().getDate()+1), "dd");
                    return_obj.month = $filter('date')(new Date().setDate(new Date().getDate()+1), "MM");
                    return_obj.monthName = $filter('date')(new Date().setDate(new Date().getDate()+1), "MMMM");
                }
                else
                    return {};
                return return_obj;
            }
            else
                return {};
        }

        function negativeFunc(fn) {
            return function() {
                return !fn.apply(null,arguments);
            }
        }

        function isAdmin() {
            if($scope.options && $scope.options.enableViewMode && angular.isDefined($scope.current_view_mode)){
                return $scope.current_view_mode == 'admin';
            }
            else{
                  return $rootScope.app_data.isAdmin;
            }
        }

        function showMoreToggle(value) {
            $timeout(function() {
                $scope.search_data.more_filters = value;
            },100);
            return false;
        }

        function allow_email(user){
            user['emailInput'] = true;
            as_upgrade(50);
        }

        function inviteVia(type,ev,user) {
          console.log('inviteVia', 'type:', type, 'ev:', ev, 'user:', user);
            // var params1 = $location.search();
            var params1 = {name:user.name};
            var index = 0;
            var params_str='';
            var params_str_2='';
            // angular.forEach(params1,function(value,key){
            //     if(key !== 'source'){
            //         params_str += (index?',':'|')+key+':'+value;
            //         params_str_2 += (index?'&':'?')+key+'='+value;
            //         index += 1;
            //     }
            // });
            $scope.facebookUrl = window.COMM_APPBASE + 'invite/2/' + $rootScope.app_data.cid + "/" + $rootScope.app_data.uid;
            $scope.facebookUrl += "/search" + params_str_2;
            if(type=="email"){
                invitation.byEmail(ev,{'reason':'search'+params_str});
            }
            if(type=="whatsapp") {
                invitation.byWhatsapp(ev,{'reason':'search'+params_str_2,'name':user.basic_info.name});
            }
            if(type=="facebook") {
                invitation.byFacebook(ev,{'reason':'search'+params_str_2,'name':user.basic_info.name});
            }
            if(type=="email_input") {
                console.log(user);
                user.invitationSending = true;
                var params = {
                    lost: user.basic_info.uid
                };
                var name = user.basic_info.name;

                invitation.byEmailInput(name,user.email,params,function(res) {
                    user.invitationSending = false;
                    if(res.success == 1) {
                        user.basic_info.is_lost_user = 0;
                        user.invited = true;
                        user.emailInput = false;
                        snackbar_general($filter("asPortalLang")("Invite_Success","[DATA:name] has been invited.",{name:user.basic_info.name}),2000);
                    }
                    if(res.message) {
                        snackbar_general(res.message,2000);
                    }
                });
            }
        }

        function claim_profile(profile) {
            claimProfile.bySignup(profile.uui,profile.basic_info.name);
        }

        function claim_profile2(profile) {
            claimProfile.claimProfile(profile.uui);
        }

        function mail() {
            if($scope.num_selected && !$scope.allSelected) return;
        	var count,queryString;
        	if($scope.isEmpty) {
        		count = $scope.totalCount.count; 
                queryString = "All Users";
        	}
        	else if($scope.queryString!=null) {
        		count = $scope.resultCount[0].count;
                if($scope.displayName.length>0) queryString = "Users "+$scope.displayName;
        		else queryString = count+" user"+(count>1?"s":"");
        	}
        	else return;

            if($scope.options && $scope.options.view && $scope.options.view.name=="directory"){
                registerAnalytics('search', 'send_mail_clicked', queryString);
            }
            console.log("mail",queryString);
			var mailing_list = {type:1,count:count};
			mailing_list.paramsArray = $scope.dataTosend4Mail;
			mailing_list.query_string = queryString;
			adminMailClone.clone({content:'',mailing_list:[mailing_list],myRecepients:'2'});
		}
        function makeChapterAndGroupDropdown(field, fParams) {
            return sidetopHttp.postDataCall(fParams.serviceLink,fParams.paramsToSend,getDropdownSuccess);
            
            function getDropdownSuccess(response){
                var fData = [];
                if(response.success == 1) {
                    angular.forEach(response.data.childs, function(value, key) {
                        if(field==="groups"){
                            fData.push({
                                id: value.id,
                                name: value.name
                            });
                        }
                        else if(field==="chapters"){
                            angular.forEach(value.childs,function(value2,key2){
                                fData.push({
                                    id: value2.id,
                                    name: value2.name
                                });
                            });
                        }
                    });
                }
                $scope.search_data.fields[field].futherSearchParams.dropdownList = fData;
                $scope.search_data.fields[field].localautocomplete.data.dataSource.data = fData;

                return fData;
            }
        }
        function professionalNetworkSelected(data){
            vAddcheckbox(data,'professional_networks');
        }

        function chapterSelected(data) {
            filterDropdownOnChange(data,'chapters');
        }

        function groupSelected(data) {
            filterDropdownOnChange(data,'groups');
        }

        function importIdSelected(data) {
            filterDropdownOnChange(data,'import_id');
        }

        function membershipIdSelected(data) {
            filterDropdownOnChange(data,'membership_id');
        }

        function yojSelected(data) {
            filterDropdownOnChange(data,'yoj');
        }

        function yopSelected(data) {
            filterDropdownOnChange(data,'yop');
        }

        function degreeSelected(data) {
            filterDropdownOnChange(data,'degree');
        }

        function departmentSelected(data) {
            filterDropdownOnChange(data,'department');
        }

        function specializationSelected(data) {
            filterDropdownOnChange(data,'specialization');
        }

        function instituteSelected(data) {
            filterDropdownOnChange(data,'institute');
        }

        function sectorSelected(data) {
            filterDropdownOnChange(data,'degree');
        }

        function subinstSelected(data) {
            filterDropdownOnChange(data,'subinst');
        }

        function showRestrictionModal(){
            contentApprovalAccessMsg.showModel();
        }

        $scope.generateUniqueName = function(filter_name,names_array,ids_array) {
            if(!names_array || !ids_array) return '';

            var uniqueNames = [];
            var checkedIds = [];
            var filteredIds = $scope.dataTosend4Mail[filter_name]; 
            for (var i = 0; i < ids_array.length; i++) {
                var currentName = names_array[i];
                var currentId = ids_array[i];
                if (!currentName || checkedIds.includes(currentId)) {
                    continue;                       
                } 
                if (filteredIds && isArray(filteredIds) && filteredIds.indexOf(currentId)!=-1) {
                    uniqueNames.unshift(currentName);
                } else {
                    uniqueNames.push(currentName);
                }
                checkedIds.push(currentId);
            }
            return uniqueNames.join(', ');
        };

        function requestForAccess() {
            contentApprovalAccessMsg.contentApprovalMessageToAdmin('Request_for_access'+$rootScope.app_data.logged_user_roles[0].uui,(window.event && window.event.target)||window.document.body);
        }
        
        function getMembershipList(field,fParams){
            membershipService.get_memberships([],callback,fParams.paramsToSend);
            function callback(data){
                var memebrship_data = [];
                var all_ids = {};
                all_ids.id = [];
                angular.forEach(data.data, function(value, key) {
                    if(value.id){
                        memebrship_data.push({id: value.id, name: value.membership_name});
                        all_ids.id.push(value.id)
                    }
                });

                $scope.search_data.fields[field].futherSearchParams.dropdownList = memebrship_data;
                $scope.search_data.fields[field].localautocomplete.data.dataSource.data = memebrship_data;
                // return data;
            }
        }
        function memebrship_datapreprocess(dataTosend,array_of_data,fieldname,d,noChanges){
            // console.log(c,d,"c+d");
            var paramas=[];
            if(noChanges && noChanges == true){
                return dataTosend;
            }
            if(!dataTosend.membership){
                dataTosend.membership={};
            }
            //membership_status  membership_status
            if(array_of_data && array_of_data.length>0 && fieldname == 'membership_payment_mode'){
                    angular.forEach(array_of_data, function(value, key) {
                        var con = [];
                        if(value == 1){
                            con = [10,30];
                        }else if(value == 2){
                            con = [20];
                        }
                        paramas = paramas.concat(con);
                    });
                
            }else if(dataTosend.membership.order && fieldname == 'membership_payment_mode'){
                delete dataTosend.membership.order;
            }else if (dataTosend.membership.membership_number && fieldname == 'membership_number'){
                delete dataTosend.membership.membership_number;
            }else if (dataTosend.membership.membership_id && fieldname == 'membership_id'){
                delete dataTosend.membership.membership_id;
            }else if (dataTosend.membership.membership_status && fieldname == 'membership_status'){
                delete dataTosend.membership.membership_status;
            }
            if(dataTosend.membership && dataTosend.membership.order && dataTosend.membership.order.product_type){
                console.log("delted");
                delete dataTosend.membership.order.product_type;
            }
            // delete dataTosend[c];
            if (fieldname == 'membership_payment_mode' && paramas.length > 0){
                dataTosend.membership = {
                    'order' :{
                        'product_type' : 5,
                        'status' : paramas
                    }
                };
            }else if(fieldname == 'membership_number' && array_of_data && array_of_data.length>0){
                dataTosend.membership.membership_number = array_of_data[0];
            }else if(fieldname == 'membership_id' && array_of_data && array_of_data.length>0){
                dataTosend.membership.membership_id = array_of_data;
            }else if(fieldname == 'membership_status' && array_of_data && array_of_data.length>0){
                dataTosend.membership.membership_status = array_of_data;
            }
            if(dataTosend.membership && (!dataTosend.membership.order || !dataTosend.membership.order.product_type) && dataTosend.membership.membership_id ){
                dataTosend.membership.order=['true'];
            }
            return dataTosend;
        }

        $scope.funcParams = {};

        $scope.onDateClose = function(field,source){
            return function(){
                $scope.openDatePickerCallback(field,source);
            }
        }

        function fieldSort(field_name){
            if(!vSearchParams.ordering){
                vSearchParams.ordering = {};
            }


            //Added to restrict ordering to only one field at a time
            angular.forEach(vSearchParams.ordering,function(val,key){
                if(key!=field_name){
                    delete vSearchParams.ordering[key];
                    $scope.membershipFields[key] = 0;
                }
            });


            if(vSearchParams.ordering.hasOwnProperty(field_name)){
                if(vSearchParams.ordering[field_name]['sort'] === 'asc'){
                    vSearchParams.ordering[field_name]['sort'] = 'desc';
                    $scope.membershipFields[field_name] = -1;
                }
                else if(vSearchParams.ordering[field_name]['sort'] === 'desc'){
                    delete vSearchParams.ordering[field_name];
                    $scope.membershipFields[field_name] = 0;
                }
            }
            else{
                vSearchParams.ordering[field_name] = {};
                vSearchParams.ordering[field_name]['sort'] = 'asc';
                vSearchParams.ordering[field_name]['priority'] = $scope.sortPriority;
                // vSearchParams.ordering[field_name] = {'sort':'asc','priority':$scope.sortPriority};
                $scope.membershipFields[field_name] = 1;
                $scope.sortPriority++;
            }
            intialiseSearch();
            vFetchProfiles();
        }

        $scope.refreshProfiles = function() {
            postCheckboxAndParams(vSearchParams);
        }

        $scope.toggleFilters = function(field) {
            $scope.adminNotDeleted = false;
            change_stream = true;
            if(angular.isDefined($scope.num_deleted))
                $scope.num_deleted = 0;
            if(angular.isDefined($scope.num_edited)){
                $scope.num_edited = 0;
                $scope.searchLangData.profileUpdCount = 0;
            }
            if(angular.isDefined($scope.adminErrorMessage))
                $scope.adminErrorMessage = "";
            $scope.search_data.fields[field].isShown = !$scope.search_data.fields[field].isShown; 
            if(angular.isDefined($scope.search_data.fields[field].isFieldChecked))
                $scope.search_data.fields[field].isFieldChecked = !$scope.search_data.fields[field].isFieldChecked;
            else
                $scope.search_data.fields[field].isFieldChecked = true;
            if(vSearchParams[field] && ((!angular.equals({},vSearchParams[field]) && !angular.isDefined(vSearchParams[field].length)) || (vSearchParams[field].length && vSearchParams[field].length!=0))){
                delete vSearchParams[field];
                if($scope.isFormField(field)){
                    if(vSearchParams && vSearchParams.form && vSearchParams.form.fields && vSearchParams.form.fields[$scope.formFieldsConfig[field]])
                        delete vSearchParams.form.fields[$scope.formFieldsConfig[field]];
                    if(angular.equals({},vSearchParams.form.fields))
                        delete vSearchParams.form;
                }
                if($scope.options && $scope.options.transferInfo)
                    $scope.options.transferInfo.fetchingCnt = true;
                $scope.availabeFields = $scope.availabeFields.filter(function(value,index) {
                    if($scope.options.view.availabeFields.indexOf(field)<0)
                        return value.field!=field;
                    else
                        return value.field;
                });
                if($scope.enableFields.indexOf(field)!=-1 && ((angular.isDefined($scope.options.view.default_fields) && $scope.options.view.default_fields.indexOf(field) < 0)
                    || !angular.isDefined($scope.options.view.default_fields)))
                    $scope.enableFields.splice($scope.enableFields.indexOf(field),1);
                searchParamsToBox(vSearchParams);
                postCheckboxAndParams(vSearchParams);
                if(angular.isDefined($scope.num_selected)){
                    $scope.num_selected = 0;
                    $scope.searchLangData.profileSelCount = 0;
                }
                if(angular.isDefined($scope.allSelected))
                    $scope.allSelected = 0;
            }

         
              loadCheckBoxData(field,vSearchParams);

        }


        function loadCheckBoxData(field,vSearchParams){

        if(! $scope.search_data["fields"][field].checkBoxRequired ) return;

           var reqCheckBox=[];

           reqCheckBox = $scope.search_data.categories.reduce(function(p, c) {
                    p=p.concat(c.fields);
                    return p;
                }, []);
          

           if(reqCheckBox.indexOf(field)>-1 && angular.isDefined($scope.search_data["fields"][field]) &&  (!angular.isDefined($scope.search_data["fields"][field].vCheckboxes) || Object.keys($scope.search_data["fields"][field].vCheckboxes).length===0 )  ){


            var dataToSend={
                requiredCheckboxes:[field],
                params:{},
                other_params:{
                    fetch_lost:false
                }
            };

            if ($scope.search_data.fetchLost || $scope.current_view_mode=='admin') {
                if(($scope.search_data.fetchLost==1 || $scope.search_data.fetchLost==true) || ($scope.search_data.fetchLost==2 && !vIsEmptySearch(vSearchParams)) || $scope.current_view_mode=='admin') {
                    dataToSend.other_params.fetch_lost = true;
                }
            }
            if($scope.search_data.roles){
                dataTosend.other_params.roles = $scope.search_data.roles;
            }

            if ($scope.search_data.authenticated_only && $scope.current_view_mode == 'user') dataToSend.params['authenticated_only'] = true;
            if ($scope.search_data.lg && $scope.current_view_mode == 'user') dataToSend.params['lg'] = true;
            if($scope.search_data.lost) dataToSend.params['lost'] = true;

               $scope.search_data["fields"][field].fetchingCheckbox=true;
               $http.post('./search/checkBoxData', dataToSend).then(function(res) {
                    if(res && res.data && res.data.success && res.data.success==1){

                        if (angular.isDefined($scope.search_data["fields"][field]) && angular.isDefined(res.data.data[field])) {
                            angular.forEach(res.data.data[field], function(value, key) {
                                res.data.data[field][key]['checked']=false;
                            });


                            if(angular.isDefined($scope.search_data["fields"][field].vCheckboxes)){
                                angular.forEach(res.data.data[field], function(value, key) {
                                   if(!angular.isDefined($scope.search_data["fields"][field].vCheckboxes[key]))
                                       $scope.search_data["fields"][field].vCheckboxes[key]=value;
                                });
                            }
                            else{
                                $scope.search_data["fields"][field].vCheckboxes=res.data.data[field];
                            }

                        }
                        as_upgrade(100);
                    }
                   $scope.search_data["fields"][field].fetchingCheckbox=false;
               });  

           }

        }

        function updateLocation(){
            profileFilling.modal(
                'location',
                function() {
                    $scope.locationUpdated = true;
                },
                function() {},
                {
                    'title': $filter("asPortalLang")("Update_Prof_Heading","Update your profile and help people connect with you better"),
                    'alwaysOpenModel': true
                }
            );
        }

        function openLostUserModal(user,index,event){
            $scope.close(event);
            if(isEmpty(user.uid)){
                return;
            }
            var params = {};
            var name = "";
            if(!isEmpty(user.basic_info.name))
                name = user.basic_info.name;
            $scope.resultProfiles[index]["lostModalLoading"] = true;
            lostUserService.openModal(user.uid,name,params,callback);
            function callback(data){
                $scope.resultProfiles[index]["lostModalLoading"] = false;
            }
        }

        function miniProfile(uid){
            if (chk_restrictions(10)) return false;
            if(isEmpty(uid))
                return;
            miniProfileService.invoke(uid);
        }

        function goToDirectory(){
            if(platform){
                $state.go("inapp.search",{searchparams:JSON.stringify(vSearchParams)});
            }
            else{
                var url = $state.href("inapp.search",{searchparams:JSON.stringify(vSearchParams)},{absolute:true});
                window.open(url,'_blank');
            }
        }

        function openMap(){
            if(platform){
                $state.go("inapp.map",{searchparams:JSON.stringify(vSearchParams)});
            }
            else{
                var url = $state.href("inapp.map",{searchparams:JSON.stringify(vSearchParams)},{absolute:true});
                window.open(url,'_blank');
            }
        }

        $scope.goToTop = function(id){
            var topDiv = document.getElementById(id);
            topDiv.scrollIntoView();
        }

        $scope.removeDateFilter = function(field,option,ev){
            var ele = ev.target.previousElementSibling.previousElementSibling.previousElementSibling;
            ele.value = '';
            if (option=='from') {
                $scope.search_data.fields[field].futherSearchParams.dateSelected.from = '';
                as_upgrade(200);
            }
            if (option=='to') {
                $scope.search_data.fields[field].futherSearchParams.dateSelected.to = '';
                as_upgrade(200);
            }
            if (option=='on') {
                $scope.search_data.fields[field].futherSearchParams.dateSelected.on = '';
                as_upgrade(200);
            }
            $scope.setDateInSearchParams(field,null,true);
        }

        $scope.openDatePickerCallback = function(field,source) {
            if($scope.search_data.fields[field].futherSearchParams.dateSelected.on!='' && source && source=='on')
                $scope.setDateInSearchParams(field,null,null,source);
            if($scope.search_data.fields[field].futherSearchParams.dateSelected.from!='' && $scope.search_data.fields[field].futherSearchParams.dateSelected.to!='' && source && source=='from-to'){
                if($scope.search_data.fields[field].futherSearchParams.dateSelected.from<=$scope.search_data.fields[field].futherSearchParams.dateSelected.to){
                    $scope.setDateInSearchParams(field,null,null,source);
                    $scope.search_data.fields[field].futherSearchParams.showDateError = false;
                }
                else
                    $scope.search_data.fields[field].futherSearchParams.showDateError = true;
                as_upgrade(10);
            }
        }

        $scope.showDatetimePicker = function(field,index,option,source,child_index){
            var path = '';
            if(source=='radio')
                path = $scope.search_data.fields[field].futherSearchParams.radioList[index].dateSelector;
            if(source=='dropdown' && child_index && $scope.search_data.fields[field].futherSearchParams.radioList[index].dropdownSelector && $scope.search_data.fields[field].futherSearchParams.radioList[index].dropdownSelector.dropdownList)
                path = $scope.search_data.fields[field].futherSearchParams.radioList[index].dropdownSelector.dropdownList[child_index].dateSelector;
            else if(source=='dropdown')
                path = $scope.search_data.fields[field].futherSearchParams.dropdownList[index].dateSelector;
            if(path){
                if(option=='from')
                    path.showFromDate = true;
                if(option=='to')
                    path.showToDate = true;
                if(option=='on')
                    path.showOnDate = true;
            }
            as_upgrade(50);
        }

        $scope.returnLangData = function(profile) {
            var name = '';
            var numRoles = 0;
            if(profile && profile.basic_info && profile.basic_info.name)
                name = profile.basic_info.name;
            if(profile && profile.other_roles_cnt)
                numRoles = profile.other_roles_cnt;
            return {name: name, numRoles: numRoles};
        };
        $scope.getCountAndDisplayName = function(totalCount){
           if(totalCount && totalCount.count){

            return {'count':totalCount.count,'displayName':$scope.displayName};
           }
           return {'count':'','displayName':$scope.displayName};
        }
        $scope.getCountLengthAndName = function(totalCount,resultProfiles){
            if(totalCount && resultProfiles && totalCount.count-resultProfiles.length){
             return {'count':totalCount.count-resultProfiles.length,'shortName':$rootScope.app_data.data.short_name};
            }
            return {'count':'','shortName':$rootScope.app_data.data.short_name};
        }
        $scope.getMailSubsLangData = function(resultCount,filters,info) {
            return {
                'count' : resultCount[0].count ?
                    '<span class="mdl-color-text--black mdl-typography--font-medium"><span>' + resultCount[0].count + '</span></span>' :
                    '',
                'filter' : (filters && filters.value) ?
                    '<span class="mdl-color-text--black mdl-typography--font-medium">' + filters.value + '</span>' :
                    '',
                'feedback' : (info && info.feedbackConfig[filters.id]) ? 
                    '<span class="mdl-color-text--black mdl-typography--font-medium">' + info.feedbackConfig[filters.id] + '</span></span>' : 
                    '',
                'spanTagStart' : '<span class="mdl-color-text--black mdl-typography--font-medium">',
                'spanTagEnd' : '</span></span>'
            }
        }
        $scope.showMoreBirthDays = function(type){
            var d, params;
            if(type=='recent'){
                params = {
                    dob: {
                        from: $filter('date')(new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000), 'dd-MM-yyyy'),
                        to: $filter('date')(new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000), 'dd-MM-yyyy'),
                        source: 'birthday'
                    }
                };
            }
            else if(type=='upcoming'){
                params = {
                    dob: {
                        from: $filter('date')(new Date(new Date().getTime() + 1 * 24 * 60 * 60 * 1000), 'dd-MM-yyyy'),
                        to: $filter('date')(new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000), 'dd-MM-yyyy'),
                        source: 'birthday'
                    }
                };
            }
            d = {searchparams:JSON.stringify(params)};
            setTimeout(function() {
                $state.go('inapp.search', d);
            },100);
        }
        
    }

    search_filter_modal_ctrl.$inject = ["$scope","$rootScope","$http","$q","$filter","$window","asMessages","$timeout","close","suggestions","searchInitialData","options"];
    function search_filter_modal_ctrl($scope, $rootScope, $http, $q, $filter, $window, asMessages, $timeout, close, suggestions,searchInitialData,options) {
        $scope.startSearchNow = {};
        $scope.applyFilter = applyFilter;
        $scope.cancel = cancel;
        // searchInitialData.dataParams
        $scope.searchInitialData = searchInitialData;
        console.log("searchInitialData : ",$scope.searchInitialData);
        $scope.options = options || {};
        $scope.dataParams = searchInitialData.dataParams || [];

        // TEMP CODE
        if($rootScope.app_data.cid==146) {
            $scope.options.setFormFields = 1;
        }

        $scope.reportingFun = {
            filterCountSuccess : function(report){
                console.log('filterCountSuccess',report);
                $scope.dataParams = angular.copy(report.dataTosend);
                delete $scope.dataParams.other_params;
            },
            fetchingProfiles: function() {
                snackbar_general('Refreshing List');
            }
        };

        $timeout(function(){
            try{
                $scope.startSearchNow.start();
            }catch(e){}
        },1000);

        function applyFilter() {
            close(window.event,$scope.dataParams);
        }

        function cancel() {
            close(window.event,false);
        }

    }



})();
